import { put, takeLatest, all, select, call, fork, cancelled } from 'redux-saga/effects';
import * as selectors from '../containers/selectors';
import { CancelToken } from 'axios';
import * as SiteAnalytics from '../sitecatalyst';
import { LPSavedCartOfferEngagement, LPErrorEngagement, isNTEenvs } from '../utils/common';
import { v4 as uuidv4 } from 'uuid';
import map from "lodash/map";
import { findIndex } from "lodash";
import LQAds from "./lqAds";
import includes from 'lodash/includes';

// bundle conversion sagas...
import {
  bundleCoversionActionWatcher, getFloatingCartDetails,
  getCartInfo, processFloatingCartDetails,
  getSelectedBundleInfo, getCustomizeBDVFiosBundleInfo, getCustomizeHSIPhoneBundleInfo, getFlexSelection
} from '../containers/bundleConversionSaga';
import { getBDVEquipments, BUNDLE, FLOW } from '../containers/bundleConversionUtils';
import { floatingCartActionWatcher } from '../Common/FloatingCart/containers/saga';
import { dynamicCartActionWatcher } from '../Common/FloatingCart/containers/dynamicCartSaga';
import { switchContractActionWatcher } from '../Pages/CustomizeOrder/ContractAgreement/containers/saga';
import * as SiteCatalyst from '../sitecatalyst';
import { formatDueDateresp, isNoSsnChecked } from '../containers/checkoutUtils';
import { getBannerInternetSelectedPlan, getapplicableBundle, getBDVValues, getBannerTVSelectedPlan } from '../containers/bannerUtil';
import { delay } from 'redux-saga';
import { dispatchEvent } from '../sitecatalyst/index';
import {
  GET_APIGEE_TOKEN_URL, GET_ZIPCODE_URL,
  GET_STREET_ADDRESS_URL,
  GET_ATOM_STREET_ADDRESS_URL, 
  GET_UNITS_URL,
  IS_FIOS_QUALIFIED_ZIP_URL,
  DO_LOOP_QUALIFICATION_URL,
  GET_AB_LOGIC,
  GET_GBCOMCREADLE_DETAILS_URL,
  CHECK_VZW_URL,
  POST_LQ_URL,
  WINBACK_QUALIFICATION_URL,
  YPH_URL,
  SAVE_CART_INFO_URL,
  RETRIEVE_SAVE_CART_INFO_URL,
  GET_SABDV_URL,
  RESERVE_DUE_DATE_URL,
  OMNI_RESERVE_DUE_DATE_URL,
  SUBMIT_ORDER_URL,
  GET_PREFERRED_VOICE_URL,
  NEXTBUTTON_URL,
  GET_BDV_TNS_URL,
  AUTOPAYLOG_URL,
  CHECKOUT_URL,
  GET_CONFIRAMTION_ORDER_INFO_URL,
  ADD_TECHTEAM_USER_URL,
  BUSINESS_INFO_VALIDATION_URL,
  CREDIT_CHECK_URL,
  INSTALLATION_VALIDATION_URL,
  SAVE_ORDER_URL,
  GET_FIOS_INTERNET_DATA_URL,
  GET_BASIC_INTERNET_DATA_URL,
  SAVE_ORDER_CONFIRMATION_URL,
  SAVE_COVID_QUESTION_URL,
  GENERATE_SELFINSTALL_URL,
  GET_CHECKOUT_CART_INFO_URL,
  LBO_PAGE_REDIRECTION_URL,
  CHECKOUT_DETAILS_URL,
  LBO_PAGE_API_URL,
  GET_CHAT_INFO_URL,
  GET_DUEDATE_URL,
  GET_YAHOO_CATEGORIES_DATA_URL,
  YAHOO_DUPE_CHECK,
  OPTIX_QUOTE_BY_ADDRESS_URL,
  OMNI_BUSINESS_INFO_VALIDATION_URL,
  OMNI_CREDIT_CHECK_URL,
  OMNI_GET_DUEDATE_URL,
  GET_CUSTOMIZE_PRODUCTS_URL,
  GET_SELECTED_PRODUCTS,
  OPTIX_QUOTE_BY_ID, OMNI_SAVE_SUBMITORDER_INFO,
  OMNI_OLO_DETAILS,
  GET_STANDARD_PHONE_URL,
  IS_PENDING_ORDER_URL,
  UPDATE_LOA_URL,
  OMNI_LOA_CONFIRMATION,
  POST_UI_EVENT_LOGGING,
  JOINT_OFFER_AVAILABILITY,
  GET_VZW_OFFER_ELIGIBILITY,
  LQ_ADS,
  SAVE_CONVERSATION,
  CHECK_WIRELESS_ELIGIBILTY_URL,
  SUBMIT_IDE,
  GET_LOCUS_UNITS_URL,
  GET_FIOS_LQ_DETAILS,
  AUTOPAY_PAYMENT_SAVE_URL,
  ENROLL_PFB_URL,
  POST_OTP,
  POST_VALIDATE_OTP,
  FWA_WIDGET_TEMPLATE_URL,
  STORE_FCC_URL,
  FCC_TEMPLATE_URL,
  FETCH_LOCUS_INFO,
  FETCH_LOCUS_UNIT,
  VALIDATE_EMAIL_URL,
  VALIDATE_EMAIL_URL_NEW,
  SAVE_FTR_MATRIX_URL,
  FETCH_LOCUS_ADDRESS_AND_UNIT_URL
} from './APIurls';

import { ERROR_MESSAGE, ENABLE_OMNI_CART, UI_EVENT_LOGGING, REDIRECT_4G_URL, REDIRECT_5G_URL, VZW_OFFER_ELIGIBILITY_FLAG, IN_NETWORK_STATES } from './constants';

import apiClient from '../utils/apiClient';
import { setChatInfo, isNightTimeWindow, getCookieByName } from '../utils/common';
import * as CryptoJS from 'crypto-js'
import Template from './Template.json'
import i18next from "i18next";
import { lowerFunnelSaga } from '../Pages/CheckoutNew/ducks/saga';
import { CheckAEMBoolValue } from '../Common/CommonPlanTile/CommonPlanTile';

const HeadersForFormData = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }
};

const INCREASED_TIMEOUT = 90000;
const ATOMAPI_KEY = process.env.REACT_APP_UI_ATOM_APIKEY;
let cmpOfferEnable = false
if ((window.location.href).includes('joint_offer_lq')){
  cmpOfferEnable = true
  console.log('sekhar')
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function* initiateGlobalSession() {

  // yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  try {
    /* THIS CALL IS NOT REQUIRED - COMMENTED OUT AS PART OF PERFORMANCE IMPROVEMENT*/
    /*const response = yield apiClient.get(INITIATE_GLOBAL_SESSION_URL);
    yield put({ type: "SAVE_GLOBAL_SESSION_VALUES", data: response.data });*/
    if(process.env.REACT_APP_GB_API_BASE_URL && process.env.REACT_APP_GB_API_BASE_URL?.includes('nte')){
    const responseWithToken = yield apiClient.get(GET_APIGEE_TOKEN_URL);
    yield put({ type: "SAVE_APIGEE_TOKEN", data: responseWithToken.data });
    }
    if (window?.newrelic?.setCustomAttribute) {
      const uuid = uuidv4();
      window.newrelic.setCustomAttribute("ApigeeToken", uuid);
      window.newrelic.setCustomAttribute("UUID", uuid);
    }
    if(window?.newrelic) {
      if(!window?.newrelic?.info?.jsAttributes?._cls_s) {
        const clss =  getCookie("_cls_s");
        const clsv =  getCookie("_cls_v");
        window.newrelic.setCustomAttribute("_cls_s", clss);
        window.newrelic.setCustomAttribute("_cls_v", clsv);
      }
    }
    // Added api call for email field
    // yield* getABLogic();
    //yield* getGBCradleBusinessSolutionsLogic();
    //yield* getVasDisplayCradle();
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_PLQ_Token', error: err } });
  }
}

function* fetchZipcodes(userInput) {
  const zipcityterm = userInput.data;

  if (userInput.skipStreetUpdate) {
    yield put({ type: "SAVE_ZIPCODE_ENTERED_BY_USER_ONLY", data: zipcityterm });
  } else {
    yield put({ type: "SAVE_ZIPCODE_ENTERED_BY_USER", data: zipcityterm });
  }
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  try {
    const response = "";

    if (zipcityterm) {
      const token = yield select(selectors.apigeeAccessToken);

      const config = {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      }

      const response = yield apiClient.get(GET_ZIPCODE_URL + zipcityterm, config);
      if (response?.data?.zips?.length) {
        yield put({ type: "SAVE_ZIPCODE_LIST", data: response.data.zips });
        const filteredZip = response.data.zips.filter(zip => zip.zip === zipcityterm);
        //filtering zipcodes from response and updating to autopopulate
        if (filteredZip?.length) {
          if (userInput.skipStreetUpdate) {
            yield put({
              type: "SAVE_SELECTED_ZIPCODE_ONLY", data: {
                zip: filteredZip[0].zip, city: filteredZip[0].city || '', altCity: filteredZip[0].altCity || '',
                state: filteredZip[0].state || '',
              }
            });
          } else {
            yield put({ type: "SAVE_SELECTED_ZIPCODE", data: { zip: filteredZip[0].zip } });
          }
          yield put({ type: "SAVE_SELECTED_ZIPCODE_AND_CHECK_IF_FIOS_QUALIFIED", data: filteredZip[0], skipStreetUpdate: userInput.skipStreetUpdate });
        }
      } else {
        if (zipcityterm?.length === 5) {
          if (!userInput.skipStreetUpdate) {
            yield put({ type: "SAVE_SELECTED_ZIPCODE", data: { zip: zipcityterm } });
          }
        }
      }

    } else {
      yield put({ type: "SAVE_ZIPCODE_LIST", data: response });
    }
  }
  catch (err) {
    console.log('Catch Error', err);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_PLQ_ELKZIP', error: err } });
    yield put({ type: "REFRESH_APIGEE_TOKEN" });
  }
}

function* saveSelectedZipcode(userInput) {
  const zipcode = userInput.data;
  if (!userInput.skipStreetUpdate) {
    yield put({ type: "SAVE_SELECTED_ZIPCODE", data: zipcode });
  }

  try {
    const response = yield apiClient.get(IS_FIOS_QUALIFIED_ZIP_URL + zipcode.zip);
    // sessionStorage.setItem('serviceType', response.data.oneFib ? 'FIOS' : 'DSL');

    yield put({ type: "SAVE_IS_ZIP_FIOS_QUALIFIED", data: response.data });
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
  }
}

function* fetchStreetAddress(userInput) {
  const streetTerm = userInput.data ? userInput.data.toUpperCase() : "";
  const isAutopayFlow = userInput?.isAutopayFlow || false;
  let token = yield select(selectors.apigeeAccessToken);
  if (!token) {
    if(process.env.REACT_APP_GB_API_BASE_URL && process.env.REACT_APP_GB_API_BASE_URL?.includes('nte')){
    const responseWithToken = yield apiClient.get(GET_APIGEE_TOKEN_URL);
    yield put({ type: "SAVE_APIGEE_TOKEN", data: responseWithToken.data });
    token = responseWithToken?.data?.access_token
    window.isApigeeTokenInitiated = true;
    }
  }
  if(!isAutopayFlow){
  yield put({ type: "SAVE_STREET_TERM_ENTERED_BY_USER", data: streetTerm });
  }
  yield put({ type: "SET_UNITS_TRIGGERED", data: false });
  yield put({ type: "SET_UNITS_RESPONDED", data: false });
  yield put({ type: "SET_BASE_ADDR_UNIT_ERROR", data: false });
  try {
    let response = {};
    const useLocusSmb = CheckAEMBoolValue(i18next.t("fios.useLocusSmb",{ns:"fios"}));
    if (streetTerm) {
      const isNTEenv = isNTEenvs();
      let apiUrl;
      let config;
      if (isNTEenv) {
        apiUrl = GET_ATOM_STREET_ADDRESS_URL;
        config = {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        }
        response = yield apiClient.get(apiUrl + streetTerm, config);
      } else {
        if(useLocusSmb){
          //implemented locus api call through our smb/api instead of direct locus endpoint from UI.
          const locusPayload = {
           streetTerm: streetTerm,
           QueryType: "typeahead"
         };
         response = yield apiClient.post(FETCH_LOCUS_ADDRESS_AND_UNIT_URL, locusPayload)
       }else{
       /*const config = {
         headers: {
           // 'Authorization': 'Bearer ' + token,
           'apikey': ATOMAPI_KEY
       }else{
         apiUrl = GET_STREET_ADDRESS_URL;
         config = {
           headers: {
             'apikey': ATOMAPI_KEY
           }
         }
       }*/
       // const response = yield apiClient.get(apiUrl + streetTerm, config);
        apiUrl = GET_STREET_ADDRESS_URL;
         config = {
           headers: {
             'apikey': ATOMAPI_KEY
           }
         }
         response = yield apiClient.get(apiUrl + streetTerm, config);
       } 
      }
      /*const config = {
        headers: {
          // 'Authorization': 'Bearer ' + token,
          'apikey': ATOMAPI_KEY
        }
      }*/

      yield put({ type: "SAVE_STREET_ADDRESS_LIST", data: response.data.addresses });
    } else {
      yield put({ type: "SAVE_STREET_ADDRESS_LIST", data: response });
    }
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_PLQ_ELKSTREET', error: err } });
    yield put({ type: "REFRESH_APIGEE_TOKEN" });
    window.isApigeeTokenInitiated = false;
  }
}

function* fetchUnits() {
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  yield put({ type: "SET_UNITS_TRIGGERED", data: true });
  yield put({ type: "SET_UNITS_RESPONDED", data: false });
  try {
    let token = yield select(selectors.apigeeAccessToken);
    const useLocusApi = yield select(state=>state.AddressValidationPage.useLocusApi)
    if (!token) {
      console.log(process.env.REACT_APP_GB_API_BASE_URL,"apigeetoken")
      if(process.env.REACT_APP_GB_API_BASE_URL && process.env.REACT_APP_GB_API_BASE_URL?.includes('nte')){
      const responseWithToken = yield apiClient.get(GET_APIGEE_TOKEN_URL);
      yield put({ type: "SAVE_APIGEE_TOKEN", data: responseWithToken.data });
      token = responseWithToken?.data?.access_token
      }
      if (window?.newrelic?.setCustomAttribute) {
        const uuid = uuidv4();
        window.newrelic.setCustomAttribute("ApigeeToken", uuid);
        window.newrelic.setCustomAttribute("UUID", uuid);
      }
    }
    const streetAddress = yield select(selectors.selectedStreetAddress);
    let response = '';
    const config = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'apikey': ATOMAPI_KEY
      }
    }
    if(String(process.env.REACT_APP_GB_ENV).includes('NTE') || !useLocusApi){
    if (streetAddress.ntasAddrID) {
      response = yield apiClient.get(GET_UNITS_URL + streetAddress.ntasAddrID, config)
        .then(response => {
          return response.data;
        });
      yield put({ type: "SET_UNITS_RESPONDED", data: true });
    } else {
      const configLocus = {
        headers: {
          'apikey': ATOMAPI_KEY
        }
      }
      response = yield apiClient.get(GET_LOCUS_UNITS_URL + streetAddress.locusID + `&size=10`, configLocus)
        .then(response => {
          response.data.unitDetails = response?.data?.data?.unitDetails?.map(e => ({
            addressId: IN_NETWORK_STATES.indexOf(streetAddress.state) > -1 ? "0" :  e?.location_id,
            baseAddressId: IN_NETWORK_STATES.indexOf(streetAddress.state) > -1 ? "0" :  e?.location_id,
            unit: e?.sublocation, ...e
          }));
          response.data.total = response.data.totalHits;
          return response
        });
      yield put({ type: "SET_UNITS_RESPONDED", data: true });
    }
    if (response?.data?.total > 0) {
      yield put({ type: "SAVE_UNIT_LIST", data: response.data.unitDetails });
      yield put({ type: "SAVE_TOTAL_UNITS", data: response.data.total });
    } else {
      yield put({ type: "ENABLE_CHECK_AVAILABILITY" });

      const previousAddressID = yield select(selectors.previousAddressID);
      if (previousAddressID !== streetAddress.ntasAddrID ||
        (!previousAddressID && !streetAddress.ntasAddrID)) {
        if (ENABLE_OMNI_CART === "true") {
          yield all([
            call(triggerAddressQualification),
            // call(triggerOptixAddressQualification)
          ])
        } else {
          yield* triggerAddressQualification()
        }
      }
      //  yield *triggerAddressQualification()
      // yield*triggerOptixAddressQualification()
    }
    }else{
      yield call(getUnitsLocus,{data:'',doLoopCall:undefined})
    }
  }
  catch (err) {
    console.log('Catch Error', err);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    // yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    // TODO 
    // yield put({ type: "REFRESH_APIGEE_TOKEN" });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_PLQ_ELKUNIT', error: err } });
    // yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_PLQ_ELKUNIT' });
  }
}

function* fetchUnitsinBillingAddress(params) {
  const {autoPayStreetAddress,isAutoPayFlow} = params?.data ||{};
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  yield put({ type: "SET_UNITS_TRIGGERED", data: true });
  yield put({ type: "SET_UNITS_RESPONDED", data: false });
  yield* initiateGlobalSession();
  try {
    const token = yield select(selectors.apigeeAccessToken);
    const useLocusApi = yield select(state=>state.AddressValidationPage.useLocusApi)
    const streetAddress = yield select(selectors.selectedStreetAddress);
    let response = '';
    const config = {
      headers: {
        'Authorization': 'Bearer ' + token,
        'apikey': ATOMAPI_KEY
      }
    }
    if ((streetAddress.ntasAddrID || autoPayStreetAddress) && (String(process.env.REACT_APP_GB_ENV).includes('NTE') || !useLocusApi || isAutoPayFlow)) {
      let addressId = isAutoPayFlow?autoPayStreetAddress:streetAddress.ntasAddrID;
      response = yield apiClient.get(GET_UNITS_URL + addressId, config)
        .then(response => {
          return response.data;
        });
      yield put({ type: "SET_UNITS_RESPONDED", data: true });
    } else {
      const configLocus = {
        headers: {
          'apikey': ATOMAPI_KEY
        }
      }
      const useLocusSmb = CheckAEMBoolValue(i18next.t("fios.useLocusSmb",{ns:"fios"}));
      if(useLocusSmb){
        response = yield apiClient.post(FETCH_LOCUS_ADDRESS_AND_UNIT_URL, { locusId: streetAddress.locusID, QueryType: "typeahead-units" })
        .then(response => {
          response.data.unitDetails = response?.data?.data?.map(e => ({
            addressId: IN_NETWORK_STATES.indexOf(streetAddress.state) > -1 ? "0" :  e?.location_id,
            baseAddressId: IN_NETWORK_STATES.indexOf(streetAddress.state) > -1 ? "0" :  e?.location_id,
            unit: e?.sublocation, ...e
          }));
          response.data.total = response.data.totalHits;
          return response
        });
      }else{
      response = yield apiClient.get(GET_LOCUS_UNITS_URL + streetAddress.locusID + `&size=10`, configLocus)
        .then(response => {
          response.data.unitDetails = response?.data?.data?.unitDetails?.map(e => ({
            addressId: IN_NETWORK_STATES.indexOf(streetAddress.state) > -1 ? "0" :  e?.location_id,
            baseAddressId: IN_NETWORK_STATES.indexOf(streetAddress.state) > -1 ? "0" :  e?.location_id,
            unit: e?.sublocation, ...e
          }));
          response.data.total = response.data.totalHits;
          return response
        });
      }
      yield put({ type: "SET_UNITS_RESPONDED", data: true });
    }
    if (response?.data?.total > 0) {
      if(!isAutoPayFlow){
      yield put({ type: "SAVE_UNIT_LIST", data: response.data.unitDetails });
      yield put({ type: "SAVE_TOTAL_UNITS", data: response.data.total });
      yield put({ type: "ENABLE_CHECK_AVAILABILITY_BUTTON" });
      }else{
        yield put({ type: "SAVE_UNIT_LIST_FOR_AUTO_PAY", data: response.data.unitDetails });
      }
    }
    else {
      yield put({ type: "ENABLE_CHECK_AVAILABILITY_BUTTON" });
      yield put({ type: "SAVE_UNIT_LIST_FOR_AUTO_PAY", data: "" });
    }
  }
  catch (err) {
    console.log('Catch Error', err);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: "REFRESH_APIGEE_TOKEN" });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_PLQ_ELKUNIT', error: err } });
    // yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_PLQ_ELKUNIT' });
  }
}


function* fetchUnitsByUnitterm(action) {

  try {
    const token = yield select(selectors.apigeeAccessToken);
    const streetAddress = yield select(selectors.selectedStreetAddress);
    const useLocusApi = yield select(state=>state.AddressValidationPage.useLocusApi)
    const selectedUnit = action.data ? { unit: action.data } : yield select(selectors.selectedUnit);
    let response = ''
    const config = {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }
    const unit = selectedUnit.unit ? selectedUnit.unit.toUpperCase() : "";
    if(String(process.env.REACT_APP_GB_ENV).includes('NTE') || !useLocusApi){
    if (streetAddress.baseAddressId) {
      const unitresponse = yield apiClient.get(GET_UNITS_URL + streetAddress.baseAddressId, config).then(response => {
        return response.data;
      });
      yield put({ type: "SET_UNITS_RESPONDED", data: true });
      yield put({ type: "SAVE_UNIT_LIST", data: unitresponse.data.unitDetails });
    }
    if (streetAddress.baseAddressId) {
      response = yield apiClient.get(GET_UNITS_URL + streetAddress.baseAddressId + "&unitterm=" + unit, config)
        .then(response => {
          return response.data;
        });
      yield put({ type: "SET_UNITS_RESPONDED", data: true });
    } else {
      const configLocus = {
        headers: {
          'apikey': ATOMAPI_KEY
        }
      }
      response = yield apiClient.get(GET_LOCUS_UNITS_URL + streetAddress.locusID + "&unitterm=" + unit + `&size=10`, configLocus)
        .then(response => {
          response.data.unitDetails = response?.data?.data?.unitDetails?.map(e => ({
            addressId: IN_NETWORK_STATES.indexOf(streetAddress.state) > -1 ? "0" : e?.location_id,
            baseAddressId:IN_NETWORK_STATES.indexOf(streetAddress.state) > -1 ? "0" :  e?.location_id,
            unit: e?.sublocation, ...e
          }));
          response.data.total = response?.data?.totalHits;
          return response
        });
      yield put({ type: "SET_UNITS_RESPONDED", data: true });
    }
    if (response?.data?.total > 0) {
      yield put({ type: "SAVE_UNIT_LIST", data: response.data.unitDetails });
    }
  }else{
    yield call(getUnitsLocus,{...action,fromFetchUnits:true})
  }
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "REFRESH_APIGEE_TOKEN" });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_PLQ_ELKUNIT', error: err } });
    // yield put({ type: "REDIRECT_TO_LBO",  message: 'NTE_PLQ_ELKUNIT' });
  }
}

function* getMultipleAddressSelection(action) {
  const token = yield select(selectors.apigeeAccessToken);
  const zipcode = yield select(selectors.selectedZipcode);
  const config = { headers: { 'Authorization': 'Bearer ' + token } }
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  try {
    // Fetch Street Address 
    const streetTerm = action.data.street ? action.data.street.toUpperCase() : "";
    let response = {};
    const useLocusSmb = CheckAEMBoolValue(i18next.t("fios.useLocusSmb",{ns:"fios"}));
    yield put({ type: "SAVE_STREET_TERM_ENTERED_BY_USER", data: streetTerm });
    yield put({ type: "SET_BASE_ADDR_UNIT_ERROR", data: false });
    if (streetTerm) {
      if(useLocusSmb){
        //implemented locus api call through our smb/api instead of direct locus endpoint from UI.
        const locusPayload = {
          streetTerm: streetTerm,
          QueryType: "typeahead"
        };
        response = yield apiClient.post(FETCH_LOCUS_ADDRESS_AND_UNIT_URL, locusPayload)
      }else{
        response = yield apiClient.get(GET_STREET_ADDRESS_URL + zipcode.zip + `&streetterm=` + streetTerm, config);
      }
      yield put({ type: "SAVE_STREET_ADDRESS_LIST", data: response.data.addressesbau });
    } else {
      yield put({ type: "SAVE_STREET_ADDRESS_LIST", data: response });
    }

    // Validate Street AddressList Response
    if (response.data && response.data.addressesbau) {
      if (response.data.addressesbau?.length === 1) {
        // Set the street value in  redux 
        const streetAddress = response.data.addressesbau[0];
        streetAddress.baseAddressId = streetAddress.ntasAddrID;
        yield put({ type: "SAVE_SELECTED_STREET_ADDRESS", data: streetAddress });
        // fetch Units

        const unitresponse = yield apiClient.get(GET_UNITS_URL + streetAddress.ntasAddrID, config).then(response => {
          return response.data;
        });
        yield put({ type: "SET_UNITS_RESPONDED", data: true });
        yield put({ type: "SAVE_UNIT_LIST", data: unitresponse.data.unitDetails });
        //enable Units field

        if (unitresponse.data.unitDetails && unitresponse.data.unitDetails?.length > 0) {

          // const termResponse = yield apiClient.get(GET_UNITS_URL + streetAddress.ntasAddrID + "&unitterm=" + action.data.unit, config)
          //   .then(response => {
          //     return response.data;
          //   });

          yield put({ type: "SAVE_UNIT_LIST", data: unitresponse.data.unitDetails });
          if (unitresponse.data.unitDetails?.length > 0) {
            yield put({ type: "SAVE_TOTAL_UNITS", data: unitresponse.data.total });
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
            yield put({ type: "SET_CHECKAVAILABILITY_CLICKED", data: false });
            yield put({ type: "SET_EMPTY_UNITS_ERROR", data: true });
          } else {
            yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
            yield put({ type: "SET_CHECKAVAILABILITY_CLICKED", data: true });
            yield* triggerAddressQualification();
          }
        }
      } else {
        yield put({ type: "SET_UNITS_TRIGGERED", data: false });
        yield put({ type: "SET_UNITS_RESPONDED", data: false });
        yield put({ type: "SET_STREETADDR_ERROR", data: "Edit the Street Address and choose from dropdown" });
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
    } else {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log(err);
  }
}

function* getMultipleAddressSelectionWithId(action) {
  const token = yield select(selectors.apigeeAccessToken);
  const config = { headers: { 'Authorization': 'Bearer ' + token } }
  const selectedStreetAddress = action.data;
  try {
    const unitsResponse = yield apiClient.get(GET_UNITS_URL + selectedStreetAddress.ntasAddrID, config)
      .then(response => {
        return response.data;
      });
    yield put({ type: "SET_UNITS_RESPONDED", data: true });
    if (unitsResponse.data.total > 0) {
      // For Location with more than  one sublocation - allowing user to select sulocation
      yield put({ type: "SAVE_UNIT_LIST", data: unitsResponse.data.unitDetails });
      yield put({ type: "SAVE_TOTAL_UNITS", data: unitsResponse.data.total });
      yield put({ type: "SET_EMPTY_UNITS_ERROR", data: true });
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      yield put({ type: "SET_CHECKAVAILABILITY_CLICKED", data: false });
    } else {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      yield put({ type: "SET_CHECKAVAILABILITY_CLICKED", data: true });
      yield* triggerAddressQualification();
    }

  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    console.log(err);
  }
}

function* triggerOptixAddressQualification(historyObjectForNavigation) {

  //  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });

  /* TODO: Find all the headers, request body and cookies required to make this call */
  console.log("in trigger optix addresss qualification");

  const history = historyObjectForNavigation?.data;

  const selectedZipcode = yield select(selectors.selectedZipcode);
  const selectedStreetAddress = yield select(selectors.selectedStreetAddress);

  const phoneNumber = yield select(selectors.phoneNumber);
  const email = yield select(selectors.email);
  const streetAddressEnteredByUser = yield select(
    selectors.streetTermEnteredByUser
  );
  let selectedUnit = yield select(selectors.selectedUnit);
  if (selectedUnit.unit === "I don't live in a unit")
    selectedUnit = "";
  else
    selectedUnit = selectedUnit.unit;
  const requestBody = {
    // "zipCode": selectedZipcode.zip,
    // "city": selectedZipcode.altCity || '',
    // "state": selectedZipcode.state || '',
    // "unit": selectedUnit ? selectedUnit : '',
    // streetAddress:
    //   selectedStreetAddress && selectedStreetAddress.street
    //     ? selectedStreetAddress.street
    //     : "",
    // streetTerm: selectedStreetAddress && selectedStreetAddress.street
    //   ? selectedStreetAddress.street
    //   : "",
    // unitTerm: "",
    addressID:
      selectedStreetAddress && selectedStreetAddress.ntasAddrID
        ? selectedStreetAddress.ntasAddrID
        : ""
    // addressID:"35307948"
    // rawaddr: "",
    // BaseAddressID:
    //   selectedStreetAddress && selectedStreetAddress.baseAddressId
    //     ? selectedStreetAddress.baseAddressId
    //     : selectedStreetAddress && selectedStreetAddress.ntasAddrID
    //       ? selectedStreetAddress.ntasAddrID : "0",
    // "Retry": "Y",
    // "RememberMe": "",
    // "IsNonDO": "N",
    // "TelephNoLQ": phoneNumber ? phoneNumber.replace(/-/g, "") : "",
    // "EmailLQ": email || "",
    // "InternalTest": "",
    // "GUID": Math.random().toString().replace('.', ''),  // added from .net 
    // "FromAmazonURL": "",
    // "OneFiberOverlay": "N",
    // "AmexOverlay": "",
    // "FromAmexMLP": "N",
    // "CloverMLP": "N",
    // "page_URL": window.location.href,
    // "campaign_Id": "Messsage=UNKNOWN",
    // "EntryPoint": "",
    // "VeteranDiscount": "N",
    // "VZWTN": phoneNumber ? phoneNumber.replace(/-/g, "") : ""

  }

  try {
    /* commented as it is not required for new optix flow */

    //const response = yield apiClient.post(OPTIX_QUOTE_BY_ADDRESS_URL, requestBody);
    //console.log("optix response==================" + response)
    window.sessionStorage.setItem("phoneNumber", phoneNumber || '');
    //yield put({ type: "SAVE_OPTIX_ADDRESS_QUALIFICATION_DETAILS", data: response.data });
    //yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "SET_PREVIOUS_ADDRESS_ID", data: requestBody.AddressID });

    /* Set below line to skip optix flow in LQ page */
    yield put({ type: "SKIP_OPTIX_FLOW_DUE_TO_API_FAILURE", data: true });
    dispatchEvent('recievedOptixAddressQualificationResponse', true);
    // SiteCatalyst.trackQualificationResponse(requestBody, response.data);
  } catch (e) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    // yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OLQ_DoLQ' });
    // history.push("/out-of-franchise");
    yield put({ type: "SKIP_OPTIX_FLOW_DUE_TO_API_FAILURE", data: true });
    dispatchEvent('recievedOptixAddressQualificationResponse', true);
    console.log('Catch Error', e);
    // yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  }
}


function* triggerAddressQualification(historyObjectForNavigation) {

  //  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "SET_EMPTY_UNITS_ERROR", data: false });
  yield put({ type: "SET_BASE_ADDR_UNIT_ERROR", data: false });
  yield put({ type: "SAVE_CHECKAVAIL_RES", data: null });
  /* TODO: Find all the headers, request body and cookies required to make this call */
  console.log("in trigger addresss qualification");
  console.log("Entry URL", document.referrer);

  const history = historyObjectForNavigation?.data;

  const selectedZipcode = yield select(selectors.selectedZipcode);
  const selectedStreetAddress = yield select(selectors.selectedStreetAddress);
  const getBizSolutionLogic = yield select(selectors.getBizSolutionLogic)
  const getABLogicResp = yield select(selectors.getABLogicResp);
  const cmpCodeForWireless = yield select(state=>state.AddressValidationPage.cmpCodeQueryParamWirelesss)
  const bannerInfo = yield select(selectors.bannerInfo)
  const bannerId = yield select(state=>state.AddressValidationPage.bannerId)
  let productRecommended = "BAU|BAU"
  if (getABLogicResp?.HasABLogic == "Y" && getBizSolutionLogic) {
    productRecommended = "gborder_bdvbundledefault|gborder_businesssolutions"
  } else if (getABLogicResp?.HasABLogic == "Y" && !getBizSolutionLogic) {
    productRecommended = "gborder_bdvbundledefault|BAU"
  } else if (getBizSolutionLogic) {
    productRecommended = "BAU|gborder_businesssolutions"
  } else if (!getBizSolutionLogic) {
    productRecommended = "BAU|BAU"
  } else {
    productRecommended = "BAU|BAU"
  }
  const phoneNumber = yield select(selectors.phoneNumber);
  const email = yield select(selectors.email);
  const streetAddressEnteredByUser = yield select(
    selectors.streetTermEnteredByUser
  );
  const selectedUnitComplete = yield select(selectors.selectedUnit);
  let selectedUnit = yield select(selectors.selectedUnit);
  const selectedUnitAddress = yield select(state=>state.AddressValidationPage.selectedUnitAddress) ?? {}
  const isNTASAddressIDPresent = (selectedUnit&&selectedUnit['IsUnitNtasIdPresent']) ? selectedUnit['IsUnitNtasIdPresent'] : 'N'
  if (selectedUnit.unit === "I don't live in a unit")
    selectedUnit = "I dont live in a unit";
  else if (selectedUnit.unit === "I can't find my unit")
    selectedUnit = "I cant find my unit";
  else if (selectedUnit.unit === "I don't have a unit")
    selectedUnit = "I dont have a unit";
  else if (selectedUnit.unit === "I don't see my unit")
    selectedUnit = "I dont see my unit";
  else
    selectedUnit = selectedUnit.unit;
  const requestBody = {
    "zipCode": selectedStreetAddress.zip,
    "city": selectedStreetAddress.muni || '',
    "state": selectedStreetAddress.state || '',
    "unit": selectedUnit ? selectedUnit : '',
    houseNumber:selectedStreetAddress && selectedStreetAddress.houseNumber
    ? selectedStreetAddress.houseNumber:"", 
    streetName:selectedStreetAddress && selectedStreetAddress.streetName
    ? selectedStreetAddress.streetName:"",
    streetAddress:
      selectedStreetAddress && selectedStreetAddress.dispstr
        ? selectedStreetAddress.dispstr
        : "",
    streetTerm: selectedStreetAddress && selectedStreetAddress.dispstr
      ? selectedStreetAddress.dispstr
      : "",
    unitTerm: "",
    AddressID:
      selectedStreetAddress && selectedStreetAddress.ntasAddrID
        ? selectedStreetAddress.ntasAddrID
        : "",
    rawaddr: "",
    BaseAddressID:
      selectedStreetAddress && selectedStreetAddress.baseAddressId
        ? selectedStreetAddress.baseAddressId
        : selectedStreetAddress && selectedStreetAddress.ntasAddrID
          ? selectedStreetAddress.ntasAddrID : "0",
    "Retry": "Y",
    "RememberMe": "",
    "IsNonDO": "N",
    "TelephNoLQ": phoneNumber ? phoneNumber?.replace(/-/g, "") : "",
    "EmailLQ": email ? email?.trim() || "" : '',
    "InternalTest": "",
    "GUID": Math.random().toString()?.replace('.', ''),  // added from .net 
    "FromAmazonURL": "",
    "OneFiberOverlay": "N",
    "AmexOverlay": "",
    "FromAmexMLP": "N",
    "CloverMLP": "N",
    "page_URL": window.location.href,
    "JourneyEntryURL": document.referrer,
    "campaign_Id": "Messsage=UNKNOWN",
    "EntryPoint": "",
    "VeteranDiscount": "N",
    "SkipPendingOrderFlag": "Y",
    "VZWTN": phoneNumber ? phoneNumber?.replace(/-/g, "") : "",
    "ABLogicValue": getABLogicResp && getABLogicResp?.HasABLogic ? getABLogicResp?.HasABLogic : 'N',
    "ProductRecommend": productRecommended, 
    "FiosTVReStructure": "Y",
    BaselocationId : (selectedStreetAddress&&selectedStreetAddress?.locusID) ? selectedStreetAddress?.locusID : "",
    SublocationId : (selectedUnitComplete && selectedUnitComplete?.addressId) ? selectedUnitComplete?.addressId : ((selectedStreetAddress&&selectedStreetAddress?.locusID) ? selectedStreetAddress?.locusID : ""),
    ...selectedUnitAddress,
    IsUnitNtasIdPresent:isNTASAddressIDPresent,
    smbBannerId:bannerId?bannerId:""
  }

  window.LQRequestBody = requestBody;
  // using axios cancel token approach to cancel an old request of the same saga method.
  // will pass the cancel token to the request method.
  // please don't remove.
  const source = CancelToken.source();
  const config = { cancelToken: source.token };
  const mtn = phoneNumber ? phoneNumber?.replace(/-/g, "") : "";
  const emailLq = email ? email?.trim() || "" : '';
  const useLocusSmb = CheckAEMBoolValue(i18next.t("fios.useLocusSmb",{ns:"fios"}));
  try {
    yield put({ type: "DO_LOOP_TRIGGERED", data: true });
    yield fork(fetchPendingOrder, requestBody, config)
    const response = yield apiClient.post(DO_LOOP_QUALIFICATION_URL, requestBody, config);
    const caEvent = { data: { log: "CheckAvailability Button Click", eventType: 'log', doLoopSessionId: response?.data?.sessionId, eventName: "CheckAvailability Button Click", sectionName: "LQ" } }
    yield call(postEventLogging, caEvent);
    const chkAvailibtyClicked = yield select(selectors.chkAvailibtyClicked);
    if (response?.data?.LQPost?.FiOSDataStatus === "Y") {
      window.localStorage.setItem('INTERNET', 'FIOS')
    } else if (response?.data?.LQPost?.HSIStatus === "Y") {
      window.localStorage.setItem('INTERNET', 'HSI')
    } else {
      window.localStorage.setItem('INTERNET', '')
    }
    if (response?.data?.LQPost?.FiOSDataStatus === 'Y' && response?.data?.LQPost?.HSIStatus === 'Y') {
      response.data.LQPost.HSIStatus = 'N';
    }

    if (chkAvailibtyClicked && (response?.data?.Qualified == "false" || response?.data?.Qualified == "true") && !response?.data?.HasMultipleAddress && response?.data?.LQPost?.HSIStatus !== "Y" && response?.data?.LQPost?.FiOSDataStatus !== "Y" && response?.data?.IDEQualified !== "Y") {
      if (!selectedStreetAddress?.ntasAddrID) {
        if (!isNightTimeWindow()) {
          SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
          SiteCatalyst.trackProductsList(window.LQResponse);
          SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
          if (response?.data?.Qualified == "true" || response?.data?.QualifiedCBand === 'true') {
            SiteCatalyst.trackLQSuccess5G(window.LQRequestBody, { type: '5G Redirection', data: window.LQResponse });
          } else {
            SiteCatalyst.trackLQSuccess4G(window.LQRequestBody, { type: '4G/LTE Redirection', data: window.LQResponse });
          }

          if (window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
            if (response?.data?.Qualified == "true" || response?.data?.QualifiedCBand === 'true') {
              window.newrelic.addPageAction('LQSuccess5G', { data: window.LQRequestBody });
            } else {
              window.newrelic.addPageAction('LQSuccess4G', { data: window.LQRequestBody });
            }
          }
        }
        if (response?.data?.Qualified == "true" || response?.data?.QualifiedCBand === 'true') {
          SiteAnalytics.track5GEligibleRedirection();
          const event = { data: { log: "Redirecting to 5G", eventType: 'log', doLoopSessionId: response?.data?.sessionId, eventName: "5G_PageLoad", sectionName: "Page", sync: true } }
          yield call(postEventLogging, event);
          if (response?.data?.GUISessionId) {
            if(response?.data?.FiveGRedirectUrl) window.location.href = response?.data?.FiveGRedirectUrl + `?redirectedFrom=BBA&lqsessionId=${response?.data?.GUISessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}` 
            else window.location.href = REDIRECT_5G_URL + `?redirectedFrom=BBA&lqsessionId=${response?.data?.GUISessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}` 
          } else {
            if(response?.data?.FiveGRedirectUrl) window.location.href = response?.data?.FiveGRedirectUrl + `?redirectedFrom=BBA`
            else window.location.href = REDIRECT_5G_URL + `?redirectedFrom=BBA`
          }
        } else {
          SiteAnalytics.track4GEligibleRedirection();
          const event = { data: { log: "Redirecting to 4G", doLoopSessionId: response?.data?.sessionId, eventType: 'log', eventName: "4G_PageLoad", sectionName: "Page", sync: true } }
          yield call(postEventLogging, event);
          if (response?.data?.GUISessionId) {
            if(response?.data?.LTERedirectUrl) window.location.href = response?.data?.LTERedirectUrl + `?redirectedFrom=BBA&lqsessionId=${response?.data?.GUISessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
            else window.location.href = REDIRECT_4G_URL + `?redirectedFrom=BBA&lqsessionId=${response?.data?.GUISessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
          } else {
            if(response?.data?.LTERedirectUrl) window.location.href = response?.data?.LTERedirectUrl + `?redirectedFrom=BBA`
            else window.location.href = REDIRECT_4G_URL + `?redirectedFrom=BBA`
          }
        }
      } else {
        yield put({ type: "SAVE_ADDRESS_QUALIFICATION_DETAILS", data: response?.data });
        const lqResponse = response?.data?.LQPost;
        yield put({ type: "GET_POST_LQ_DATA_RESPONSE", data: response?.data?.LQPost });
        yield put({ type: "DO_LOOP_TRIGGERED", data: false })
        window.LQResponse = response?.data;
        dispatchEvent('recievedDoLoopResponse', true);
      }
    } else {

      window.sessionStorage.setItem("phoneNumber", phoneNumber || '');
      window.LQResponse = response?.data;

      if (ENABLE_OMNI_CART === "true") {
        // yield* triggerOptixAddressQualification(historyObjectForNavigation)
        const selectedStreetAddress = yield select(selectors.selectedStreetAddress);
        const phoneNumber = yield select(selectors.phoneNumber);
        const addressID =
          selectedStreetAddress && selectedStreetAddress.ntasAddrID
            ? selectedStreetAddress.ntasAddrID
            : "";
        window.sessionStorage.setItem("phoneNumber", phoneNumber || '');
        yield put({ type: "SET_PREVIOUS_ADDRESS_ID", data: addressID });

      }
      yield put({ type: "SAVE_ADDRESS_QUALIFICATION_DETAILS", data: response?.data });
      const lqResponse = response?.data?.LQPost;
      yield put({ type: "GET_POST_LQ_DATA_RESPONSE", data: response?.data?.LQPost });
      yield put({ type: "DO_LOOP_TRIGGERED", data: false })
      console.log("====after save address qualification details")
      yield put({ type: "SET_PREVIOUS_ADDRESS_ID", data: requestBody.AddressID });

      // Redirecting to LBO if plans are blank
      if (response?.data?.LQPost?.FiOSDataStatus === 'Y') {
        if (!response?.data?.DataInfo?.Plans || response?.data?.DataInfo?.Plans?.length === 0) {
           if (response?.data?.GUISessionId) {
            // window.location.href = REDIRECT_4G_URL + `?redirectedFrom=GBCOM&lqsessionId=${response?.data?.GUISessionId}`
            window.location.href = REDIRECT_4G_URL
            return;
          } else {
            window.location.href = REDIRECT_4G_URL + `?redirectedFrom=GBCOM`
            return;
          }
        }
      }

      if (response?.data?.LQPost?.HSIStatus === 'Y' && chkAvailibtyClicked) {
        if (!response?.data?.DataInfo?.Plans || response?.data?.DataInfo?.Plans?.length === 0) {
          if (response?.data?.GUISessionId) {
            // window.location.href = REDIRECT_4G_URL + `?redirectedFrom=GBCOM&lqsessionId=${response?.data?.GUISessionId}`
            window.location.href = REDIRECT_4G_URL
            return;
          } else {
            window.location.href = REDIRECT_4G_URL + `?redirectedFrom=GBCOM`
            return;
          }
        }
      }
      if (lqResponse?.EPSessionID && window.newrelic?.setCustomAttribute) {
        window.newrelic.setCustomAttribute("EPSessionId", lqResponse?.EPSessionID);
        window.newrelic.setCustomAttribute("GUISessionID", lqResponse?.GUISessionID);
      }
      /* Check if Units triggered */
      const isUnitsTriggered = yield select(selectors.isUnitsTriggered);
      const selectedUnit = yield select(selectors.selectedUnit)
      // Base Address Validation Service Blocked Scenario fix 
      if (response?.data?.BaseAddressBlocked === 'Y' && selectedUnit.unit === "I don't live in a unit") {
        yield put({ type: "SET_EMPTY_UNITS_ERROR", data: true });
        yield put({ type: "SET_BASE_ADDR_UNIT_ERROR", data: true });
        yield put({ type: "SET_DONT_SHOW_LIVE_UNIT", data: true });
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
        yield put({ type: "SET_CHECKAVAILABILITY_CLICKED", data: false });
        yield put({ type: "RESET_DOLOOP_FLAGS" });
        return;
      }

      if (!isUnitsTriggered && !requestBody.AddressID) {
        if (lqResponse) {
          // Temporary pick street Address from Address Location
          const address = lqResponse.Address;
          const streetAddr = address.split(',')[0]?.trim();
          // yield put({ type: "GET_STREET_ADDRESS", data: streetAddr});
          const token = yield select(selectors.apigeeAccessToken);
          const zipcode = yield select(selectors.selectedZipcode);

          const config = {
            headers: {
              'Authorization': 'Bearer ' + token
            }
          }
          // Fetch Street Address from the response od LQPost
          let streetResponse = {};
          if(useLocusSmb){
            //implemented locus api call through our smb/api instead of direct locus endpoint from UI.
            const locusPayload = {
              streetTerm: streetAddr,
              QueryType: "typeahead"
            };
             streetResponse = yield apiClient.post(FETCH_LOCUS_ADDRESS_AND_UNIT_URL, locusPayload)
          }else{
            // Fetch Street Address from the response od LQPost
            streetResponse = yield apiClient.get(GET_STREET_ADDRESS_URL + zipcode.zip + `&streetterm=` + streetAddr, config);
          }
          const streetAddressSuggestionList = streetResponse.data.addressesbau;//yield select(selectors.streetAddressSuggestionList);
          yield put({ type: "SAVE_STREET_ADDRESS_LIST", data: streetResponse.data.addressesbau });
          yield put({ type: "SET_BASE_ADDR_UNIT_ERROR", data: false });
          if (streetAddressSuggestionList) {
            if (streetAddressSuggestionList?.length === 1) {
              const selectedStreetAddress = streetAddressSuggestionList[0];
              selectedStreetAddress.baseAddressId = selectedStreetAddress.ntasAddrID
              yield put({ type: "SAVE_SELECTED_STREET_ADDRESS", data: selectedStreetAddress });
              // Fetch Units start
              const streetAddress = streetAddressSuggestionList[0]; // Street address object with AddressId
              const unitsResponse = yield apiClient.get(GET_UNITS_URL + streetAddress.ntasAddrID, config)
                .then(response => {
                  return response.data;
                });
              yield put({ type: "SET_UNITS_TRIGGERED", data: true });
              yield put({ type: "SET_UNITS_RESPONDED", data: true });
              if (unitsResponse.data.total > 0) {
                // For Location with more than  one sublocation - allowing user to select sulocation
                yield put({ type: "SAVE_UNIT_LIST", data: unitsResponse.data.unitDetails });
                yield put({ type: "SAVE_TOTAL_UNITS", data: unitsResponse.data.total });
                yield put({ type: "SET_EMPTY_UNITS_ERROR", data: true });
                yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
                yield put({ type: "SET_CHECKAVAILABILITY_CLICKED", data: false });
              } else {
                // if(unitsResponse.data.total  == 1) {
                //   // For Location with one sublocation - auto setting the addressId for next DoLoop call
                //   streetAddress.ntasAddrID = unitsResponse.data.unitDetails[0].addressId;
                //   yield put({ type: "SAVE_SELECTED_STREET_ADDRESS", data: streetAddress });
                // }
                yield* triggerAddressQualification();
              }
              // Fetch units end
              // Show error Notification
              return;
            } else if (streetAddressSuggestionList?.length == 0) {
              yield put({ type: "SET_UNITS_TRIGGERED", data: false });
              yield put({ type: "SET_UNITS_RESPONDED", data: false });
            } else {
              if (!response?.data?.HasMultipleAddress && !response?.data?.RedirectToNextPage) {
                yield put({ type: "SET_STREETADDR_ERROR", data: true });
                yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
                yield put({ type: "RESET_DOLOOP_FLAGS" });

                return;

              }
            }
          }
        }
      }
      // yield fork(checkAvailAPICall);
      if (response?.data?.HasExistingService) {
        yield put({ type: "SET_PREVIOUS_HAS_EXISTING_SERVICE", data: 'Y' });
      } else {
        yield put({ type: "SET_PREVIOUS_HAS_EXISTING_SERVICE", data: 'N' });
      }
      const getABLogicResp = yield select(selectors.getABLogicResp);
      yield put({ type: "UPDATE_IS_ETF_BUY_OUT_QUALIFIED", data: response?.data?.IsETFBuyOutQualified });

      const bannerInfo = yield select(selectors.bannerInfo);
      let bundleRecommendFlow = true;
      if (((response?.data?.LQPost?.FiOSDataStatus === 'Y' && response?.data?.LQPost?.bdvStatus === 'Y') ||
        (response?.data?.LQPost?.HSIStatus === 'Y' && response?.data?.LQPost?.PhoneStatus === 'Y')) &&
        getABLogicResp?.HasABLogic === 'Y' && !bannerInfo) {
        yield put({ type: "UPDATE_BUNDLE_RECOMMEND", data: true });
      } else {
        yield put({ type: "UPDATE_BUNDLE_RECOMMEND", data: false });
        bundleRecommendFlow = false;
      }
      let isBannerPreSelectionByAPI = CheckAEMBoolValue(i18next.t("fios.IsBannerPreSelection",{ns:"fios"}));
      let bannerEnabledByApi = isBannerPreSelectionByAPI !== "IsBannerPreSelection"?isBannerPreSelectionByAPI: false;
      if (bannerEnabledByApi || (!bundleRecommendFlow && !bannerInfo)) {
        if (response?.data?.DataInfo) {
          let params = {
            url: "",
            type: 'data'
          }
          if (response.data?.DataInfo?.Plans[0]?.ServiceType === "DSL") {
            params.url = GET_BASIC_INTERNET_DATA_URL;
          } else {
            params.url = GET_FIOS_INTERNET_DATA_URL;
          }
          yield put({ type: "SET_INTERNET_TYPE", data: response?.data?.DataInfo?.Plans[0]?.ServiceType });
          yield put({ type: "SET_ROUTER_LIST", data: response?.data?.DataInfo?.Routers });

          let bannerInternetObj = bannerInfo ? getBannerInternetSelectedPlan(response?.data?.DataInfo, bannerInfo) : '';
          let internetPlanData = bannerInfo && bannerInternetObj ? bannerInternetObj : response?.data?.DataInfo?.Plans[0];
          const infoParams = {
            bundleID: internetPlanData?.PackageId,
            tvID: 0,
            nLines: 1,
            contract: internetPlanData?.Contract,
            hcid: internetPlanData?.ProductId ? internetPlanData?.ProductId : '',
            ptype: internetPlanData?.ServiceType ? internetPlanData?.ServiceType : '',
            bRc: internetPlanData?.Price,
            upselSelected: false
          };
          const newFlowInternetType = infoParams.ptype;
          if (response?.data?.LQPost?.FiOSDataStatus == "Y" || response?.data?.LQPost?.HSIStatus == "Y") {
            yield* getSelectedBundleInfo({ infoParams, params }, true);
            // yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA });
          }
          // yield put({ type: "UPDATE_INTERNET_PLAN_ID", internetPlanID: infoParams?.hcid?.toString() });
          yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: newFlowInternetType });
        }
        if (!response?.data?.DataInfo && response?.data?.LQPost?.PhoneStatus === 'Y') {
          const bundleID = response?.data?.PhoneInfo[0]?.BID;
          const bRc = response?.data?.PhoneInfo[0]?.BundleRC;
          const preferredvoiceFormData = `BID=${bundleID}&RC=${bRc}&nlines=1`;
          // yield* getPreferredvoiceData({ params: preferredvoiceFormData });
        }
      }

      window.LQResponse = response?.data;
      dispatchEvent('recievedDoLoopResponse', true);
      if (!response?.data?.OOF && !response?.data?.HasMultipleAddress && !response?.data?.HasError &&
        (response?.data?.LQPost?.FiOSDataStatus == "Y" || response?.data?.LQPost?.HSIStatus == "Y") &&
        response?.data?.DefaultReg !== 'Y') {
        yield* fetchCustomizeProducts();
      }
      // yield put({ type: "SET_UNITS_TRIGGERED", data: false });
      // yield put({ type: "SET_UNITS_RESPONDED", data: false });
    }
  } catch (e) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OLQ_DoLQ' });
    // history.push("/out-of-franchise");
    console.log('Catch Error', e);
    // yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  } finally {
    // once new saga request has been made, we cancel the old axios request mid-flight.
    // please don't remove.
    if (yield cancelled()) {
      source.cancel();
    }
  }
}


function* checkAvailAPICall({data}) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  const selectedZipcode = yield select(selectors.selectedZipcode);
  const selectedStreetAddress = yield select(selectors.selectedStreetAddress);
  const phoneNumber = yield select(selectors.phoneNumber);
  const email = yield select(selectors.email);
  let selectedUnit = yield select(selectors.selectedUnit);
  if (selectedUnit.unit === "I don't live in a unit")
    selectedUnit = "";
  else
    selectedUnit = selectedUnit.unit;
  const requestBody = {
    "zipCode": selectedStreetAddress.zip,
    "city": selectedStreetAddress.muni || '',
    "state": selectedStreetAddress.state || '',
    "unit": selectedUnit ? selectedUnit : '',
    streetAddress:
      selectedStreetAddress && selectedStreetAddress.dispstr
        ? selectedStreetAddress.dispstr
        : "",
    streetTerm: selectedStreetAddress && selectedStreetAddress.dispstr
      ? selectedStreetAddress.dispstr
      : "",
    unitTerm: "",
    AddressID:
      selectedStreetAddress && selectedStreetAddress.ntasAddrID
        ? selectedStreetAddress.ntasAddrID
        : "",
    rawaddr: "",
    BaseAddressID:
      selectedStreetAddress && selectedStreetAddress.baseAddressId
        ? selectedStreetAddress.baseAddressId
        : selectedStreetAddress && selectedStreetAddress.ntasAddrID
          ? selectedStreetAddress.ntasAddrID : "0",
    "Retry": "Y",
    "RememberMe": "",
    "IsNonDO": "N",
    "TelephNoLQ": phoneNumber ? phoneNumber?.replace(/-/g, "") : "",
    "EmailLQ": email || "",
    "InternalTest": "",
    "GUID": Math.random().toString()?.replace('.', ''),  // added from .net 
    "FromAmazonURL": "",
    "OneFiberOverlay": "N",
    "AmexOverlay": "",
    "FromAmexMLP": "N",
    "CloverMLP": "N",
    "page_URL": window.location.href,
    "campaign_Id": "Messsage=UNKNOWN",
    "EntryPoint": "",
    "VeteranDiscount": "N",
    "VZWTN": phoneNumber ? phoneNumber?.replace(/-/g, "") : ""

  }

  try {

    const response_checkoffr = yield apiClient.post(CHECK_VZW_URL, requestBody);
    if (response_checkoffr) {
      // const lqPostData = yield select(selectors.lqPostData);
      // const addressQualificationDetails = yield select(selectors.addressQualificationDetails);
      // if (lqPostData?.FiOSDataStatus != "Y" && !addressQualificationDetails?.HasMultipleAddress) {
      //     yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      // }

      //yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      yield put({ type: "SAVE_CHECKAVAIL_RES", data: response_checkoffr.data });
      // if (lqPostData?.FiOSDataStatus != "Y") {
      //   yield* checkWirelessEligibilty();
      //   }
      yield* assignVBMValues(response_checkoffr?.data?.VBMQuotes);
      yield* assignJointOfferValues(response_checkoffr?.data);
      dispatchEvent('recievedDoLoopResponse', true);
      if(data.callback && typeof data.callback == 'function') {
        yield delay(1000)
        data.callback()
      }
    }
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  } catch (e) {
    // call checkAvailability api again without user interaction and stop retry after 1st retry.
    // if (data?.stopRetry) {
    // to reset the lq page and show error message for check availability failure.
    yield put({ type: 'SAVE_ZIPCODE_ENTERED_BY_USER', data: '' });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: 'Could not process your previous request. Please try again by entering details!.' } });
    window.scroll(0, 0);
    // } else {
    //   yield* checkAvailAPICall({ stopRetry: true });
    // }
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    //yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log(e)
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* checkAvailAPICallVcg({data}) {

  const selectedZipcode = yield select(selectors?.selectedZipcode);
  const selectedStreetAddress = yield select(selectors?.selectedStreetAddress) || {};
  const { phoneNumber, email, } = data || {};
  let selectedUnit = yield select(selectors?.selectedUnit) || {};
  if (selectedUnit?.unit === "I don't live in a unit")
    selectedUnit = "";
  else
    selectedUnit = selectedUnit?.unit;
  const requestBody = {
    "zipCode": selectedStreetAddress?.zip ? selectedStreetAddress?.zip : data?.Zip ? data?.Zip : '',
    "city": selectedStreetAddress?.muni || '',
    "state": selectedStreetAddress?.state ? selectedStreetAddress?.state : data?.State ? data?.State : '',
    "unit": selectedUnit ? selectedUnit : '',
    streetAddress:
      selectedStreetAddress?.dispstr
        ? selectedStreetAddress?.dispstr
        : data?.Address ? data?.Address : "",
    streetTerm: selectedStreetAddress && selectedStreetAddress?.dispstr
      ? selectedStreetAddress?.dispstr
      : data?.Address ? data?.Address : "",
    unitTerm: "",
    AddressID:
      selectedStreetAddress?.ntasAddrID
        ? selectedStreetAddress?.ntasAddrID
        : "",
    rawaddr: "",
    BaseAddressID:
      selectedStreetAddress?.baseAddressId
        ? selectedStreetAddress?.baseAddressId
        : selectedStreetAddress?.ntasAddrID
          ? selectedStreetAddress?.ntasAddrID : "0",
    "Retry": "Y",
    "RememberMe": "",
    "IsNonDO": "N",
    "TelephNoLQ": phoneNumber ? phoneNumber?.replace(/-/g, "") : "",
    "EmailLQ": email || "",
    "InternalTest": "",
    "GUID": Math.random().toString()?.replace('.', ''),  // added from .net 
    "FromAmazonURL": "",
    "OneFiberOverlay": "N",
    "AmexOverlay": "",
    "FromAmexMLP": "N",
    "CloverMLP": "N",
    "page_URL": window.location.href,
    "campaign_Id": "Messsage=UNKNOWN",
    "EntryPoint": "",
    "VeteranDiscount": "N",
    "VZWTN": phoneNumber ? phoneNumber?.replace(/-/g, "") : ""

  }

  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    const response_checkoffr = yield apiClient.post(CHECK_VZW_URL, requestBody);
    if (response_checkoffr) {
      //yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      yield put({ type: "SAVE_CHECKAVAIL_RES", data: response_checkoffr?.data });
      yield put({ type: "SET_VCG_CHECK_AVAIL_DONE", data: true });
      yield* assignVBMValues(response_checkoffr?.data?.VBMQuotes);
      yield* assignJointOfferValues(response_checkoffr?.data);
      dispatchEvent('recievedDoLoopResponse', true);
      if(data.callback && typeof data.callback == 'function') {
        yield delay(1000)
        data.callback()
      }
    }
  } catch (e) {
    // call checkAvailability api again without user interaction and stop retry after 1st retry.
    // if (data?.stopRetry) {
    // to reset the lq page and show error message for check availability failure.
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: 'SAVE_ZIPCODE_ENTERED_BY_USER', data: '' });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: 'Could not process your previous request. Please try again by entering details!.' } });
    window.scroll(0, 0);
    // } else {
    //   yield* checkAvailAPICall({ stopRetry: true });
    // }
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    //yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log(e)
  }
  finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* checkWirelessEligibilty() {
  const selectedZipcode = yield select(selectors.selectedZipcode);
  const selectedStreetAddress = yield select(selectors.selectedStreetAddress);
  const phoneNumber = yield select(selectors.phoneNumber);
  const email = yield select(selectors.email);
  let selectedUnit = yield select(selectors.selectedUnit);
  const addressQualificationDetails = yield select(selectors.addressQualificationDetails);
  if (selectedUnit.unit === "I don't live in a unit")
    selectedUnit = "";
  else
    selectedUnit = selectedUnit.unit;
  const requestBody = {
    "zipCode": selectedStreetAddress.zip,
    "city": selectedStreetAddress.muni || '',
    "state": selectedStreetAddress.state || '',
    "unit": selectedUnit ? selectedUnit : '',
    streetAddress:
      selectedStreetAddress && selectedStreetAddress.dispstr
        ? selectedStreetAddress.dispstr
        : "",
    streetTerm: selectedStreetAddress && selectedStreetAddress.dispstr
      ? selectedStreetAddress.dispstr
      : "",
    unitTerm: "",
    AddressID:
      selectedStreetAddress && selectedStreetAddress.ntasAddrID
        ? selectedStreetAddress.ntasAddrID
        : "",
    rawaddr: "",
    BaseAddressID:
      selectedStreetAddress && selectedStreetAddress.baseAddressId
        ? selectedStreetAddress.baseAddressId
        : selectedStreetAddress && selectedStreetAddress.ntasAddrID
          ? selectedStreetAddress.ntasAddrID : "0",
    "Retry": "Y",
    "RememberMe": "",
    "IsNonDO": "N",
    "TelephNoLQ": phoneNumber ? phoneNumber?.replace(/-/g, "") : "",
    "EmailLQ": email || "",
    "InternalTest": "",
    "GUID": Math.random().toString()?.replace('.', ''),  // added from .net 
    "FromAmazonURL": "",
    "OneFiberOverlay": "N",
    "AmexOverlay": "",
    "FromAmexMLP": "N",
    "CloverMLP": "N",
    "page_URL": window.location.href,
    "campaign_Id": "Messsage=UNKNOWN",
    "EntryPoint": "",
    "VeteranDiscount": "N",
    "VZWTN": phoneNumber ? phoneNumber?.replace(/-/g, "") : ""

  }
  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    let response = yield apiClient.post(CHECK_WIRELESS_ELIGIBILTY_URL, requestBody);
    if (response?.data?.Qualified == "true") {
      SiteAnalytics.track5GEligibleRedirection();
      const event = { data: { log: "Redirecting to 5G", eventType: 'log', doLoopSessionId: addressQualificationDetails?.sessionId, eventName: "5G_PageLoad", sectionName: "Page", sync: true } }
      yield call(postEventLogging, event);
      window.location.href = REDIRECT_5G_URL + `?redirectedFrom=BBA&lqsessionId=${addressQualificationDetails?.GUISessionId}${cmpOfferEnable ? "&cmp=int:int:ac:smb:fw_jo:joint_offer_lq" : ""}`
    } else {
      SiteAnalytics.track4GEligibleRedirection();
      const event = { data: { log: "Redirecting to 4G", eventType: 'log', doLoopSessionId: addressQualificationDetails?.sessionId, eventName: "4G_PageLoad", sectionName: "Page", sync: true } }
      yield call(postEventLogging, event);
      window.location.href = REDIRECT_4G_URL + `?redirectedFrom=BBA`
    }
  }
  catch (err) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    //  const event= {data: { type: 'Error', log:"Redirecting to 4G", eventType: 'log',  doLoopSessionId: addressQualificationDetails?.sessionId, eventName: "4G_PageLoad", sectionName: "Page" } }
    //   // yield call(postEventLogging,event);
    //   if ( !isNightTimeWindow()) {
    //     SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
    //     SiteCatalyst.trackProductsList(window.LQResponse);
    //     SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
    //     SiteCatalyst.trackLQSuccess4G(window.LQRequestBody, { type: '4G/LTE Redirection', data: window.LQResponse });
    //     if (window?.newrelic?.addPageAction) {
    //       window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
    //       window.newrelic.addPageAction('LQSuccess4G', { data: window.LQRequestBody });
    //     }
    //   }
    //   yield put({ type: 'POST_EVENT_LOGGING', data: event.data });
    //   window.location.href= REDIRECT_4G_URL+`?AddressLine1=${requestBody.streetAddress}&City=${requestBody.city}&State=${requestBody.state}&Zip=${requestBody.zipCode}&Qualified4GHome=${""}&redirectedFrom=BBA`
  }
}


function* assignVBMValues(VBMQuotes) {
  try {
    yield put({ type: "SAVE_OPTIX_ADDRESS_QUALIFICATION_DETAILS", data: VBMQuotes });
    dispatchEvent('recievedOptixAddressQualificationResponse', true);
  } catch (e) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "SKIP_OPTIX_FLOW_DUE_TO_API_FAILURE", data: true });
    dispatchEvent('recievedOptixAddressQualificationResponse', true);
  }
}

function* assignJointOfferValues(values) {
  yield put({ type: "SAVE_JOINT_OFFER_DETAILS", data: values });
}

export function* fetchPendingOrder(requestBody, config) {
  try {
    //  const response = {
    //    data:{
    //     "HasPendingOrder":true,
    //     "req" : requestBody,
    //     "config": config
    //    }
    //  }

    yield put({ type: "PENDING_ORDER_RESPONSE_INPROGRESS", data: true });

    const response = yield apiClient.post(IS_PENDING_ORDER_URL, requestBody, config);
    yield put({ type: "SET_PENDING_ORDER_RESPONSE", data: response?.data });
    if (response?.data?.HasPendingOrder) {
      yield put({ type: "HAS_PENDING_ORDER", data: true });
      // yield put({ type: "DISABLE_CHECK_AVAILABILITY", data: false });
    } else {
      yield put({ type: "HAS_PENDING_ORDER", data: false });
    }
    yield put({ type: "PENDING_ORDER_RESPONSE_INPROGRESS", data: false });
    dispatchEvent('recievedDoLoopResponse', true);
    const doLoopTriggered = yield select(selectors.doLoopTriggered);
    if (!doLoopTriggered) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
  }
  catch (err) {
    yield put({ type: "HAS_PENDING_ORDER", data: false });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "SET_PENDING_ORDER_RESPONSE", data: "failed" });
    dispatchEvent('recievedDoLoopResponse', true);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "PENDING_ORDER_RESPONSE_INPROGRESS", data: false });

  }
}
export function* fetchCustomizeProducts(reqFrom, isCheckout) {
  try {
    const doLoopResponse = yield select(selectors.addressQualificationDetails);
    // if (reqFrom === 'Retrieve' && isCheckout) {
    if(!doLoopResponse?.DataInfo){
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    }
    const retrieveCartID = yield select(selectors.retrieveCartID);
    const formData = { bannerId: '', fiosPresale: '', fetchProduct: 'ALL' };
    const params = new URLSearchParams();
    Object.keys(formData).forEach(key => {
      const value = formData[key];
      params.append(key, value);
    });
    yield put({ type: "CUST_API_TRIGGERED", data: true });
    let response = yield apiClient.get(GET_CUSTOMIZE_PRODUCTS_URL);

    if (response.data?.BDVFIOSTP?.Plans) {
      response.data.BDVFIOSTP.Plans = response.data.BDVFIOSTP.Plans.map(e => ({
        ProductId: e?.DataProductId,
        PackageId: e?.DataPackageId, ...e
      }))
    }
    if (response.data?.FlexInfo?.Plans) {
      response.data.FlexInfo.Plans = response.data.FlexInfo.Plans.map(e => ({
        ProductId: e?.DataProductId,
        PackageId: e?.DataPackageId, ...e
      }))
    }
    yield put({ type: "SET_CUSTOMIZE_PRODUCTS_DATA", data: response.data });

    // Initially load standalone bdv resp
    if (!retrieveCartID) {
      const iBDVInfo = JSON.parse(JSON.stringify(response?.data?.BDVFIOSDP))
      const iEquipmentList = getBDVEquipments(iBDVInfo);
      yield put({ type: "UPDATE_BDV_EQUIPMENTS", data: iEquipmentList });
    }


    window.customizeProductsCompleted = true;
    window.customizeProductsResponse = response?.data;
    //window.localStorage.setItem('customizeProductsCompleted', "true");
    dispatchEvent('recievedCustomizeProductResponse', true);
    const pendingOrderResponseInProgress = yield select(selectors.pendingOrderResponseInProgress);
    if (!pendingOrderResponseInProgress) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }

    if (reqFrom === 'Retrieve' && isCheckout) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }

    const bundleRecommendFlow = yield select(selectors.bundleRecommendFlow);
    const bannerInfo = yield select(selectors.bannerInfo);
    if (bundleRecommendFlow && reqFrom !== 'Retrieve') {

      if (response.data?.BDVFIOSDP) {
        let bundleInfo = response.data?.BDVFIOSDP.Plans && response.data?.BDVFIOSDP.Plans[0];
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA_BDV });
        yield put({ type: "SET_ROUTER_LIST", data: response?.data?.BDVFIOSDP?.Routers });

        const FiosBdvFormData = {
          bundleID: bundleInfo?.BundleId,
          dpackgeId: bundleInfo?.PackageId,
          dHcid: bundleInfo?.ProductId,
          contract: bundleInfo?.Contract,
          bdvID: bundleInfo?.BDVId,
          ptype: bundleInfo?.Flowtype,
          bRc: bundleInfo?.Price,
          Nlines: 1,
          upselSelected: false,
          TVPackageId: 0,
          TVHCID: 0,
        };
        let isSelectedBundlePlan = response.data?.BDVFIOSDP?.Plans.find((item) => {
          return item?.IsSelected === true;
        });

        yield put({ type: "UPDATE_INTERNET_PLAN_ID", internetPlanID: isSelectedBundlePlan?.ProductId });
        yield* getCustomizeBDVFiosBundleInfo({ params: { FiosBdvFormData: FiosBdvFormData } });
        yield put({
          type: "UPDATE_SELECTED_INTERNET_PLAN", params: {
            bundleID: bundleInfo?.ProductId?.toString(),
            hcid: bundleInfo?.PackageId?.toString(), ProductName: bundleInfo?.ProductName
          }
        });
        yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: 'FIOS' });
      } else if (response.data?.HSIBundleInfo) {
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI_PHONE });
        yield put({ type: "UPDATE_PHONE_SERVICES", params: BUNDLE.PHONE });

        yield put({ type: "SET_ROUTER_LIST", data: response?.data?.HSIBundleInfo?.Routers });

        let filteredNeedPrds = response.data?.HSIBundleInfo?.Plans?.length && response.data?.HSIBundleInfo.Plans.filter(eachInfo => {
          return (eachInfo.IPType === "Dynamic");
        });

        let filteredAllProds = filteredNeedPrds?.length && filteredNeedPrds.filter(eachInfo => {
          return (eachInfo.LineType && eachInfo.LineType === "ALL")
        });

        let bundleHSIInfo = filteredAllProds && (filteredAllProds?.length > 0 ? filteredAllProds[0] : filteredNeedPrds[0])
        const HsiPhoneFormData = {
          bundleID: bundleHSIInfo?.BundleId,
          tvID: 0,
          nLines: 1,
          contract: bundleHSIInfo?.Contract,
          hcid: bundleHSIInfo?.ProductId || 0,
          ptype: bundleHSIInfo?.Flowtype,
          bRc: bundleHSIInfo?.Price,
          upselSelected: false,
        };
        yield put({ type: "UPDATE_INTERNET_PLAN_ID", internetPlanID: bundleHSIInfo?.ProductId });

        yield* getCustomizeHSIPhoneBundleInfo({ params: { HsiPhoneFormData: HsiPhoneFormData } });
        yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: 'DSL' });
      } else {
        if (response?.data?.DataInfo) {
          let params = {
            url: "",
            type: 'data'
          }
          if (response.data?.DataInfo?.Plans[0]?.ServiceType === "DSL") {
            params.url = GET_BASIC_INTERNET_DATA_URL;
          } else {
            params.url = GET_FIOS_INTERNET_DATA_URL;
          }
          yield put({ type: "SET_INTERNET_TYPE", data: response?.data?.DataInfo?.Plans[0]?.ServiceType });
          yield put({ type: "SET_ROUTER_LIST", data: response?.data?.DataInfo?.Routers });

          let internetPlanData = response?.data?.DataInfo?.Plans[0];
          const infoParams = {
            bundleID: internetPlanData?.PackageId,
            tvID: 0,
            nLines: 1,
            contract: internetPlanData?.Contract,
            hcid: internetPlanData?.ProductId ? internetPlanData?.ProductId : '',
            ptype: internetPlanData?.ServiceType ? internetPlanData?.ServiceType : '',
            bRc: internetPlanData?.Price,
            upselSelected: false
          };
          const newFlowInternetType = infoParams.ptype;
          yield* getSelectedBundleInfo({ infoParams, params }, true);
          yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: newFlowInternetType });
        }
        if (!response?.data?.DataInfo && response?.data?.PhoneInfo) {
          const bundleID = response?.data?.PhoneInfo[0]?.BID;
          const bRc = response?.data?.PhoneInfo[0]?.BundleRC;
          const preferredvoiceFormData = `BID=${bundleID}&RC=${bRc}&nlines=1`;
          yield* getPreferredvoiceData({ params: preferredvoiceFormData });
        }
      }
    }


    const cid = yield select(selectors.cid);
    // Banner flow implementation
    if (bannerInfo && (!retrieveCartID && !cid)) {
      yield* processBannerProductCall(response);
    }

    const lqPostData = yield select(selectors.lqPostData);
    if (lqPostData?.HSIStatus === "N" && lqPostData?.FiOSDataStatus === "N"
      && lqPostData?.PhoneStatus === "Y") {
      if (response.data?.PhoneInfo?.TNList?.TNObject?.length === 0) {
        yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_PS_GETPREFEREDVOICE_BTNEmpty' });
        yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
      }
    }
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });
  } finally {
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

export function* getVasDisplayCradle() {
  const payload = {
    "pageName": "customizeOrder",
    "flow": "VasDisplay"
  }
  try {
    let response = yield apiClient.post(GET_GBCOMCREADLE_DETAILS_URL, payload);
    const trialType = JSON.parse(response?.data?.outPut)?.trialType;
    if (trialType == "gborder_vasdisplay") {
      yield put({ type: "SET_VAS_DISPLAY_RESP", data: true });

    } else {
      yield put({ type: "SET_VAS_DISPLAY_RESP", data: false });
    }
  }
  catch (err) {
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "SET_VAS_DISPLAY_RESP", data: false });
  }

}

export function* getABLogic() {
  const payload = {
    "pageName": "customizeOrder",
    "flow": "bdvbundle"
  }
  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    let response = yield apiClient.post(GET_GBCOMCREADLE_DETAILS_URL, payload);
    if (response?.data?.outPut?.includes("bdvbundledefault")) {
      yield put({ type: "SET_AB_LOGIC_RESP", data: { HasABLogic: 'Y' } });

    } else {
      yield put({ type: "SET_AB_LOGIC_RESP", data: { HasABLogic: 'N' } });
    }
  }
  catch (err) {
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "SET_AB_LOGIC_RESP", data: {} });
  }
}
export function* getGBCradleBusinessSolutionsLogic() {
  const payload = {
    "pageName": "customizeOrder",
    "flow": "businessSolutions"
  }
  try {
    let response = yield apiClient.post(GET_GBCOMCREADLE_DETAILS_URL, payload);
    if (response?.data?.outPut?.includes("businesssolutions")) {
      yield put({ type: "SET_BUSINESS_SOLUTION_LOGIC", data: true });

    } else {
      yield put({ type: "SET_BUSINESS_SOLUTION_LOGIC", data: false });
    }
  }
  catch (err) {
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "SET_BUSINESS_SOLUTION_LOGIC", data: false });
  }
}

function* fetchOwnNumber(request) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });

  const { params } = request;

  try {
    const response = yield apiClient.post(WINBACK_QUALIFICATION_URL, params);
    yield put({ type: "USE_YOUR_OWN_NUMBER", data: response.data });
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    console.log('Catch Error', err);
  }
  finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* fetchJointOfferInfo(params) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "JOINT_OFFER_AVAILABILITY_RESPONSE", data: "" });
  yield put({
    type: "SAVE_JOINT_OFFER_DETAILS", data: ""
  });
  try {
    let response = yield apiClient.get(JOINT_OFFER_AVAILABILITY + `?BTNumber=${params.tn}`)
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    if (response?.data?.JointofferStatus === 'Y') {
      yield call(getFloatingCartDetails);
    }
    if (response?.data?.JointOfferPrice?.includes("-")) {
      response.data.JointOfferPrice = response?.data?.JointOfferPrice?.replaceAll("-", "");
    }
    if (response?.data) {
      response.data.jointOfferPreSelected = false;
    }
    yield put({ type: "JOINT_OFFER_AVAILABILITY_RESPONSE", data: response.data === "" ? "Not Eligible" : response.data });
    yield put({
      type: "SAVE_JOINT_OFFER_DETAILS", data: {
        JointOfferPrice: response.data.JointOfferPrice,
        JointOfferStatus: response.data.JointofferStatus,
        OneGigSpeedPrice: response.data.OneGigSpeedPrice
      }
    });

  }
  catch (err) {
    yield put({ type: "JOINT_OFFER_AVAILABILITY_RESPONSE", data: false });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* fetchvzwofferEligibility(params) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "VZW_OFFER_ELIGIBLITY_RESPONSE", data: "" });
  try {
    let response = yield apiClient.get(GET_VZW_OFFER_ELIGIBILITY + `?BTN=${params.tn}`)
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "VZW_OFFER_ELIGIBLITY_RESPONSE", data: response.data });
    yield put({ type: 'VZW_OFFER_ELIGIBLITY_RESPONSE_STATUS', data:"SUCCESS"});
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
  catch (err) {
    yield put({ type: "VZW_OFFER_ELIGIBLITY_RESPONSE", data: false });
    yield put({ type: 'VZW_OFFER_ELIGIBLITY_RESPONSE_STATUS', data:"FAILURE"});
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  } 
}


function* fetchYellowPageHeadings(request) {
  const { params } = request;
  yield put({ type: "GET_YELLOW_PAGE_RES", data: [] });
  const response = yield apiClient.get(YPH_URL + (params || ""))
    /* Commenting Below line is for local mock json pointing */
    // const response = yield apiClient.get("http://localhost:3001/yellowPageHeadings" + params)
    .then(response => {
      if (response.data?.length === 1 && response.data[0].includes('re-enter')) {
        return [];
      }
      return response.data;
    })
    .catch(error => ({ error }));
  // yield put({ type: "GET_YELLOW_PAGE_RES", data: { data: [] } });
  yield put({ type: "GET_YELLOW_PAGE_RES", data: response });
}



function* fetchInternetData(request) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  const { params } = request;
  const response = yield apiClient.get(params.url)
    .then(response => {
      return response.data;
    })
    .catch(error => ({ error }));

  yield put({ type: "GET_INTERNET_FLOW_RES", data: response });
  // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
}

function eventFire(el, etype) {
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}
// New API used
export function* getSABDV(request) {

  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  // yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  const { params } = request;
  const customizeProductsResponse = yield select(selectors.customizeProductsResponse);
  const addressQualificationDetails = yield select(selectors.addressQualificationDetails);
  try {
    const response = yield apiClient.post(GET_SABDV_URL, params)
      .then(response => {
        return response.data;
      });
    if (response === "BDVTNFail" || response.APIstatus === 'BDVTNFail') {
      yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_PS_GetSABDV', error: response } });
    }
    yield put({ type: "SET_BDV_TN_COUNT", data: 1 });
    yield put({ type: "SET_GET_BDV_TN_RESP", data: response?.TNList?.TNObject });
    yield put({ type: "GET_SABDV_RESPONSE", data: response });
    yield put({ type: "UPDATE_PHONE_SERVICES", params: BUNDLE.BDV });
    yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV });
    const BDVInfo = JSON.parse(JSON.stringify(customizeProductsResponse?.BDVInfo));
    // let objIndex = BDVInfo?.BDVEquip.findIndex((obj => obj.ProductId == "25441894"));
    // if (BDVInfo.BDVEquip[objIndex].Quantity === 0 || BDVInfo.BDVEquip[objIndex].Quantity === "0") {
    //   BDVInfo.BDVEquip[objIndex].Quantity = 1;
    //   BDVInfo.BDVEquip[objIndex].IsSelected = true;
    // }
    const equipmentList = getBDVEquipments(BDVInfo);
    yield put({ type: "UPDATE_BDV_EQUIPMENTS", data: equipmentList });

    let TNObject = customizeProductsResponse?.BDVInfo?.TNList?.TNObject;
    if (!TNObject || TNObject?.length === 0 || addressQualificationDetails?.IsCachePM === true) {
      TNObject = response?.TNList?.TNObject;
      if (TNObject && TNObject?.length !== 0) {
        yield put({
          type: "UPDATE_TN_LISTING_FROM_PROD_CALL", data: {
            key: 'BDVInfo',
            value: {
              TNList: response?.TNList,
              FaxLineInfo: response?.FaxLineInfo,
              FaxTNList: response?.FaxTNList
            }
          }
        });
      }
    }
    const tn = TNObject?.length ? TNObject[0].TN : "";
    if (!TNObject || TNObject?.length === 0) {
      yield put({ type: "BTN_EMPTY", data: true });
    }
    yield put({ type: "UPDATE_TN_FOR_LISTING", data: tn });
    if (!TNObject || TNObject?.length === 0) {
      yield localStorage.setItem('LOAD_FIOS_DATA','true')
      yield put({ type: "ONLY_SA_FIOS", data: true });
      yield window.location.reload() 
      // yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OLQ_BTNEmpty' });
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
    }
    if(response.TNList.TNObject){
      let bdvSubsLines = []
      let responses=response.TNList.TNObject.length>1?response.TNList.TNObject.slice(0,1):response.TNList.TNObject;
      responses.map((data,i)=>{
                bdvSubsLines.push({
                    LineNO:i+1,
                    OldTN:(data['TN']).replace(/-/g, ""),
                    OldPlanID:data['ProductID'],
                    OldIsWB:"",
                    NewTN:(data['TN']).replace(/-/g, ""),
                    NewPlanID:data['ProductID'],
                    NewIsWB:"",
                    selected:"desktop"
                })
            })
          yield put({ type: "SET_BDVW_PHONE_LINES", data: bdvSubsLines });
      }


    if (response?.planDetails) {
      yield* processFloatingCartDetails(response);
    } else {
      yield call(getFloatingCartDetails);
    }

  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });
    yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_PS_GetSABDV', error: err } });
  }
}

// New api used
function* getPreferredvoiceData(request) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  //yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: true });
  const customizeProductsResponse = yield select(selectors.customizeProductsResponse);
  const lqPostData = yield select(selectors.lqPostData);
  const { params } = request
  try {
    const response = yield apiClient.post(GET_PREFERRED_VOICE_URL, params)
      .then(response => {
        return response.data;
      });
    if (response === "RequestTNFail" || response?.APIstatus === 'RequestTNFail') {
      yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_PS_RequestTNFailure', error: response } });
      yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_PS_GETPREFEREDVOICE_BTNEmpty' });
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
    }
    yield put({ type: "GET_PREFERRED_VOICE_RESPONSE", data: response });
    yield put({ type: "UPDATE_PHONE_SERVICES", params: BUNDLE.PHONE });
    yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE });
    yield put({ type: "USE_YOUR_OWN_NUMBER", data: '' });
    const tn = customizeProductsResponse && customizeProductsResponse?.PhoneInfo?.TNList?.TNObject?.length ?
      customizeProductsResponse?.PhoneInfo?.TNList?.TNObject[0].TN : "";
    yield put({ type: "UPDATE_TN_FOR_LISTING", data: tn });

   
     if(lqPostData?.HSIStatus == "Y" && response?.TNList == null)
    {
      yield put({ type: "BTN_EMPTY", data: true });
      yield localStorage.setItem('LOAD_FIOS_DATA','true')
      yield put({ type: "ONLY_SA_FIOS", data: true });
      yield window.location.reload() 
      // yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OLQ_BTNEmpty' });
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
    }
    if(lqPostData?.HSIStatus === "Y"  && response?.TNList)
{
  let  TNData  = response?.TNList; 
let TNObject = TNData?.TNObject;

  
  if(TNObject?.length == 0 )
  {
    yield put({ type: "BTN_EMPTY", data: true });
    yield localStorage.setItem('LOAD_FIOS_DATA','true')
    yield put({ type: "ONLY_SA_FIOS", data: true });
    yield window.location.reload() 
    // yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OLQ_BTNEmpty' });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
  }
  yield put({ type: "IS_Phone", data: true });
  yield put({ type: "SAVE_SELECTED_BUNDLE_TN", data: response });

}
    // if (lqPostData?.HSIStatus === "Y") {
    //   if (customizeProductsResponse?.PhoneInfo?.TNList?.TNObject?.length === 0) {
    //     yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_PS_GETPREFEREDVOICE_BTNEmpty' });
    //     yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TN_FAIL } });
    //   }
    // }

    if (response?.planDetails) {
      yield* processFloatingCartDetails(response);
    } else {
      yield call(getFloatingCartDetails);
    }
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "FLOATING_CART_LOADING_SPINNER", data: false });


  } finally {
    // yield call(getFloatingCartDetails);
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}


function* fetchSaveCartInfo(request) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  try {
    const response = yield apiClient.post(SAVE_ORDER_URL)
    yield* submitSaveCart(request);
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_SO_SaveMyOrder' });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  }
}

function* SubmitIdeForm(params) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  try {
    const response = yield apiClient.post(SUBMIT_IDE, params.data);
    if (response?.data) {
      params.history.push("/Thank-you");
    }
  }
  catch (err) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  }
}

function* submitSaveCart(request) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  const { params } = request

  try {
    try {
      const response = yield apiClient.post(SAVE_CART_INFO_URL, params)
        .then(response => {
          return response.data;
        });
      yield put({ type: "SAVE_CART_INFO_RESPONSE", data: response });
      SiteCatalyst.trackSaveCart(request, response);
    } catch (err) {
      yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
      console.log(err);
    }
    const response1 = yield apiClient.get(SAVE_ORDER_CONFIRMATION_URL)
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    request.history ? request.history.push('/save-cart-confirmation') : yield put({ type: "SAVE_CART_SUCCESS_BANNER", data: true });
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_SO_DOSaveOrder' });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* doLOAConfirmation(params) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  const ccdata = yield select(selectors.creditCheckInfo);
  const data = params.data;
  const requestBody = {
    Sole_DOB: ccdata.soleOwner.dob,
    Sole_SSN: encryptionUsingCrypto(ccdata.soleOwner.ssn),
    Sole_SSnDonotwise: ccdata.soleOwner.isNoSsn ? "nowish" : "nowish",
    pn1_DOB: ccdata.partner1.dob ? ccdata.partner1.dob : "0/0/0",
    pn1_SSN: encryptionUsingCrypto(ccdata.partner1.ssn),
    pn1_SSnDonotwise: ccdata.partner1.isNoSsn ? true : false,
    pn2_DOB: ccdata.partner2.dob ? ccdata.partner2.dob : "0/0/0",
    pn2_SSN: encryptionUsingCrypto(ccdata.partner2.ssn),
    pn2_SSnDonotwise: ccdata.partner2.isNoSsn ? true : false,
    Corp_Taxid: ccdata.corporation.taxIdNumber ? encryptionUsingCrypto(ccdata.corporation.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : '',
    LSProvider: data.localService ? 'on' : 'off',
    intraLATA: data.intraLATA ? 'on' : 'off',
    interLATA: data.interLATA ? 'on' : 'off',
    LOA_Date: data.tDate,
    LOA_FirstName: data.firstName,
    LOA_LastName: data.lastName,
    LOAContno: data.cNumber
  }
  try {
    const response = yield apiClient.post(UPDATE_LOA_URL, requestBody);
    if (response?.data) {
      const LOAStatus = response?.data;
      yield put({ type: "SAVE_LOA_CONFIRMATION", data: LOAStatus });
    }
  } catch (e) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    console.log(e);
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

/*function* doOptixLOAConfirmation(data) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  const optixSessionId = yield select(selectors.optixSessionId);
  const optixAddressQualificationDetails = yield select(selectors.optixAddressQualificationDetails);
  const priceQuotesSetField = optixAddressQualificationDetails?.quoteResultsField?.priceQuotesSetField;
  const monField = priceQuotesSetField && priceQuotesSetField.length > 0 ? priceQuotesSetField[priceQuotesSetField.length - 1].monField : "";

  const requestBody = {
    "SessionId": optixSessionId,
    "Client": {},
    "LOAConfirmation": {
      "MON": monField,
      "DigitalTPV": "N",
      "TPVCode": ""
    }
  };

  try {
    const response = yield apiClient.post(OMNI_LOA_CONFIRMATION, requestBody);
    if (response?.data) {
      const omniLOA = response?.data.statusField;
      yield put({ type: "SAVE_OMNI_LOA_CONFIRMATION", data: omniLOA });
    }
  } catch (e) {
    console.log(e);
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}*/


function* doBusinessValidation(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  yield put({ type: 'SAVE_PERSONAL_INFO', data: props.data });
  yield put({ type: 'VZW_OFFER_ELIGIBLITY_RESPONSE_STATUS', data:"PENDING"});

  const { contactInfo, businessInfo, shippingInfo } = props.data;

  const creditCheckInfo = yield select(selectors.creditCheckInfo);
  const phoneNumber = yield select(selectors.phoneNumber);
  const lqPostData = yield select(selectors.lqPostData);
  if (!creditCheckInfo?.soleOwner?.firstName) {
    yield put({ type: 'AUTOFILL_DATA_FOR_CREDITCHECK', data: contactInfo });
  }

  const busStartHour = yield select(selectors.busStartHour);
  const busEndHour = yield select(selectors.busEndHour);
  const enableNewLowerFunnelFlag = CheckAEMBoolValue(i18next.t("enableVDS3LF",{ns:"customize-order"}));

  const requestBody = {
    Cont_FirstName: contactInfo.firstName,
    Cont_LastName: contactInfo.lastName,
    Cont_EmailAddress: contactInfo.email,
    Cont_Mobileno: contactInfo.phoneNumber?.replace(/-/g, ""),
    Cont_BusinessName: contactInfo.businessName,
    PhonenoType: "MobileNo",
    EmailReceive: contactInfo.selectedMailType === "E" ? true : false,
    useServiceAddressForBilling: enableNewLowerFunnelFlag?businessInfo.selected ? false : true:businessInfo.selected ? true : false,
    StreetAddress: businessInfo.selected ? contactInfo.address : businessInfo.address,
    UnitType: enableNewLowerFunnelFlag?businessInfo.selected ? 'None':contactInfo?.unitType || "":businessInfo.selected ? contactInfo.unitType : 'None',
    UnitNo: businessInfo.unit,
    City: businessInfo.selected ? contactInfo.city : businessInfo.city,
    State: businessInfo.selected ? contactInfo.state : businessInfo.state,
    Zipcode: businessInfo.selected ? contactInfo.zipCode : businessInfo.zipCode,
    AddressId: businessInfo?.steetaddressId || "",
    AttentionName: '',
    useServiceAddressForWBBilling: enableNewLowerFunnelFlag?businessInfo.selected ? false : true:businessInfo.selected,
    ShippingSameService: shippingInfo.selected,
    ShippingStreetAdress: shippingInfo.selected ? contactInfo.address : shippingInfo.address,
    ShippingUnitType: shippingInfo.selected ? contactInfo.unitType : 'None',
    ShippingUnitNo: shippingInfo.selected ? contactInfo.unit : '',
    ShippingCity: shippingInfo.selected ? contactInfo.city : shippingInfo.city,
    ShippingZipcode: shippingInfo.selected ? contactInfo.zipCode : shippingInfo.zipCode,
    ShippingState: shippingInfo.selected ? contactInfo.state : shippingInfo.state,
    BusStartHr: busStartHour ? busStartHour : '0001',
    BusEndHr: busEndHour ? busEndHour : '0010'
  };

  const params = new URLSearchParams();
  Object.keys(requestBody).forEach(key => {
    const value = requestBody[key];
    params.append(key, value);
  });
  const headers = { ...HeadersForFormData, timeout: INCREASED_TIMEOUT };
  const autoPayData = {
    AutopayScript: '',
    AutopayUrl: ''
  };
  const getFloatCartResponse = yield select(selectors.getFloatCartResponse);
  try {
    const response = yield apiClient.post(BUSINESS_INFO_VALIDATION_URL, params, headers);
    if (response && response.data) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      yield put({ type: 'SAVE_BI_VALIDATION_RESPONSE', data: response.data });
      const {EmailValidationStatus,MTNValidationStatus} = response?.data
      if ((response.data.BillAddrValidatedStatus === "SUCCESS" || response.data.BillAddrRetryCount === 3)&&
      (!(EmailValidationStatus === 'INVALID'|| MTNValidationStatus === 'INVALID'))) {
        yield put({ type: 'ACCORDION_COMPLETED', data: { key: 'isPersonalInfoSaved', value: true } });
        yield put({ type: 'TOGGLE_CREDITCHECK_ACCOR' });
        SiteAnalytics.trackComponentLoad('Credit Check Component', { floatCartInfo: getFloatCartResponse });
        SiteAnalytics.trackCCFormInit({ floatCartInfo: getFloatCartResponse });
      }
    }
    if (response.data.AutopayUrl && response.data.AutopayScript) {
      //yield call(fetchAutoPayStatus, response.data);
      autoPayData.AutopayScript = response.data.AutopayScript;
      autoPayData.AutopayUrl = response.data.AutopayUrl;
    }

    if (VZW_OFFER_ELIGIBILITY_FLAG === "true" && lqPostData?.FiOSDataStatus === "Y") {
      yield put({ type: 'VZW_OFFER_ELIGIBLITY_RESPONSE_STATUS', data:"PENDING"});
      const validTN = contactInfo.phoneNumber !== phoneNumber ? contactInfo.phoneNumber?.replace(/-/g, "") : '';
      yield fork(fetchvzwofferEligibility, { tn: validTN });
    }else{
      yield put({ type: 'VZW_OFFER_ELIGIBLITY_RESPONSE_STATUS', data:"SUCCESS"});
    }
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_CO_NextButtonBI', error: err } });
  } finally {
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    //GET_DUE_DATES
    // yield call(getDueDateInfo);
    // if (autoPayData.AutopayUrl !== '' && autoPayData.AutopayScript !== '') {
    //   yield fork(fetchAutoPayStatus, autoPayData);
    // }
  }
}

function* omniBusinessValidation(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  yield put({ type: 'SAVE_PERSONAL_INFO_OPTIX', data: props.data });
  const { contactInfo, businessInfo, shippingInfo } = props.data;
  const optixSessionId = yield select(selectors.optixSessionId);
  const creditCheckInfo = yield select(selectors.optixCreditCheckInfo);
  const phoneNumber = yield select(selectors.phoneNumber);
  const lqPostData = yield select(selectors.lqPostData);
  if (!creditCheckInfo?.soleOwner?.firstName) {
    yield put({ type: 'AUTOFILL_DATA_FOR_OPTIX_CREDITCHECK', data: contactInfo });
  }
  const requestBody = {
    "sessionId": optixSessionId,
    "StreetAddress": businessInfo.selected ? contactInfo.address : businessInfo.address,
    "Zipcode": businessInfo.selected ? contactInfo.zipCode : businessInfo.zipCode,
    "communityName": businessInfo.selected ? contactInfo.city : businessInfo.city,
    "State": businessInfo.selected ? contactInfo.state : businessInfo.state,
    "useServiceAddressForBilling": businessInfo.selected
  }
  try {
    const response = yield apiClient.post(OMNI_BUSINESS_INFO_VALIDATION_URL, requestBody);
    if (response && response.data) {
      const description = response.data?.validateBillingAddressResultField?.requestStatusField?.descriptionField;
      const statusCode = response.data?.validateBillingAddressResultField?.requestStatusField?.statusCodeField;
      const validationStatus = description && description.toUpperCase() === "SUCCESS" && statusCode === 0 ? "SUCCESS" : "FAILURE";
      const BillAddrErrorMsg = validationStatus !== "SUCCESS" ? "Please enter a valid billing address." : null;
      const nextButtonBI = {
        BillAddrValidatedStatus: validationStatus,
        BillAddrErrorMsg,
      }
      yield put({ type: 'SAVE_BI_VALIDATION_RESPONSE_OPTIX', data: nextButtonBI });
    }
    if (VZW_OFFER_ELIGIBILITY_FLAG === "true" && lqPostData?.FiOSDataStatus === "Y") {
      const validTN = contactInfo.phoneNumber !== phoneNumber ? contactInfo.phoneNumber?.replace(/-/g, "") : '';
      yield fork(fetchvzwofferEligibility, { tn: validTN });
    }
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_CO_NextButtonBI', error: err } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}
function encryptionUsingCrypto(ssn){
  if(ssn!==null&&ssn){
    var key = CryptoJS.enc.Utf8.parse('HR$2pIjHR$2pIj12');
    var iv = CryptoJS.enc.Utf8.parse('HR$2pIjHR$2pIj12');
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(ssn), key,
    {
    keySize: 128 / 8,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
    }).toString()
    return encrypted
  }
return ''
}
function* creditCheck(props) {
  const nextButtonBI = yield select(selectors.nextButtonBI);
  const enableNewLowerFunnelFlagC = CheckAEMBoolValue(i18next.t("enableVDS3LF",{ns:"customize-order"}));
  if(nextButtonBI?.RestrictedEmailDomain && enableNewLowerFunnelFlagC){
    yield put({ type: 'SHOW_CREDIT_CHECK_PROGRESS',data:true});
  }else{
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  }

  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });

  const data = props.data;

  yield put({ type: 'SAVE_CREDIT_CHECK_INFO', data });
  const contactInfo = yield select(selectors.contactInfo);
  const businessInfo = yield select(selectors.businessInfo);
  const shippingInfo = yield select(selectors.shippingInfo);
  const busStartHour = yield select(selectors.busStartHour);
  const busEndHour = yield select(selectors.busEndHour);

  let requestBody = {
    Cont_FirstName: contactInfo.firstName,
    Cont_LastName: contactInfo.lastName,
    Cont_EmailAddress: contactInfo.email,
    Cont_Mobileno: contactInfo.phoneNumber?.replace(/-/g, ""),
    PhonenoType: "MobileNo",
    EmailReceive: contactInfo.selectedMailType === "E" ? true : false,
    useServiceAddressForBilling: enableNewLowerFunnelFlagC?businessInfo.selected ? false : true:businessInfo.selected ? true : false,
    StreetAddress: businessInfo.selected ? contactInfo.address : businessInfo.address,
    UnitType: enableNewLowerFunnelFlagC?businessInfo.selected ?'None':contactInfo.unitType || "":businessInfo.selected ? contactInfo.unitType : 'None',
    UnitNo: enableNewLowerFunnelFlagC ? businessInfo?.unit || "" : businessInfo.selected ? contactInfo.unit : '',
    City: businessInfo.selected ? contactInfo.city : businessInfo.city,
    State: businessInfo.selected ? contactInfo.state : businessInfo.state,
    Zipcode: businessInfo.selected ? contactInfo.zipCode : businessInfo.zipCode,
    AddressId: businessInfo?.steetaddressId ||"",
    AttentionName: '',
    useServiceAddressForWBBilling: enableNewLowerFunnelFlagC?businessInfo.selected ? false : true:businessInfo.selected ? true : false,
    ShippingSameService: shippingInfo.selected,
    ShippingStreetAdress: shippingInfo.selected ? contactInfo.address : shippingInfo.address,
    ShippingUnitType: shippingInfo.selected ? contactInfo.unitType : 'None',
    ShippingUnitNo: shippingInfo.selected ? contactInfo.unit : '',
    ShippingCity: shippingInfo.selected ? contactInfo.city : shippingInfo.city,
    ShippingZipcode: shippingInfo.selected ? contactInfo.zipCode : shippingInfo.zipCode,
    ShippingState: shippingInfo.selected ? contactInfo.state : shippingInfo.state,
    BusStartHr: busStartHour ? busStartHour : '0001',
    BusEndHr: busEndHour ? busEndHour : '0010',

    NoofInstall: 0,
    InstallmentBillPrice: 0,
    NoofBdvInstall: 0,
    NoofRouterInstall: 0,
    RouterInstallmentBillPrice: 0,
    BdvInstallmentBillPrice: 0,
    PaperFreeBilling: true,
    OwnerType: data.customerType,
    Sole_BusinessName: contactInfo.businessName,
    Sole_FirstName: data.soleOwner.firstName,
    Sole_MI: data.soleOwner.middleInitial,
    Sole_LastName: data.soleOwner.lastName,
    Sole_DOB: data.soleOwner.dob,
    Sole_SSN: encryptionUsingCrypto(data.soleOwner.ssn),
    Sole_SSnDonotwise: data.soleOwner.isNoSsn ? "nowish" : "nowish",
    PnBusinessName: contactInfo.businessName,
    Pn1_FirstName: data.partner1.firstName,
    Pn1_MI: data.partner1.middileInitial,
    pn1_LastName: data.partner1.lastName,
    pn1_DOB: data.partner1.dob ? data.partner1.dob : "0/0/0",
    pn1_SSN: encryptionUsingCrypto(data.partner1.ssn),
    pn1_SSnDonotwise: data.partner1.isNoSsn ? true : false,
    Pn2_FirstName: data.partner2.firstName,
    Pn2_MI: data.partner2.middileInitial,
    pn2_LastName: data.partner2.lastName,
    pn2_DOB: data.partner2.dob ? data.partner2.dob : "0/0/0",
    pn2_SSN: encryptionUsingCrypto(data.partner2.ssn),
    pn2_SSnDonotwise: data.partner2.isNoSsn ? true : false,
    Corp_BusinessName: contactInfo.businessName,
    Corp_BillingName:data.customerType === 'SCORP'? data.scorp.billingName  : data.customerType === 'LLC' ? data.llc.billingName : data.corporation.billingName,
    Corp_Taxid:data.customerType === 'SCORP' ? (data.scorp.taxIdNumber ? encryptionUsingCrypto(data.scorp.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : '') :   data.customerType === 'LLC' ? (data.llc.taxIdNumber ? encryptionUsingCrypto(data.llc.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : '') : (data.corporation.taxIdNumber ? encryptionUsingCrypto(data.corporation.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : ''),
    // LLC_BillingName: data.llc.billingName,
    // LLC_Taxid: data.llc.taxIdNumber ? encryptionUsingCrypto(data.llc.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : '',
    // SCORP_BillingName: data.scorp.billingName,
    // SCORP_Taxid: data.scorp.taxIdNumber ? encryptionUsingCrypto(data.scorp.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : '',
    SOValidatedStatus: false,
    PartnerValidatedStatus: false,
    CorpValidatedStatus: false,
    CCBpInfo: '',
    CCDepositBpInfo: '',
    PCIEnabled: '',
    FinalBillBpInfo: '',
    creditCheckFailed: data?.creditCheckFailed ? data?.creditCheckFailed : '',
  };

  const params = new URLSearchParams();
  Object.keys(requestBody).forEach(key => {
    const value = requestBody[key];
    params.append(key, value);
  });
  const headers = { ...HeadersForFormData, timeout: INCREASED_TIMEOUT };
  // const autoPayData = {
  //  AutopayScript :'',
  //  AutopayUrl : ''
  // }

  try {
    const VOStatus = yield select(selectors.VOStatus);
    if (VOStatus?.toUpperCase() === 'VOFAIL') {
      yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_VOFailure' });
    }
    const response = yield apiClient.post(CREDIT_CHECK_URL, params, headers);
    if (response && response.data) {
      if(response?.data?.FraudLboPresent === "Y"){
        yield put({ type: "SET_CREDIT_CHECK_LBO", data: true });
        yield put({ type: "REDIRECT_TO_LBO", message: 'CREDITFRAUDALERTLBO' }); 
      }else{
        yield put({ type: "SET_CREDIT_CHECK_LBO", data: false });
      }
      if (response.data.CreditCheckStatus) {
        SiteCatalyst.trackCCStatus(response.data);
      } else {
        SiteCatalyst.trackCCStatus({ error: "Credit Check Failed", response: response.data });
      }
      if (response.data.CreditCheckStatus === "FAILURE") {
        LPErrorEngagement("creditIssue");
      } else {
        LPErrorEngagement("creditCheckSuccess");
      }
      if(!data?.creditCheckFailed){
      yield put({ type: 'SAVE_CC_RESPONSE', data: response.data });
    }
    }else{
      yield put({ type: "SET_CREDIT_CHECK_LBO", data: false });
    }
    // if (response.data.AutopayUrl && response.data.AutopayScript) {
    //   //yield call(fetchAutoPayStatus, response.data);
    //   autoPayData.AutopayScript = response.data.AutopayScript;
    //   autoPayData.AutopayUrl = response.data.AutopayUrl;
    // }
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    SiteCatalyst.trackCCStatus({ error: ERROR_MESSAGE.TECHNICAL_ISSUE, response: err });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_CO_NextButtonCC', error: err } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    // if (autoPayData.AutopayUrl != '' && autoPayData.AutopayScript != '') {      
    //   yield call(fetchAutoPayStatus, autoPayData);
    // }
    yield put({ type: 'SHOW_CREDIT_CHECK_PROGRESS',data:false});
    //GET_DUE_DATES
    const dueDateInfo = yield select(selectors.dueDateInfo);
    if (dueDateInfo?.GetDueDateStatus !== "SUCCESS") {
      yield call(getDueDateInfo, true);
    }
  }
}

function* omniCreditCheck(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });

  const data = props.data;

  yield put({ type: 'SAVE_CREDIT_CHECK_INFO_OPTIX', data });
  const contactInfo = yield select(selectors.optixContactInfo);
  const optixSessionId = yield select(selectors.optixSessionId);
  const ownerTypes = {
    "soleowner": "S",
    "partner": "P",
    "corporation": "N"
  };
  const ownerShip = ownerTypes[data.customerType?.toLowerCase()];
  const soleOwnerDob = data.soleOwner.dob ? data.soleOwner.dob.split("/") : [0, 0, 0];
  const partner1Dob = data.partner1.dob ? data.partner1.dob.split("/") : [0, 0, 0];
  const partner2Dob = data.partner2.dob ? data.partner2.dob.split("/") : [0, 0, 0];
  const isSoleOwner = ownerShip === ownerTypes.soleowner;
  const isPartnership = ownerShip === ownerTypes.partner;
  const dob = isSoleOwner ? soleOwnerDob : partner1Dob;
  const firstName = isSoleOwner ? data.soleOwner.firstName : data.partner1.firstName;
  const lastName = isSoleOwner ? data.soleOwner.lastName : data.partner1.lastName;
  const middleInitial = isSoleOwner ? data.soleOwner.middleInitial : data.partner1.middleInitial;
  const ssn = isSoleOwner ? data.soleOwner.ssn : data.partner1.ssn;

  const requestBody = {
    "client": "",
    "sessionId": optixSessionId,
    "getStoredAssessmentResults": "false",
    "refreshCreditFromICredit": "false",
    "retryCredit": "true",
    "creditInfo": {
      "permitExternalAssessment": true,
      "permitAffiliateSharing": true,
      "TypeOfOwnership": ownerShip,
      "Customer1Info": {
        "SSN": ssn,
        "name": {
          "firstname": firstName,
          "lastname": lastName,
          "middlename": middleInitial
        },
        "dob": {
          "month": dob[0],
          "day": dob[1],
          "year": dob[2]
        }
      },
      "BusCreditInfo": {
        "BusinessName": contactInfo.businessName,
        // "BusinessType": "",
        "LegalCorporationName": data.corporation.billingName,
        "TaxID": data.corporation.taxIdNumber,
        // "IncorporatedState": "",
        // "IncorporatedDate": "",
        // "StateLicensedforBusiness": "",
        // "CorporateEmail": "",
        "Customer2Info": {
          "SSN": data.partner2.ssn,
          "name": {
            "firstname": data.partner2.firstName,
            "lastname": data.partner2.lastName,
            "middlename": data.partner2.middleInitial
          },
          "dob": {
            "month": isPartnership ? partner2Dob[0] : '',
            "day": isPartnership ? partner2Dob[1] : '',
            "year": isPartnership ? partner2Dob[2] : ''
          }
        }
      }
    }
  }
  try {
    // const VOStatus = yield select(selectors.VOStatus);
    // if(VOStatus.toUpperCase() === 'VOFAIL') {
    //   yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_VOFailure' });
    // }
    const response = yield apiClient.post(OMNI_CREDIT_CHECK_URL, requestBody);
    let nextButtonCC = '';
    if (response && response.data) {
      const creditStatus = response.data.outputField.icreditField.creditWorthinessResultField;
      nextButtonCC = {
        CreditCheckStatus: creditStatus?.toLowerCase() === "pass" ? "SUCCESS" : "FAILURE",
        CreditCheckCCRNO: response.data.outputField.icreditField.iCreditRefNoField
      }
      if (nextButtonCC.CreditCheckStatus) {
        SiteCatalyst.trackCCStatus(response.data);
      } else {
        SiteCatalyst.trackCCStatus({ error: "Credit Check Failed", response: response.data });
      }
      if (window?.newrelic?.addPageAction) {
        window.newrelic.addPageAction(creditStatus?.toLowerCase() === "pass" ? "Credit Check Success" : "Credit Check Failure");
      }
      if (creditStatus?.toLowerCase() === "pass") {
        yield call(getOmniDueDateInfo);
      }
      yield put({ type: 'SAVE_CC_RESPONSE_OPTIX', data: nextButtonCC });
    }
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    SiteCatalyst.trackCCStatus({ error: ERROR_MESSAGE.TECHNICAL_ISSUE, response: err });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_CO_NextButtonCC', error: err } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* getDepositScript(data) {
  const response = yield apiClient.get(window.ccPunchOutURL);
  if (response && response.data) {
    const script = document.createElement('script');
    script.innerHTML = response.data;
    document.head.appendChild(script);
  }
}

function* updateCartAfterInstallments() {

  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER_FLOATING_CART", data: true });
    // yield call(getCartInfo);
    yield call(getFloatingCartDetails);
    yield put({ type: "TOGGLE_LOADING_SPINNER_FLOATING_CART", data: false });
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  }
}

function* doInstallmentValidation(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: 'SAVE_IPM_RESPONSE', data: { installmentTriggered: true } });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });

  const data = props.data;
  const installments = yield select(selectors.installmentsInfo);
  const oneTimeInstallmentApplicable = installments.oneTimeInstallmentsPrice !== '';
  const equipmentInstallmentApplicable = installments.equipmentInstallmentsPrice !== '';
  const routerInstallmentApplicable = installments.routertInstallmentsPrice !== '';
  const contactInfo = yield select(selectors.contactInfo);
  const businessInfo = yield select(selectors.businessInfo);
  const shippingInfo = yield select(selectors.shippingInfo);
  const unit = yield select(selectors.selectedUnit);
  const dataone = yield select(selectors.creditCheckInfo);
  const busStartHour = yield select(selectors.busStartHour);
  const busEndHour = yield select(selectors.busEndHour);

  const requestBody = {
    /* analysis what these are - must be set properly - currently mismatch found */
    Cont_FirstName: contactInfo.firstName,
    Cont_LastName: contactInfo.lastName,
    Cont_EmailAddress: contactInfo.email,
    Cont_Mobileno: contactInfo.phoneNumber?.replace(/-/g, ""),
    PhonenoType: "MobileNo",
    EmailReceive: contactInfo.selectedMailType === "E" ? true : false,
    useServiceAddressForBilling: businessInfo.selected ? true : false,
    StreetAddress: businessInfo.selected ? contactInfo.address : businessInfo.address,
    UnitType: businessInfo.selected ? contactInfo.unitType : 'None',
    UnitNo: businessInfo.selected ? contactInfo.unit : '',
    City: businessInfo.selected ? contactInfo.city : businessInfo.city,
    State: businessInfo.selected ? contactInfo.state : businessInfo.state,
    Zipcode: businessInfo.selected ? contactInfo.zipCode : businessInfo.zipCode,
    AttentionName: '',
    useServiceAddressForWBBilling: false,
    ShippingSameService: shippingInfo.selected,
    ShippingStreetAdress: shippingInfo.selected ? contactInfo.address : shippingInfo.address,
    ShippingUnitType: shippingInfo.selected ? contactInfo.unitType : 'None',
    ShippingUnitNo: shippingInfo.selected ? contactInfo.unit : '',
    ShippingCity: shippingInfo.selected ? contactInfo.city : shippingInfo.city,
    ShippingZipcode: shippingInfo.selected ? contactInfo.zipCode : shippingInfo.zipCode,
    ShippingState: shippingInfo.selected ? contactInfo.state : shippingInfo.state,
    BusStartHr: busStartHour ? busStartHour : '0001',
    BusEndHr: busEndHour ? busEndHour : '0010',

    NoofInstall: oneTimeInstallmentApplicable ? installments.oneTimeInstallments : 0,
    InstallmentBillPrice: oneTimeInstallmentApplicable ? installments.oneTimeInstallmentsPrice : 0,
    NoofBdvInstall: equipmentInstallmentApplicable ? installments.equipmentInstallments : 0,
    NoofRouterInstall: routerInstallmentApplicable ? installments.routerInstallments : 0,
    RouterInstallmentBillPrice: routerInstallmentApplicable ? installments.routertInstallmentsPrice : 0,
    BdvInstallmentBillPrice: equipmentInstallmentApplicable ? installments.equipmentInstallmentsPrice : 0,
    /* --- */
    PaperFreeBilling: installments.paperFreeBilling ? true : false,

    OwnerType: dataone.customerType,
    Sole_BusinessName: contactInfo.businessName,
    Sole_FirstName: dataone.soleOwner.firstName,
    Sole_MI: dataone.soleOwner.middleInitial,
    Sole_LastName: dataone.soleOwner.lastName,
    Sole_DOB: dataone.soleOwner.dob,
    Sole_SSN: encryptionUsingCrypto(dataone.soleOwner.ssn),
    Sole_SSnDonotwise: dataone.soleOwner.isNoSsn ? "nowish" : "nowish",
    PnBusinessName: contactInfo.businessName,
    Pn1_FirstName: dataone.partner1.firstName,
    Pn1_MI: dataone.partner1.middileInitial,
    pn1_LastName: dataone.partner1.lastName,
    pn1_DOB: dataone.partner1.dob ? dataone.partner1.dob : "0/0/0",
    pn1_SSN: encryptionUsingCrypto(dataone.partner1.ssn),
    pn1_SSnDonotwise: dataone.partner1.isNoSsn ? true : false,
    Pn2_FirstName: dataone.partner2.firstName,
    Pn2_MI: dataone.partner2.middileInitial,
    pn2_LastName: dataone.partner2.lastName,
    pn2_DOB: dataone.partner2.dob ? dataone.partner2.dob : "0/0/0",
    pn2_SSN: encryptionUsingCrypto(dataone.partner2.ssn),
    pn2_SSnDonotwise: dataone.partner2.isNoSsn ? true : false,
    Corp_BusinessName: contactInfo.businessName,
    Corp_BillingName: dataone.customerType === "SCORP" ? dataone.scorp.billingName : dataone.customerType === "LLC" ? dataone.llc.billingName : dataone.corporation.billingName,
    Corp_Taxid: dataone.customerType === "SCORP" ? (dataone.scorp.taxIdNumber ? encryptionUsingCrypto(dataone.scorp.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : ''):
                dataone.customerType === "LLC" ? (dataone.llc.taxIdNumber ? encryptionUsingCrypto(dataone.llc.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : ''):
                (dataone.corporation.taxIdNumber ? encryptionUsingCrypto(dataone.corporation.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : ''),
    // LLC_BillingName: data.llc.billingName,
    // LLC_Taxid: data.llc.taxIdNumber ? encryptionUsingCrypto(data.llc.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : '',
    // SCORP_BillingName: data.scorp.billingName,
    // SCORP_Taxid: data.scorp.taxIdNumber ? encryptionUsingCrypto(data.scorp.taxIdNumber?.replace(/[^0-9a-zA-Z]/gi, '')) : '',
    SOValidatedStatus: false,
    PartnerValidatedStatus: false,
    CorpValidatedStatus: false,
    CCBpInfo: '',
    CCDepositBpInfo: '',
    PCIEnabled: '',
    FinalBillBpInfo: '',
    Autopayoffer: installments?.autoPay === true && installments?.paperFreeBilling === true ? "Y" : "N",
  };

  const params = new URLSearchParams();
  Object.keys(requestBody).forEach(key => {
    const value = requestBody[key];
    params.append(key, value);
  });
  const headers = { ...HeadersForFormData, timeout: INCREASED_TIMEOUT };

  try {
    const response = yield apiClient.post(INSTALLATION_VALIDATION_URL, params, headers);
    if (response && response.data) {
      const resData = response.data;
      resData.DueDates = resData.DueDates ? JSON.parse(resData.DueDates) : [];
      resData.DueDateIntervals = resData.DueDateIntervals ? JSON.parse(resData.DueDateIntervals) : [];
      resData.appointmentCode = resData.appointmentCode ? JSON.parse(resData.appointmentCode) : [];
      yield put({ type: 'SAVE_IPM_RESPONSE', data: resData });

      // if (resData.AutopayUrl && resData.AutopayScript) {
      //   yield call(fetchAutoPayStatus, resData);
      // }
    }
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
    yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_CO_NextButtonIPM', error: err } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield fork(updateCartAfterInstallments);
  }
}

//RESERVE_DUE_DATE_URL

function* reserveDueDate(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  yield put({ type: "RESERVE_DUEDATE_ERROR", message: '' });
  const { data } = props;
  yield put({ type: "UPDATE_INSTALLATION_TYPE", data: data.SIselected });

  const requestBody = {
    DueDate: data.dueDate,
    TimeSlot: data.timeSlot,
    TimeSlotCode: data.timeSlotCode,
    PremiumTimeSlot: '',
    BusinessStartHr: data.busStartHour ? data.busStartHour : '0001',
    BusinessEndHr: data.busEndHour ? data.busEndHour : '0010',
    appointmentCode: data.appointmentCode,
    withInBusWindow: '',
    isSelfInstallChecked  : data?.dueDateInfo?.ShowSelfTechInstall === "Y" && data.SIselected == "selfInstall" ? true:false
  };

  const params = new URLSearchParams();
  Object.keys(requestBody).forEach(key => {
    const value = requestBody[key];
    params.append(key, value);
  });

  try {
    const response = yield apiClient.post(RESERVE_DUE_DATE_URL, params, HeadersForFormData);
    if (response && response?.data?.Status?.toLowerCase() === "success") {
      yield put({ type: "SAVE_SUBMITORDER_INFO", data: response.data });
    } else {
      // window.scrollBy({ top: -250, behavior: 'smooth' });
      throw new Error();
    }
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "RESERVE_DUEDATE_ERROR", message: 'Selected Slot in the given Due Date is not available.  Please select other Slot/Date' });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_CO_SetDueDate', error: err } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }



}



function* submitOrder(props) {
  if (isNightTimeWindow()) {
    SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
    SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
    if (window?.newrelic?.addPageAction) {
      window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
      window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
    }
  }
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  const SIselected = yield select(selectors.SIselected);
  const { data } = props;
  const { businessName: YSLBusinessName, businessCategory: YSLBusinessCategory, businessPhone: YSLBusinessPhone, isBillingPhoneRequired: YSLUseBillPhone } = props.data.yahooFormData;
  const { potentialDuplicate: YSLDupeCheckResponse } = props.data.yahooEligibilityResponse;
  const nextButtonCC = yield select(selectors.nextButtonCC);
  const isNoSsnCheck = isNoSsnChecked(data);
  const tosCheckNor = yield select(state=>state.CheckoutPage.tosCheckNor);

  /* Analysis the rest the request body - set appropriate values*/
  let requestBody = {
    PremiumTimeSlot: '',
    BusinessStartHr: data.busStartHour ? data.busStartHour : '0001',
    BusinessEndHr: data.busEndHour ? data.busEndHour : '0010',
    withInBusWindow: '',
    StreetAddress: '',
    City: '',
    State: 'select..',
    UnitType: 'None',
    Zipcode: '',
    UnitNo: '',
    IsShippingAddressSelected: false,
    CCBpinfo: '',   
    isSelfInstallChecked  : data?.dueDateInfo?.ShowSelfTechInstall === "Y" && SIselected == "selfInstall" ? true:false,
    norFlag: tosCheckNor ? 'Y' : 'N'
  };

  if (isNoSsnCheck) {
    requestBody = {
      ...requestBody,
      DueDate: data.dueDate,
      TimeSlot: data.timeSlot,
      TimeSlotCode: data.timeSlotCode,
      appointmentCode: data.appointmentCode,
    };
  }

  if (props.data.Enable_YSL === 'Y' && YSLDupeCheckResponse === false && false) {
    requestBody.YSLBusinessName = YSLBusinessName;
    requestBody.YSLBusinessCategory = YSLBusinessCategory;
    requestBody.YSLBusinessPhone = (YSLUseBillPhone === 'Yes') ? data.CheckoutPage.contactInfo.phoneNumber : YSLBusinessPhone;
    requestBody.YSLUseBillPhone = (YSLUseBillPhone === 'No') ? false : true;
    requestBody.YSLDupeCheckResponse = YSLDupeCheckResponse;
  }

  const params = new URLSearchParams();
  Object.keys(requestBody).forEach(key => {
    const value = requestBody[key];
    params.append(key, value);
  });

  try {
    const response = yield apiClient.post(SUBMIT_ORDER_URL, params, HeadersForFormData);
    if (response && response.data) {
      yield put({ type: "SAVE_SUBMITORDER_INFO", data: response.data });
      if (response.data.Status === 'success') {
        let path = "/confirmation";
        if (nextButtonCC.CreditCheckStatus === "FAILURE") {
          // path = "/contact-rep";
          path = "/confirmation-contact-rep"
        }
        data.history.push(path);
      } else {
        throw new Error();
      }
    }
  } catch (err) {
    console.log('NTE_CO_SubmitOrder Err', err)
    SiteCatalyst.trackOrderFailure();
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_SubmitOrder' });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}
function* omnisubmitOrder(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  const { data } = props;
  const nextButtonCC = yield select(selectors.nextButtonCC);
  const optixSessionId = yield select(selectors.optixSessionId);
  const contactInfo = yield select(selectors.optixContactInfo);  
  const otpInfo = yield select(selectors.creditCheckInfo);
  let altCotact = otpInfo?.otp?.postValidateOtpResponse?.SMSNumber?.replace(/-/g, "");

 if(otpInfo?.otp?.postValidateOtpResponse?.SMSNumber?.replace(/-/g, "") === contactInfo.phoneNumber?.replace(/-/g, "")){
  altCotact = "";
 }  
  const requestBody = {
    "submitRequest": {
      "client": {
        "name": "GBCOM",
        "clientId": "GBCOM",
        "RequestId": "6767"
      },
      "sessionId": optixSessionId,
      "tosAccepted": "Accepted",
      "forceSubmit": "false",
      "isDepositWaived": "N",
      "UpdateVEC": "false",
      "IschangedBillingAddress": "false",
      "IsOrderValidationRequired": "false",
      "AutoPayPerformedType": "0",
      "VepsConfirmationNumbers": "",
      "IsOrderHandedOverToAgent": "false"
    },
    "ContactInfo": {
      "FirstName": contactInfo.firstName,
      "LastName": contactInfo.lastName,
      "TelNumber": contactInfo.phoneNumber?.replace(/-/g, ""),
      "AltContact1": altCotact,
      "AltContact2": "",
      "ContactEmail": contactInfo.email,
      "vzWirelessTN": contactInfo.phoneNumber?.replace(/-/g, ""),
      "wirelessReferral": ""
    },
    "SessionId": optixSessionId,
    "GBSessionID": "",
    "precheckoutRequest": {
      "custFirstName": "ABC",
      "custLastName": "XYZ"
    }
  };

  try {
    const response = yield apiClient.post(OMNI_SAVE_SUBMITORDER_INFO, requestBody);
    if (response && response.data) {
      const monNumber = response.data?.outputField?.svcOrderNumbersField?.[0]?.valueField;
      response.data.Status = monNumber ? "success" : "failure";

      response.data.orderInfo = {
        "svc_orderNo": monNumber
      };

      yield put({ type: "OMNI_SAVE_SUBMITORDER_INFO", data: response.data });
      if (response.data.Status === 'success') {
        let path = "/optix-confirmation";
        if (nextButtonCC.CreditCheckStatus === "FAILURE") {
          // path = "/contact-rep";
          path = "/confirmation-contact-rep"
        }
        SiteAnalytics.trackTOSAccordianComplete();
        SiteAnalytics.trackOptixOrderConfirmation(response.data);

        data.history.push(path);
      } else {
        throw new Error();
      }
    }
  } catch (err) {
    console.log('NTE_CO_SubmitOrder Err', err)
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    SiteCatalyst.trackOrderFailure();
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_SubmitOrder' });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}


function* setCOVID19(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  const { data } = props;
  //const nextButtonCC = yield select(selectors.nextButtonCC);

  /* Analysis the rest the request body - set appropriate values*/
  const requestBody = {
    CovidQvalues: data.CovidQvalues
  };

  const params = new URLSearchParams();
  Object.keys(requestBody).forEach(key => {
    const value = requestBody[key];
    params.append(key, value);
  });

  try {
    const response = yield apiClient.post(SAVE_COVID_QUESTION_URL + `?CovidQvalues=${data.CovidQvalues}`, params, HeadersForFormData);
    if (response && response.data) {
      /*yield put({ type: "SAVE_SUBMITORDER_INFO", data: response.data });
      if (response.data.Status === 'success') {
        let path = "/confirmation";
        if (nextButtonCC.CreditCheckStatus === "FAILURE") {
          path = "/contact-rep";
        }
        data.history.push(path);
      } else {
        throw new Error(); 
      }*/
    }
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_CovidQ' });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

/** Due date api */

function* selectedDueDate(props) {
  // yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  // yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  // const { data } = props;

  // const requestBody = {
  //   DueDate: data.dueDate,
  // };

  // const params = new URLSearchParams();
  // Object.keys(requestBody).forEach(key => {
  //   const value = requestBody[key];
  //   params.append(key, value);
  // });

  // try {
  //   const response = yield apiClient.post(SELECTED_DUE_DATE_URL, params, HeadersForFormData);
  //   if (response && response.data) {
  //     if (response.data === 'Success' || response.data.Status === 'success') {
  //       console.log(response);
  //     } else {
  //       throw new Error();
  //     }
  //   }
  // } catch (err) {
  //   yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_SDD' });
  //   yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
  // } finally {
  //   yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  // }
}

function* generateSI(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  const { data } = props;
  //const nextButtonCC = yield select(selectors.nextButtonCC);

  /* Analysis the rest the request body - set appropriate values*/
  const requestBody = {
    isSelfInstall: data.IsSelfInstall,
    isTechInstall: data.IsTechInstall
  };

  const params = new URLSearchParams();
  Object.keys(requestBody).forEach(key => {
    const value = requestBody[key];
    params.append(key, value);
  });

  try {
    const response = yield apiClient.post(GENERATE_SELFINSTALL_URL, params, HeadersForFormData);
    const resData = response.data;
    if (resData && resData.GetDueDateStatus && resData.GetDueDateStatus === "SUCCESS") {
      resData.DueDates = resData.DueDates ? JSON.parse(resData.DueDates) : [];
      resData.DueDateIntervals = resData.DueDateIntervals ? JSON.parse(resData.DueDateIntervals) : [];
      resData.appointmentCode = resData.appointmentCode ? JSON.parse(resData.appointmentCode) : [];
      yield put({ type: "UPDATE_DUE_DATES", data: { response: resData } });
    }
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_GenerateSI' });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}




/* To get the MON Details to show in Confirmation page */
function* getConfirmationOrderInfo() {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  try {
    const response = yield apiClient.get(GET_CONFIRAMTION_ORDER_INFO_URL);
    yield put({ type: "GET_CONFIRMATION_ORDER_STATUS", data: response.data });
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    // yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_OC_Confirm' });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    console.log('Catch Error', err);
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* getRetrieveOrder(request) {
  yield put({ type: "CLEAR_GLOBAL_STORE" });
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "UPDATE_SAVED_CART_ERROR", data: false });
  yield put({ type: "TOGGLE_CART_LOADING", data: true });

  const cartId = encodeURIComponent(request.params.scartId)
  const monNO = request.params.monNO;
  const cid = encodeURIComponent(request.params.cid)
  const cmp = encodeURIComponent(request.params.cmp);
  const source = encodeURIComponent(request.params.source);

  yield put({ type: "SET_SOURCE", data: source });
  yield put({ type: "SET_CART_MON", data: monNO });
  yield put({ type: "SET_CART_ID", data: cartId });
  yield put({ type: "SET_C_ID", data: cid });
  yield put({ type: "SET_C_MP", data: cmp });
  if (window?.newrelic?.addPageAction) {
    window.newrelic.addPageAction("Retrieve Cart PageLoad");
    const uuid = uuidv4();
    window.newrelic.setCustomAttribute("ApigeeToken", uuid);
    window.newrelic.setCustomAttribute("UUID", uuid);
    if(!window?.newrelic?.info?.jsAttributes?._cls_s) {
      const clss =  getCookie("_cls_s");
      const clsv =  getCookie("_cls_v");
      window.newrelic.setCustomAttribute("_cls_s", clss);
      window.newrelic.setCustomAttribute("_cls_v", clsv);
    }
  }
  const result = i18next.t("fios",{returnObjects:true,ns:'fios'});
  const cmpCode = cmp ? String(cmp).replaceAll('%3A',':') : ''
  const cmpVal=(cmpCode&&result['cpmCodeRetrieve']&&result['cpmCodeRetrieve'].includes(cmpCode))?("&cmp="+cmpCode):""
  const retrieveCartUrl = request.params?.cid ? ((cmpCode&&cmpVal) ? RETRIEVE_SAVE_CART_INFO_URL + `?scartid=${cartId}&cid=${cid}${cmpVal??""}`:RETRIEVE_SAVE_CART_INFO_URL + `?scartid=${cartId}&cid=${cid}`) : (request.params?.cmp ? RETRIEVE_SAVE_CART_INFO_URL + `?scartid=${cartId}${cmpVal}`:RETRIEVE_SAVE_CART_INFO_URL + `?scartid=${cartId}`)
  try {
    const retrieveCartResponse = yield apiClient.get(retrieveCartUrl)
    if (retrieveCartResponse?.data?.LQPost?.FiOSDataStatus === 'Y' && retrieveCartResponse?.data?.LQPost?.HSIStatus === 'Y') {
      retrieveCartResponse.data.LQPost.HSIStatus = 'N';
    }
    yield put({ type: "GET_POST_LQ_DATA_RESPONSE", data: retrieveCartResponse.data.LQPost });
    if (retrieveCartResponse?.data?.Status === "SUCCESS") {
      yield put({ type: "INTERNER_FLOW_COMPLETED", data: true });
      if (retrieveCartResponse?.data?.LQPost?.EPSessionID && window?.newrelic?.setCustomAttribute) {
        window.newrelic.setCustomAttribute("EPSessionId", retrieveCartResponse.data.LQPost.EPSessionID);
        window.newrelic.setCustomAttribute("GUISessionID", retrieveCartResponse.data.LQPost.GUISessionID);
      }
      if (retrieveCartResponse?.data?.isSavedCartOfferApplied === "Y") {
        LPSavedCartOfferEngagement();
      }

      SiteAnalytics.trackFiosSavedCartOffers(retrieveCartResponse?.data?.isSavedCartOfferApplied === "Y");

      const lastVistFlag = retrieveCartResponse?.data?.LastVisitPage?.toLowerCase().includes("checkout");
      yield put({ type: "UPDATE_IS_SAVED_CART_OFFER_APPLIED", data: retrieveCartResponse.data.isSavedCartOfferApplied });
      yield put({ type: "SAVE_SELECTED_PRODUCTS", data: { response: null } });
      yield put({ type: "SET_CUSTOMIZE_PRODUCTS_DATA", data: null });
        if(retrieveCartResponse?.data?.isSavedCartOfferApplied === "Y") window.isRedirectedSaveCart = true
      if (lastVistFlag && !(window.isRedirected && window.isRedirected[cartId])) {
        if (!window.isRedirected) {
          window.isRedirected = {};
        }
        window.isRedirected[cartId] = true;
        yield put({ type: "UPDATE_CHECKOUTPAGE_VISIT_FLAG", data: 'Y' });
        yield put({ type: "UPDATE_PAGELOAD_TYPE", data: 'R' }); 
        // yield* getSelectedproduct();
        request.params.history.push('/checkout');
        // yield call(getFloatingCartDetails, null, 'Retrieve', lastVistFlag);
      }

      if(retrieveCartResponse?.data?.DigitalAgentFlow!=="Y"){
      yield fork(fetchCustomizeProducts, 'Retrieve');
      }
      if (!lastVistFlag || !(window.isRedirected && window.isRedirected[cartId])) {
        yield* getSelectedproduct();
        yield call(getFloatingCartDetails, null, 'Retrieve', false);
        request.params.history.push('/customize-order');
        window.isRedirected = null;
      }

      // const retrieveCartID = yield select(selectors.retrieveCartID);
      const bannerInfo = yield select(selectors.bannerInfo);
      const cid = yield select(selectors.cid);
      const customizeProductsResponse = yield select(selectors.customizeProductsResponse);
      // Banner flow implementation
      if (bannerInfo && cid) {
        yield call(processBannerProductCall, { data: customizeProductsResponse });
      }


      yield put({ type: "SAVE_VO_STATUS", data: 'VOSUCCESS' });
    } else {
      yield put({ type: "UPDATE_SAVED_CART_ERROR", data: true });
      if (window?.newrelic?.addPageAction) {
        window.newrelic.addPageAction("Retrieve Cart Failure");
      }
      throw new Error();
    }
  }
  catch (err) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "TOGGLE_CART_LOADING", data: false });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    //yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_SO_GetRetrievedOrder', error: err } });
  } finally {
    yield put({ type: "TOGGLE_CART_LOADING", data: false });
  }
}


function* getRetrieveCartInfo(request) {
  console.log(request, 'test request');
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  try {
    // yield* getCartInfo();
    if (!request?.data) {
      yield* getFloatingCartDetails();
    }
    yield* getSelectedproduct('Back', request);
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
  finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}


function* fetchAutoPayStatus(data) {
  const params = new URLSearchParams();
  params.append('args', data.AutopayScript);
  yield put({ type: "SET_APLOADING", data: true });
  try {
    const response = yield apiClient.post(data.AutopayUrl, params);
    if (response && response.data) {
      yield put({ type: "AUTOPAY_DETAILS", data: response.data });
      //if (response && response.data) {
      //yield call(autoPayLog, response.data);
    }

    window.mymethod = (poresponsedata) => {
      var APEntrolled = "N";
      if (poresponsedata != null) {
        if ((poresponsedata.result !== null && poresponsedata.result == 1) && (poresponsedata.eventID != null && poresponsedata.eventID == 0) && (poresponsedata.eventType != null && poresponsedata.eventType == "TRANS")) {
          //if ($("#hdnAutoPayDiscountEligiable").val() == "true" && $('#rdPaperBillYesAp').is(':Checked') == true && (poresponsedata.data = null && (poresponsedata.data.pmtType = null && poresponsedata.data.pmtType == "DD" || poresponsedata.data.pmtType == "DC"))) $("#hdnAutoPayDiscountEligiable").val() == "true" && $('#rdPaperBillYesAp').is(':Checked') == true && 
          if (((poresponsedata.transactions != null && poresponsedata.transactions?.length > 0) && (poresponsedata.transactions[0].data.pmtType != null && poresponsedata.transactions[0].data.pmtType == "DD" || poresponsedata.transactions[0].data.pmtType == "DC"))) {
            //$("#dvAutopayMessage .level2").text("Your Auto Pay request is submitted, and you are eligible for the $5/mo Auto Pay and Paper Free Billing discount!  Registration in MyBusiness required to receive discount.");
            //$('.button-section').find('.button').prop("disabled", true).css({ 'background': "#999 " });
          }
          else {
            //$("#dvAutopayMessage .level2").text("Your auto pay request is submitted.");
            // $('.button-section').find('.button').prop("disabled", true).css({ 'background': "#999 " });
          }

          //$('#dvAutopaySection').hide();
          //$("#dvAutopayMessage").show();
          APEntrolled = "Y";

        }
        console.log("/// Event Response", poresponsedata);
        dispatchEvent('recievedAutoPayResponse', { data: poresponsedata, APEnrolled: APEntrolled });
        BuildAutopaylog(poresponsedata, APEntrolled);
        if (data != null) {
          //const onChange = (onContinueClick) 
          //onAutoPayChange("NY")
          //
          //this.onAutopayChange
        }

      }
      console.log(APEntrolled);
    }

    function BuildAutopaylog(poresponsedata, APEntrolled) {
      var APPmtType = '';
      if (poresponsedata != null && poresponsedata.transactions != null && poresponsedata.transactions?.length > 0 && poresponsedata.transactions[0] != null && poresponsedata.transactions[0].data != null && poresponsedata.transactions[0].data.pmtType != null) {
        APPmtType = poresponsedata.transactions[0].data.pmtType;
      }
      var data = {
        AutoPayStatusLog: JSON.stringify(poresponsedata),
        APEntrolled: APEntrolled.toString(),
        AutoPayPmtType: APPmtType
      };
      autoPayLog(data);

      return data;
    }

  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "UPDATE_APLOAD_FAILURE", data: true });
  } finally {
    yield put({ type: "SET_APLOADING", data: false });
  }
}

function autoPayLog(data) {
  const requestBody = {
    AutoPayStatusLog: data.AutoPayStatusLog,
    APEntrolled: data.APEntrolled,
    AutoPayPmtType: data.AutoPayPmtType
  };

  try {
    const response = apiClient.post(AUTOPAYLOG_URL, requestBody);
    if (response) {
      //yield put({ type: "SAVE_AUTOPAYLOG_RESPONSE", data: response.data });
    }
  } catch (err) { }
}


export function* updateCartAsynchronously() {

  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER_FLOATING_CART", data: true });

    const params = new URLSearchParams();
    params.append("type", "OC");
    params.append("SelectedDueDate", "");
    params.append("skipVo", "false");

    // const getCartInfoResponse = yield apiClient.post(GET_CART_INFO_URL, params, HeadersForFormData);
    // yield put({ type: "GET_CART_INFO_RESPONSE", data: getCartInfoResponse.data });

    yield call(getFloatingCartDetails, null, "checkout");
    yield put({ type: "TOGGLE_LOADING_SPINNER_FLOATING_CART", data: false });
  }
  catch (err) {
    console.log('Catch Error', err);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  }
  finally {
    // Ideally below action should be inside checkoutCartLoad generator function but due to spinner loading issues moving here.
    // TODO: move to checkout cart load function
    yield put({ type: "VO_CALL_IN_PROGRESS", data: false });
  }
}

function* checkout() {
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "CHECKOUT_INITIATED", data: true });

  const phoneNumber = yield select(selectors.phoneNumber);
  const email = yield select(selectors.personalInfoEmail);
  const lqEmail = yield select(selectors.email);
  const emailEnteredInSaveCart = yield select(selectors.saveCartEmail);
  const businessInfor = yield select(selectors.businessInfo);
  const contactInfor = yield select(selectors.contactInfo);
  const isCheckoutPageVisited = yield select(selectors.isCheckoutPageVisited);
  const isRetrieveCart = yield select(selectors.isRetrieveCart);
  const creditCheckInfo = yield select(selectors.creditCheckInfo);
  const isSelectedStreetAddress = yield select(selectors.selectedStreetAddress);
  const pageLoadType = yield select(selectors.pageLoadType);
  const lqPostData = yield select(selectors.lqPostData);  //incase of Retrive cart flow
  const LqData = yield select(selectors.LqData);
  try {


    const response = yield apiClient.get(CHECKOUT_URL);
    const lqResData = pageLoadType === 'R' ? (lqPostData ? lqPostData : {}) :
      (LqData ? LqData : lqPostData ? lqPostData : {})

    if (response && response.data && response.data.objDOBBind) {
      // if (isCheckoutPageVisited !== "Y") {
      //   yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      // }
      const res = response.data.objDOBBind;
      let billingAddressdata = {
          disprawstr: res.BillingAddress,
          dispstr: res.BillingStreeAddress,
          zip: res.BillingZipCode,
          state: res.BillingState,
          muni: res.BillingCity,
          ntasAddrID: res.BillingAddressId,
          baseAddressId: res.BillingAddressId
        }
      if (isRetrieveCart) {
        yield put({ type: "SAVE_SELECTED_STREET_ADDRESS", data: billingAddressdata });
        yield put({ type: "RETRIVE_DEFAULT_ADDRESS", data: billingAddressdata })

        let unitdata = {
          unit: res.BillingUnitNO
        }
        yield put({ type: "RETRIVE_DEFAULT_UNIT", data: unitdata })
        yield put({ type: "SAVE_SELECTED_UNIT", data: unitdata })


        yield call(fetchUnitsinBillingAddress);
        yield put({ type: "RETRIEVE_CART_FLOW", data: false });

        let phoneNumberfromLQ = res.PhoneNumFromLQ
        const formattedPhoneNumber = phoneNumberfromLQ?.indexOf("-") === -1 ? phoneNumberfromLQ?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : phoneNumberfromLQ;
        yield put({ type: "SAVE_PHONE_NUMBER", data: formattedPhoneNumber });
      }
      const enableNewLowerFunnel = CheckAEMBoolValue(i18next.t("enableVDS3LF",{ns:"customize-order"}));
      const contactInfo = {
        phoneNumber: contactInfor?.phoneNumber || res.Cont_Mobileno || res.PhoneNumFromLQ || phoneNumber,
        email: contactInfor?.email || res.Cont_EmailAddress || email || res.EmailFromLQ || lqEmail || emailEnteredInSaveCart,
        address: res.BillingAddress ? res.BillingAddress.split(',')[0] : '',
        city: res.BillingCity || contactInfor?.city,
        state: res.BillingState || contactInfor?.state,
        zipCode: res.BillingZipCode || contactInfor?.zipCode,
        unit: res.BillingUnitNO,
        unitType: res.BillingUnitType,
        firstName: res.Cont_FirstName || contactInfor?.firstName,
        lastName: res.Cont_LastName || contactInfor?.lastName,
        businessName: res.BusinessName || contactInfor?.businessName,
      };
      if(!isSelectedStreetAddress) yield put({ type: "SAVE_SELECTED_STREET_ADDRESS", data: billingAddressdata });
      if(enableNewLowerFunnel){
      yield put({type:'SAVE_ADDRSS_ENTERED_DURING_INITIAL',data:res?.BusinessAddress ?? lqResData?.Address})
      if(res.OwnerType!=="SoleOwner"&&res.OwnerType!=="Partner"){
        contactInfo.firstName="";
        contactInfo.lastName="";
      }
      yield put({type:'UPDATE_CREDITCHECK_INFO',data:{key:"taxIdNumber",value:"",type:"corporation"}})
      yield put({type:'UPDATE_CREDITCHECK_INFO',data:{key:"taxIdNumber",value:"",type:"llc"}})
      yield put({type:'UPDATE_CREDITCHECK_INFO',data:{key:"taxIdNumber",value:"",type:"scorp"}})
      yield put({type:'UPDATE_CREDITCHECK_INFO',data:{key:"ssn",value:"",type:"partner1"}})
      yield put({type:'UPDATE_CREDITCHECK_INFO',data:{key:"ssn",value:"",type:"partner2"}})
      yield put({type:'UPDATE_CREDITCHECK_INFO',data:{key:"ssn",value:"",type:"soleOwner"}})
      yield put({ type: 'AUTOFILL_DATA_FOR_CREDITCHECK', data: contactInfo });
      }
      const businessInfo = {
        address: businessInfor?.address || (res.BillingAddress ? res.BillingAddress.split(',')[0] : ''),
        city: businessInfor?.city || res.BillingCity,
        state: businessInfor?.state || res.BillingState,
        zipCode: businessInfor?.zipCode || res.BillingZipCode,
        selected: enableNewLowerFunnel ? false : res.UseServiceAddressForBilling == "false" ? false : true
      };
      const shippingInfo = { ...businessInfo };
      const checkoutData = { contactInfo, businessInfo, shippingInfo };

      const pageLoadType = yield select(selectors.pageLoadType);
      const retrieveCartID = yield select(selectors.retrieveCartID);
      if (pageLoadType === 'R' && retrieveCartID) {
        console.log('checkInfo', res.OwnerType, creditCheckInfo?.customerType)
        let data = {
          customerType: res.OwnerType || creditCheckInfo?.customerType,
          soleOwner: {
            firstName: res.Sole_FirstName || creditCheckInfo?.soleOwner?.firstName,
            middleInitial: res.Sole_MI || creditCheckInfo?.soleOwner?.middleInitial,
            lastName: res.Sole_LastName || creditCheckInfo?.soleOwner?.lastName,
            dob: res.Sole_Day ? res.Sole_Month + "/" + res.Sole_Day + "/" + res.Sole_Year : creditCheckInfo?.soleOwner?.dob,
          },
          partner1: {
            firstName: res.Pn1_FirstName || creditCheckInfo?.partner1?.firstName,
            middleInitial: res.Pn1_MI || creditCheckInfo?.partner1?.middleInitial,
            lastName: res.pn1_LastName || creditCheckInfo?.partner1?.lastName,
            dob: res.pn1_Day ? res.pn1_Month + "/" + res.pn1_Day + "/" + res.pn1_Year : creditCheckInfo?.partner1?.dob,
          },
          partner2: {
            firstName: res.Pn2_FirstName || creditCheckInfo.partner2?.firstName,
            middleInitial: res.Pn2_MI || creditCheckInfo.partner2?.middleInitial,
            lastName: res.pn2_LastName || creditCheckInfo.partner2?.lastName,
            dob: res.pn2_Day ? res.pn2_Month + "/" + res.pn2_Day + "/" + res.pn2_Year : creditCheckInfo?.partner2?.dob,
          },
          corporation: {
            billingName: res.OwnerType === "Corporation" ? (res.Corp_BillingName || creditCheckInfo?.corporation?.billingName) : "",
            taxIdNumber: res.OwnerType === "Corporation" && !enableNewLowerFunnel? (res.Corp_Taxid || creditCheckInfo?.corporation?.taxIdNumber) : ""
          },
          llc: {
            billingName: res.OwnerType === "LLC" ? (res.Corp_BillingName || creditCheckInfo?.llc?.billingName) : "",
            taxIdNumber: res.OwnerType === "LLC" && !enableNewLowerFunnel? (res.Corp_Taxid || creditCheckInfo?.llc?.taxIdNumber) : ""
          },
          scorp: {
            billingName: res.OwnerType === "SCORP" ? (res.Corp_BillingName || creditCheckInfo?.scorp?.billingName) : "",
            taxIdNumber: res.OwnerType === "SCORP" && !enableNewLowerFunnel? (res.Corp_Taxid || creditCheckInfo?.scorp?.taxIdNumber) : ""
          }
        };
        yield put({ type: "SAVE_CREDIT_CHECK_INFO", data: data });
      }

      yield put({ type: "SAVE_CHECKOUT_RESPONSE", data: { checkoutData, response: response.data } });
      yield put({ type: "CHECKOUT_INITIATED", data: false });


    }
  } catch (err) {
    console.log('Catch Error', err);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_GenericError' });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
  }
  finally {
    // if (isCheckoutPageVisited !== "Y") {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    // }
  }
}

function* getFaqContent(faqRequest) {
  const { pageName, sectionName } = faqRequest.data;
  const res = [
    { title: 'title one', description: 'title one description' },
    { title: 'title two', description: 'title two description' }
  ];

  try {
    const response = {};
    // const response = yield apiClient.get(FAQ_URL + `pid=${pageName}&sid=${sectionName}`);
    if (response && response.data) {
      yield put({ type: "SAVE_FAQ_CONTENT", data: response.data });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_GenericError' });
  }
}

function* checkoutCartLoad() {
  // const isCheckoutPageVisited = yield select(selectors.isCheckoutPageVisited);
  try {
    // if (isCheckoutPageVisited === "Y") {
    //   yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    // }
    yield put({ type: "VO_CALL_IN_PROGRESS", data: true });
    /* VO CART INFO CALL BEFORE CHECKOUT */
    // if (!window.isRedirected || window.isRedirectedSaveCart) {
      const voStatus = yield apiClient.post(GET_CHECKOUT_CART_INFO_URL);
      if (voStatus && voStatus.data) {
        yield put({ type: "SAVE_VO_STATUS", data: voStatus.data.status });
        // if(window.isRedirectedSaveCart) window.isRedirectedSaveCart = undefined
      }
    // } else {
    //   setTimeout(() => {
    //     window.isRedirected = null;
    //   }, 5000);
    // }
    if (window.bundleChanged) {
      window.bundleChanged = undefined;
      yield put({ type: "VO_CALL_IN_PROGRESS", data: false });
      return;
    }

    yield call(getDueDateInfo, null, 'checkout');

    const response = yield apiClient.get(CHECKOUT_DETAILS_URL);
    const enableNewLowerFunnel = CheckAEMBoolValue(i18next.t("enableVDS3LF",{ns:"customize-order"}));
    const retrieveCartID = yield select(selectors.retrieveCartID);
    if (response && response.data && response.data.objDOBBind) {
      response.data.objDOBBind = JSON.parse(JSON.stringify(response.data.objDOBBind));
      if(enableNewLowerFunnel&&!retrieveCartID){
        response.data.objDOBBind.BDVInstallmentRadio = "";
      }
      yield put({ type: "SAVE_CHECKOUT_INSTALLMENTS", data: { response: response.data } });
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }

    yield fork(updateCartAsynchronously);
    //yield put({ type: "HAS_CHECKOUT_DETAILS_RESPONSE", data: "Y" });

  } catch (err) {
    console.log(err);
    // yield put({ type: "SAVE_VO_STATUS", data: 'VOFAIL' });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
  } finally {
    // if (isCheckoutPageVisited === "Y") {
    //   yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    // }
  }
}

export function* getSelectedproduct(param, request) {
  console.log(request, param)
  // yield put({ type: "JOINT_OFFER_AVAILABILITY_RESPONSE", data: false });
  try {
    const jointOfferAvailResponse = yield select(selectors.jointOfferAvailResponse);
    const retrieveCartID = yield select(selectors.retrieveCartID);
    const bannerInfo = yield select(selectors.bannerInfo);
    const response = yield apiClient.get(GET_SELECTED_PRODUCTS);
    if (response && response.data) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      yield put({
        type: "SAVE_JOINT_OFFER_DETAILS", data: {
          JointOfferPrice: response?.data?.JointOfferSaveCart?.JointOfferPrice?.replaceAll("-", ""),
          JointOfferStatus: response.data?.JointOfferSaveCart?.JointofferStatus === "" ? "Not Eligible" : response.data?.JointOfferSaveCart.JointofferStatus,
          OneGigSpeedPrice: response?.data?.JointOfferSaveCart?.OneGigSpeedPrice?.replaceAll("-", "")
        }
      });
      if (response?.data?.JointOfferSaveCart && retrieveCartID) {
        if (response?.data?.JointOfferSaveCart?.JointOfferPrice?.includes("-")) {
          response.data.JointOfferSaveCart.JointOfferPrice = response?.data?.JointOfferSaveCart?.JointOfferPrice?.replaceAll("-", "");
        }
        if (response?.data?.JointOfferSaveCart && !jointOfferAvailResponse?.jointOfferPreSelected) {
          response.data.JointOfferSaveCart.jointOfferPreSelected = false;
        }
        yield put({ type: "JOINT_OFFER_AVAILABILITY_RESPONSE", data: response.data?.JointOfferSaveCart === "" ? "Not Eligible" : response.data?.JointOfferSaveCart });
      }

      // DataProductId assigned to Produtid
      if (response.data?.BDVFIOSTP?.Plans) {
        response.data.BDVFIOSTP.Plans = response.data.BDVFIOSTP.Plans.map(e => ({
          ProductId: e?.DataProductId,
          PackageId: e?.DataPackageId, ...e
        }))
      }
      if (response.data?.FlexInfo?.Plans) {
        response.data.FlexInfo.Plans = response.data.FlexInfo.Plans.map(e => ({
          ProductId: e?.DataProductId,
          PackageId: e?.DataPackageId, ...e
        }))
      }

      if (response?.data?.ContactsInfo?.LQEmailId) {
        yield put({ type: "SAVE_EMAIL_ADDRESS", data: response.data.ContactsInfo.LQEmailId });
      }
      if (response?.data?.ContactsInfo?.LQContactTN) {
        let phoneNumber = response.data.ContactsInfo.LQContactTN;
        const formattedPhoneNumber = phoneNumber.indexOf("-") === -1 ? phoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : phoneNumber;
        yield put({ type: "SAVE_PHONE_NUMBER", data: formattedPhoneNumber });
      }
      if (response?.data?.ContactsInfo?.BIEmailId) {
        yield put({ type: "SAVE_CHECKOUT_EMAIL", data: response.data.ContactsInfo.BIEmailId });
      }
      if (response?.data?.ContactsInfo?.BIContactTN) {
        yield put({ type: "SAVE_CHECKOUT_PHONE", data: response.data.ContactsInfo.BIContactTN });
      }
      if (response?.data?.ContactsInfo?.BIBusinessName) {
        yield put({ type: "SAVE_CHECKOUT_BUSINESSNAME", data: response.data.ContactsInfo.BIBusinessName });
      }
      if (response?.data?.ContactsInfo?.SaveCartEmailId) {
        yield put({ type: "SAVE_SAVECART_EMAIL", data: response.data.ContactsInfo.SaveCartEmailId });
      }

      yield put({
        type: "SAVE_BDV_ENHANCED_CALL", data: {
          serviceCallOpt: response.data.CommonInfo.BDVEnhanced.IsChecked === 'Y' ? true : false ,
          selectedOpt: response.data.CommonInfo.BDVEnhanced.IsAccepted,
          isServiceCallAccepted: response.data.CommonInfo.BDVEnhanced.IsAccepted
        }
      });

      yield put({
        type: "SAVE_SELECTED_PRODUCTS", data: {
          response: response.data,
          pageLoadType: bannerInfo ? 'C' : retrieveCartID ? 'R' : 'I'
        }
      });

      let DataKey = 'DataInfo';
      if (response.data.DataInfo) {
        if (response.data.DataInfo.Plans[0]?.ServiceType === 'DSL') {
          yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI });
        } else {
          yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA });
        }
        yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: response.data.DataInfo.Plans[0]?.ServiceType });
        if (retrieveCartID && response.data.DataInfo.Plans[0]?.ServiceType === 'DSL') {
          const internet = yield select(selectors.internet);
          if (!internet?.RouterSelection) {
            const selectedRouterFromAPI = response.data.DataInfo?.Routers.filter(router => router.IsSelected === true);
            const initialOldID = selectedRouterFromAPI && selectedRouterFromAPI[0] ? selectedRouterFromAPI[0].ProductId : '';
            let RouterSelection = { NewID: initialOldID };
            yield put({ type: "UPDATE_INTERNET_CART_SELECTION", data: { ...internet, RouterSelection } });
          }
        }
        yield put({ type: "SAVE_SELECTED_PRODUCTS_ROUTERS", data: response.data.DataInfo?.Routers });
      } else if (response.data.BDVInfo) {
        DataKey = 'BDVInfo';
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV });

        const BDVInfo = JSON.parse(JSON.stringify(response.data?.BDVInfo))
        const equipmentList = getBDVEquipments(BDVInfo);
        yield put({ type: "UPDATE_BDV_EQUIPMENTS", data: equipmentList });

        yield put({ type: "SET_BDV_TN_COUNT", data: response.data?.BDVInfo?.TNList?.Qnty });
        yield put({ type: "SET_GET_BDV_TN_RESP", data: response.data?.BDVInfo?.TNList?.TNObject });
        

      } else if (response.data.BDVFIOSDP) {
        DataKey = 'BDVFIOSDP';
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA_BDV });

        const BDVFIOSDP = JSON.parse(JSON.stringify(response.data?.BDVFIOSDP))
        const equipmentList = getBDVEquipments(BDVFIOSDP);
        yield put({ type: "UPDATE_BDV_EQUIPMENTS", data: equipmentList });
        yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: 'FIOS' });
        yield put({ type: "SAVE_SELECTED_PRODUCTS_ROUTERS", data: response.data.BDVFIOSDP?.Routers });

        yield put({ type: "SET_BDV_TN_COUNT", data: response.data?.BDVFIOSDP?.TNList?.Qnty });
        yield put({ type: "SET_GET_BDV_TN_RESP", data: response.data?.BDVFIOSDP?.TNList?.TNObject });

      } else if (response.data.HSIBundleInfo) {
        DataKey = 'HSIBundleInfo';
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI_PHONE });
        yield put({ type: "UPDATE_PHONE_SERVICES", params: BUNDLE.PHONE });
        yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: 'DSL' });

        if (retrieveCartID) {
          const internet = yield select(selectors.internet);
          if (!internet?.RouterSelection) {
            const selectedRouterFromAPI = response.data.HSIBundleInfo?.Routers.filter(router => router.IsSelected === true);
            const initialOldID = selectedRouterFromAPI && selectedRouterFromAPI[0] ? selectedRouterFromAPI[0].ProductId : '';
            let RouterSelection = { NewID: initialOldID };
            yield put({ type: "UPDATE_INTERNET_CART_SELECTION", data: { ...internet, RouterSelection } });
          }
        }

      } else if (response.data.FiosTVInfo) {
        DataKey = 'FiosTVInfo';
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.VIDEO });
        yield put({ type: "SAVE_SELECTED_PRODUCTS_ROUTERS", data: response.data.FiosTVInfo?.Routers });
      } else if (response.data.FlexInfo) {
        DataKey = 'FlexInfo';
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.FLEX });
        yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: 'FIOS' });
        yield put({ type: "SAVE_SELECTED_PRODUCTS_ROUTERS", data: response.data.FlexInfo?.Routers });
      } else if (response.data.BDVFIOSTP) {
        DataKey = 'BDVFIOSTP';
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV_DATA_VIDEO });

        const BDVFIOSTP = JSON.parse(JSON.stringify(response.data?.BDVFIOSTP))
        const equipmentList = getBDVEquipments(BDVFIOSTP);
        yield put({ type: "UPDATE_BDV_EQUIPMENTS", data: equipmentList });
        yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: 'FIOS' });
        yield put({ type: "SAVE_SELECTED_PRODUCTS_ROUTERS", data: response.data.BDVFIOSTP?.Routers });

        yield put({ type: "SET_BDV_TN_COUNT", data: response.data?.BDVFIOSTP?.TNList?.Qnty });
        yield put({ type: "SET_GET_BDV_TN_RESP", data: response.data?.BDVFIOSTP?.TNList?.TNObject });
      } else if (response.data.PhoneInfo) {
        DataKey = 'PhoneInfo';
        yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.PHONE });
        yield put({ type: "UPDATE_PHONE_SERVICES", params: BUNDLE.PHONE });

      }
      //if (retrieveCartID && response.data[DataKey]?.Addons?.StaticPackageInfo?.Products) {
      if (retrieveCartID && response.data[DataKey]?.Addons?.StaticPackageInfo?.Products) {  
        let ipkey = 'Dynamic';
        let productId = ""
        map(response.data[DataKey]?.Addons?.StaticPackageInfo?.Products, plan => {
          if (plan?.ProductName?.includes('Static IP Single') && plan?.IsSelected === true) {
            ipkey = 'Static IP Single';
            productId=plan['ProductId']??""
          }else if (plan?.ProductName?.includes('Static IP Block of 5') && plan?.IsSelected === true) {
            ipkey = 'Static IP Block of 5';
            productId=plan['ProductId']??""
          }
        });
        yield put({ type: "SET_NEW_IP_SELECTION", data: ipkey });
        yield put({type :'SET_SELECTED_STATIC_IP_NEW_3.0',data:productId})
      }

      if (response.data[DataKey]?.Addons?.StaticPackageInfo?.Products) {
        let showBox = false ;
        map(response.data[DataKey]?.Addons?.StaticPackageInfo?.Products, plan => {
          if(plan?.ProductName?.includes('Static') && plan?.IsSelected === true){ 
            showBox = true ;
          }
        });
        yield put({ type: "SHOW_BLOCK_IP_SELECTION", data: showBox });
      }

      if (retrieveCartID && response.data[DataKey]?.Addons?.VasProdInfo) {

        const techTeamInfo = response.data[DataKey]?.Addons?.VasProdInfo?.find(prod =>
          prod.CategoryName === "TechTeam for Internet")?.VasProducts;
        const yahooInfo = response.data[DataKey]?.Addons?.VasProdInfo?.find(prod =>
          prod.CategoryName === "YAHOO")?.VasProducts;
        if (techTeamInfo) {
          let VasUser;
          map(techTeamInfo, plan => {
            if (plan?.IsSelected === true) {
              VasUser = plan?.VasUser;
            }
          });
          if (VasUser) {
            yield put({ type: "SET_TECHTEAM_FORM_DATA", data: VasUser });
          }
        }

        if (yahooInfo) {
          let yahooVasUser = yahooInfo?.find(plan => plan?.IsSelected === true)?.VasUser;
          if (yahooVasUser) {
            let yahooData = {
              businessName: yahooVasUser?.businessName,
              businessCategory: yahooVasUser?.businessCategory,
              businessPhone: yahooVasUser?.businessPhone,
              isBillingPhoneRequired: yahooVasUser?.businessPhone ? 'No' : "Yes",
              categoryName: yahooVasUser?.categoryName,
            }
            yield put({ type: "SET_YAHOO_FORM_DATA", data: yahooData });
          }
        }
      }

    }
    if (request?.data?.callback) {
      request.data.callback();
    }
    else if (param === 'Back' && request && request.data) {
      const retrieveCartID = yield select(selectors.retrieveCartID);
      //temporary fix for reteieve cart, need to check how we can goback without impacting browser history
      retrieveCartID ? request.data.push('/customize-order') : request.data.goBack();

    }
  } catch (err) {
    console.log(err);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}



function redirectToLBO(data) {
  window.location.href = LBO_PAGE_REDIRECTION_URL + "?message=" + (data ? data.message : '');
}

function* updateFailureToLBO(payload) {
  try {
    // const requestObj = {
    //   messageCode,
    //   error
    // }
    const messageCode = payload.data ? payload.data.messageCode : 'NTE_GenericError';
    const response = yield apiClient.get(LBO_PAGE_API_URL + "?Message=" + messageCode);
    console.log(response)
  } catch (err) {
    console.log(err);
  }
}

function* getChatInfo(data) {
  const currentAction = window.location.pathname.split('/')[3];
  const { params } = data;
  // yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  try {
    const response = yield apiClient.get(GET_CHAT_INFO_URL + params).then(response => {
      setChatInfo(response?.data);
    });
  } catch (e) {
    console.log("chat error", e);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  } finally {
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* getDueDateInfo(enableLoading, reqFrom) {
  if (enableLoading) {
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  }
  try {
    const response = yield apiClient.get(GET_DUEDATE_URL);
    const resData = response.data;
    // const resData = {
    //     GetDueDateStatus: "SUCCESS",
    //     DueDateIntervals: '[["09/04/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["09/08/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["09/10/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["09/22/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["09/23/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["09/24/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["09/25/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["09/26/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"]],["09/28/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["09/29/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["09/30/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/01/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/02/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/03/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"]],["10/05/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/06/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/07/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/08/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/09/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/10/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"]],["10/13/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/14/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/15/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/16/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/17/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"]],["10/19/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/20/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/21/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/22/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/23/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/24/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"]],["10/26/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/27/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/28/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/29/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/30/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]],["10/31/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"]],["11/02/2020",["10:00 AM. and Noon.","1000-1200"],["8:00 AM. and 10:00 AM.","0800-1000"],["1:00 PM. and 3:00 PM.","1300-1500"],["11:30 AM. and 1:30 PM.","1130-1330"]]]',
    //     DueDates: '["09/04/2020","09/08/2020","09/10/2020","09/22/2020","09/23/2020","09/24/2020","09/25/2020","09/26/2020","09/28/2020","09/29/2020","09/30/2020","10/01/2020","10/02/2020","10/03/2020","10/05/2020","10/06/2020","10/07/2020","10/08/2020","10/09/2020","10/10/2020","10/13/2020","10/14/2020","10/15/2020","10/16/2020","10/17/2020","10/19/2020","10/20/2020","10/21/2020","10/22/2020","10/23/2020","10/24/2020","10/26/2020","10/27/2020","10/28/2020","10/29/2020","10/30/2020","10/31/2020","11/02/2020"]',
    //     appointmentCode: '[["09/04/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/08/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/10/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/22/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/23/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/24/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/25/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/26/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/28/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/29/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["09/30/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/01/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/02/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/03/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/05/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/06/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/07/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/08/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/09/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/10/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/13/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/14/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/15/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/16/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/17/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/19/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/20/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/21/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/22/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/23/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/24/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/26/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/27/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/28/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/29/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/30/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["10/31/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]],["11/02/2020",["1300-1500","N"],["1130-1330","I"],["0800-1000","Q"],["1000-1200","I"]]]'
    //   };
    if (resData.GetDueDateStatus && resData.GetDueDateStatus === "SUCCESS") {
      resData.DueDates = resData.DueDates ? JSON.parse(resData.DueDates) : [];
      resData.DueDateIntervals = resData.DueDateIntervals ? JSON.parse(resData.DueDateIntervals) : [];
      resData.appointmentCode = resData.appointmentCode ? JSON.parse(resData.appointmentCode) : [];
    } else {
      resData.DueDates = [];
      resData.DueDateIntervals = [];
      resData.appointmentCode = [];
    }
    yield put({ type: "SET_DUE_DATES", data: { response: resData } });
  } catch (err) {
    if (enableLoading) {
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    }
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });

    // added condition for avoid on checkout load lBO issue
    if (reqFrom !== 'checkout') {
      yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_CO_GetDueDates', error: err } });
    }
    console.log("chat error", err);
  } finally {
    if (enableLoading) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
  }
}

function* getOmniDueDateInfo(param) {
  const enableLoading = param?.data?.enableLoading;
  const installationType = param?.data?.type || "";
  if (enableLoading) {
     yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  }
  const optixSessionId = yield select(selectors.optixSessionId);
  const optixData = yield select(selectors.optixData);

  const requestBody = {
    "Client": {
      "Name": "GBCOM",
      "ClientId": "GBCOM",
      "RequestId": "6767"
    },
    "SessionId": optixSessionId,
    "NeedDueDatesForDTV": "",
    "InstallationType": installationType,
    "dueDates": [{
      "ExpectedDueDate": "",
      "OrderType": ""
    }],
    "ChannelType": "",
    "ChangeDueDate": "",
    "RequestInstallationTypesOnly": false,
    "NewDuedateFlow": false,
    "HadSatelliteOrDishTv": "",
    "PrepaidOrder": true,
    "PrepayCashOnlyNoCreditDueDate": "",
    "TechAssisted": "",
    "BusinessStartHr": "",
    "BusinessEndHr": ""
  }
  try {
    const response = yield apiClient.post(OMNI_GET_DUEDATE_URL, requestBody);
    const resData = formatDueDateresp(response.data);
    console.log(resData)
    if (resData.GetDueDateStatus && resData.GetDueDateStatus === "SUCCESS") {
      resData.DueDates = resData.DueDates ? resData.DueDates : [];
      resData.DueDateIntervals = resData.DueDateIntervals ? resData.DueDateIntervals : [];
      // resData.DueDateIntervals = resData.DueDateIntervals ? JSON.parse(resData.DueDateIntervals) : [];
      // resData.appointmentCode = resData.appointmentCode ? JSON.parse(resData.appointmentCode) : [];
    } else {
      resData.DueDates = [];
      resData.DueDateIntervals = [];
      resData.appointmentCode = [];
    }
    console.log(resData)
    yield put({ type: "SET_DUE_DATES_OPTIX", data: { response: resData } }); 
    if(optixData == "")
    {
      
    yield put({ type: "SET_OPTIX_OPTION_FIELD", data: { response: resData?.techOptionFields } }); 

    }
    yield put({ type: "IS_RESET_DATE_CHANGE", data: true });
     yield put({ type: "IS_OPTIX_RESPONSE", data: true });
   
     
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    if (enableLoading) {
      yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true } });
    }
    yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_CO_GetDueDates', error: err } });
    console.log("chat error", err);
  } finally {
    if (enableLoading) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
  }
}

function* reserveOmniDueDate(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: false } });
  yield put({ type: "RESERVE_DUEDATE_ERROR_OPTIX", message: '' });
  const { data } = props;

  const optixSessionId = yield select(selectors.optixSessionId);
  const requestBody = {
    "client": {
      "name": "GBCOM",
      "clientId": "GBCOM",
      "requestId": "34343",
      "appservername": "",
      "appserverip": "",
      "appservertimestamp": "",
      "ClientVersion": "",
      "SubClientId": "",
      "SubClientName": "",
      "SalesAgentId": "1234",
      "SalesAgentName": "Servicability"
    },
    "sessionId": optixSessionId,
    "setDueDateForDTV": "",
    "installationType": "",
    "selectedDueDates": [{
      "orderType": "TELCO",
      "dueDate": data.dueDate ? data.dueDate : '',
      "timeSlots": [{
        "code": data.timeSlotCode ? data.timeSlotCode : '',
      }],
      "xrmReservationId": "",
      "formattedTimeSlot": ""
    }],
    "billBycleInfo": {
      "billCycleType": "",
      "isBillMsgChecked": "",
      "isRenegociateDD": ""
    },
    "dtvComments": {
      "installationComments": "",
      "drivingDirections": ""
    },
    "IsVZWDataOfferSelected": "",
    "IsSelfInstallRewardCardSelected": "",
    "IsPremiumDateAdded": "",
    "IsDirectShipDateSelected": "",
    "IsOverrideDateSelected": "",
    "overrideCode": "",
    "overrideComments": "",
    "overrideType": "",
    "EarliestDeliveryAcceptDate": "",
    "IsVZWJetPackSelected": "",
    "DuedateAdditionalReqInfoSet": {
      "AdditionalReqInfo": [{
        "key": "",
        "value": ""
      }]
    },
    "missedAppointmentCode": ""
  }

  try {
    const response = yield apiClient.post(OMNI_RESERVE_DUE_DATE_URL, requestBody);
    // let response = {
    //   "data": {
    //     "outputField": {
    //       "sessionIdField": "UAT-632c0049-ab3b-473c-a94f-00132bb5af8e",
    //       "dueDatesSetField": [
    //         {
    //           "orderTypeField": "TELCO",
    //           "codeField": null,
    //           "messageField": null,
    //           "startDateTimeField": null,
    //           "endDateTimeField": null,
    //           "dueDateField": "10/07/2020",
    //           "timeslotField": {
    //             "intervalField": "",
    //             "codeField": "10:00-12:00"
    //           }
    //         }
    //       ],
    //       "ddReservedField": {
    //         "reservedField": "Y"
    //       }
    //     },
    //     "exceptionField": null,
    //     "statusReportField": {
    //       "sessionIdField": "UAT-632c0049-ab3b-473c-a94f-00132bb5af8e",
    //       "statusField": [
    //         {
    //           "sourceField": "OVERALL",
    //           "codeField": "0",
    //           "messageField": "SUCCESS",
    //           "detailsField": "SUCCESS"
    //         }
    //       ]
    //     }
    //   }
    // };
    //if (response && response.data?.statusReportField?.statusField[0]?.messageField?.toLowerCase() === "success") {
    if (response?.data?.outputField?.dueDatesSetField?.length > 0 && response.data.outputField.dueDatesSetField[0]?.messageField?.toLowerCase() === "success") {
      response.data.Status = 'SUCCESS';
      yield put({ type: "SAVE_SUBMITORDER_INFO_OPTIX", data: response.data });
    } else {
      response.data.Status = 'FAIL';
      yield put({ type: "SAVE_SUBMITORDER_INFO_OPTIX", data: response.data });
      throw new Error();
    }
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "RESERVE_DUEDATE_ERROR_OPTIX", message: 'Selected Slot in the given Due Date is not available.  Please select other Slot/Date' });
    // yield put({ type: "UPDATE_FAILURE_LBO", data: { messageCode: 'NTE_CO_SetDueDate', error: err } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* getYahooRelatedCategoriesAndBusinessAddress() {
  //yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  try {

    const response = yield apiClient.get(GET_YAHOO_CATEGORIES_DATA_URL);
    if (response && response.data) {
      yield put({ type: "SAVE_YAHOO_CATEGORY_DETAILS", data: response.data });
    }
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
  finally {
    // yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* checkYahooEligibility(request) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "SAVE_YAHOO_DUPE_CHECK_FAILED_RESPONSE", data: { responseMsg: "" } });

  const  {params} = request.payload;
  const { showAddService } = request.payload;

  try {
    let response = '';
    if (params.isBillingPhoneRequired == "Yes") {
      // yield new Promise(resolve => setTimeout(resolve, 10));
      yield put({ type: "SAVE_YAHOO_DUPE_CHECK_SUC_RESPONSE", data: { params, response, responseMsg: "Listing Approved" } });
    } 
    if(showAddService) {
      response = yield apiClient.post(YAHOO_DUPE_CHECK, params)
        .then(response => {
          return response.data;
        });

      if (response.success && !response.potentialDuplicate) {
        yield put({ type: "SAVE_YAHOO_DUPE_CHECK_SUC_RESPONSE", data: { params, response, responseMsg: "Listing Approved" } });
      } else if (response.success && response.potentialDuplicate) {
        yield put({ type: "SAVE_YAHOO_DUPE_CHECK_SUC_RESPONSE", data: { params, response, responseMsg: "Paid listing already exists for this business location" } });
      } else {
        yield put({ type: "SAVE_YAHOO_DUPE_CHECK_FAILED_RESPONSE", data: { responseMsg: "" } });
      }
    }
  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
  finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* clearEligibilityForm() {
  yield put({ type: "SET_YAHOO_FORM_TO_DEFAULT" });
}

function* clearYahooEligibilityResponse() {
  yield put({ type: "SET_YAHOO_ELIGIBILITY_RESPONSE_TO_DEFAULT" });
}

function* getOmniCartInfo(params) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  yield put({ type: "UPDATE_OMNI_CART_ERROR", data: false });

  //clean up
  /*const optixSessionId = yield select(selectors.optixSessionId);
  const address = yield select(selectors.selectedStreetAddress);
  const priceQuoteNumber = yield select(selectors.priceQuoteNumber);*/
  const priceQuoteNumber = yield select(selectors.priceQuoteNumber);
  let isDirectCheckout = false
  if (params.priceQuoteNumber) {
    isDirectCheckout = true
  }

  const requestBody = {
    //AddressID: address?.ntasAddrID,
    PriceQuoteNumber: params.priceQuoteNumber || priceQuoteNumber,
    IsDirectCheckout: isDirectCheckout
    //SessionID: ""
  };
  try {
    const response = yield apiClient.post(OPTIX_QUOTE_BY_ID, requestBody);
    if (response && response.data) {
      // const sessionId = response.data.SessionId?.split("-").filter((s, index) => !!index).join("-");
      const sessionId = response.data.SessionId;
      // remove hardcoded value
      // const sessionId = "FLDSVC-c84d2fe9-3b00-4276-9f54-1ae8286c051d";

      yield put({ type: "SAVE_ADDRESS_OMNI_CART_FLOW", data: response.data.OmniServiceAddressInfo })
      yield put({ type: "SAVE_OMNI_CART_INFO", data: response.data });
      yield put({ type: "SAVE_OPTIX_SESSION_ID", data: sessionId });
      yield put({ type: "SAVE_OPTIX_EPSESSION_ID", data: response.data.EpSessionId });
      if (!response.data.OmniServiceAddressInfo || response.data.ErrorMessage === "FBEResponse Null") {
        yield put({ type: "UPDATE_OMNI_CART_ERROR", data: true });
      } else {
        SiteAnalytics.trackPageInfo('Checkout');
        SiteAnalytics.trackOptixQuoteNumber('');
        SiteAnalytics.trackOmniCheckoutProdSelection(response.data);
      }
    } else {
      throw new Error();
    }
  } catch (e) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
    yield put({ type: "REDIRECT_TO_LBO", message: 'NTE_CO_GenericError' });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* getOmniOloDetails(data) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  const props = data.data;
  const requestBody = {
    "MonNo": props.monNumber,
    "DueDate": (props.optixDueDate || '') + ' ' + (props.optixTimeslot || ''),
    "EmailId": props.optixCheckout?.contactInfo?.email,
    "LastName": props.lastName,
    "ZipCode": props.zipCode,
    "FlowType": "FIOS",
    "FirstName": props.firstName,
    "DSLStatus": "",
    "FiosStatus": "Selected",
    "MobileNumber": props.optixCheckout?.contactInfo?.phoneNumber,
    "DSLInstallInfo": "TECH INSTALL"
  };

  try {
    const response = yield apiClient.post(OMNI_OLO_DETAILS, requestBody);
    if (response?.data) {
      yield put({ type: "SAVE_OMNI_OLO_DETAILS", data: response.data });
    }
  } catch (e) {
    console.log(e);
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* postEventLogging(event) {
  if (UI_EVENT_LOGGING === true || UI_EVENT_LOGGING === 'true') {

    const lqPostData = yield select(selectors.lqPostData);
    const optixEpSessionId = yield select(selectors.optixEpSessionId);
    const token = yield select(selectors.apigeeAccessToken);
    const sessionId = lqPostData?.EPSessionID || optixEpSessionId || event?.data?.doLoopSessionId;
    let requestBody = {
      sessionId: sessionId,
      eventType: event?.data?.eventType || "log",
      eventName: event?.data?.eventName || "",
      sectionName: event?.data?.sectionName || "",
      pageName: window.location.pathname,
      timestamp: "",
      beginTime: "",
      endTime: "",
      logs: event?.data?.log ? event?.data?.log.toString(): '' || event?.data?.message ? event?.data?.message.toString():'' || token || "",
      comments: event?.data?.comments || token || "",
    };
    const date = new Date();
    date.setHours(date.getHours() - 5);
    if (event.type == 'TOGGLE_LOADING_SPINNER') {
      if (window.spinnerToggle === event.data) {
        return;
      }
      window.spinnerToggle = event.data;
      requestBody.eventName = "Loading Spinner";
      if (event.data) {
        window.beginTimer = date;
        requestBody.beginTime = window.beginTimer;
      }
      else {
        window.endTimer = date;
        requestBody.beginTime = window.beginTimer;
        requestBody.endTime = window.endTimer;
        requestBody.delay = (window.endTimer - window.beginTimer) / 1000;
      }
    }
    if ((sessionId || event?.data?.sync) && event.type !== 'TOGGLE_LOADING_SPINNER' && event?.data?.eventName !== "") {
      const contentSquareSessionSent = yield select(state=>state.AddressValidationPage.contentSquareSessionSent)
    if(sessionId && window.newrelic && window.newrelic.info && window.newrelic.info.jsAttributes && window.newrelic.info.jsAttributes.ContentsquareReplay && !contentSquareSessionSent){
      yield put({type:'CONTENT_SQUARE_SESSION_SENT',data:window.newrelic.info.jsAttributes.ContentsquareReplay})
      requestBody = {...requestBody , ContentSquareLink:window.newrelic.info.jsAttributes.ContentsquareReplay}
    }
      try {
        if (event?.data?.sync) {
          yield apiClient.post(POST_UI_EVENT_LOGGING, requestBody);
        } else {
          // setTimeout(() => {
            apiClient.asyncPost(POST_UI_EVENT_LOGGING, requestBody);
          // }, 100)
        }
        if (window?.newrelic?.addPageAction && event.type != 'TOGGLE_LOADING_SPINNER' && requestBody.eventType != 'ERROR') {
          // window.newrelic.addPageAction(requestBody.eventName, {data: requestBody}); 
        }
        return;
      } catch (e) {
        console.log(e);
      }
    }
  }
}

function* refreshApigeeToken() {
  try {
    const route = window.location.pathname.split("/foryoursmallbiz/gborder")[1];
    const fiosRoute = window.location.pathname.split("/foryoursmallbiz/internet")[1];
    if (route === '/' || route === "" || fiosRoute === '/' || fiosRoute === "") {
      yield* initiateGlobalSession();
    }
  } catch (e) {

  }
}

function* getLqPageAds() {
  // disable api cache mechanism
  const headers = {
    headers: {
      'cache-control': 'no-cache',
      'pragma': 'no-cache'
    }
  };
  try {
    // const res = yield apiClient.get(LQ_ADS, headers);
    // if (res?.data) {
    // yield put({ type: "SAVE_AD_RESPONSE", data: res.data });
    yield put({ type: "SAVE_AD_RESPONSE", data: LQAds });
    // }
  } catch (e) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  }
}

function* addTechTeamUsers(props) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });

  const { eligibilityFrm, selectedAddonDetails } = props.data;

  const lqPostData = yield select(selectors.lqPostData);
  const optixEpSessionId = yield select(selectors.optixEpSessionId);
  const sessionId = lqPostData?.EPSessionID || optixEpSessionId;
  const requestBody = {
    FirstName: eligibilityFrm?.FirstName,
    LastName: eligibilityFrm?.LastName,
    Phone: eligibilityFrm?.Phone,
    Email: eligibilityFrm?.Email,
    SessionId: sessionId,
    VasId: selectedAddonDetails[0]?.PkgID,
    VasProdId: selectedAddonDetails[0]?.PrdID,

  };

  try {
    const response = yield apiClient.post(ADD_TECHTEAM_USER_URL, requestBody);
    if (response && response.data) {

    }
  } catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_GLOBAL_ERROR_MESSAGE", data: { enableNotification: true, message: ERROR_MESSAGE.TECHNICAL_ISSUE } });
  } finally {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}

function* saveConversationInfo(params) {
  console.log('chat', params)
  try {
    let response = yield apiClient.get(SAVE_CONVERSATION + params?.data);
    if (response?.data == "Success") {
      yield put({ type: "SET_CONV_INFO", data: params?.data });
    } else {
      yield put({ type: "SET_CONV_INFO", data: '' });
    }
  }
  catch (e) {
    yield put({ type: "SET_CONV_INFO", data: '' });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: e } });
  }
}

function* redirectionHandler(params) {
  // const selectedZipcode = yield select(selectors.selectedZipcode);
  const selectedStreetAddress = yield select(selectors.selectedStreetAddress);
  const addressQualificationDetails = yield select(selectors.addressQualificationDetails);
  const phoneNumber = yield select(selectors.phoneNumber);
  const email = yield select(selectors.email);
  const cmpCodeForWireless = yield select(state=>state.AddressValidationPage.cmpCodeQueryParamWirelesss)
  const mtn = phoneNumber ? phoneNumber?.replace(/-/g, "") : "";
  const emailLq = email ? email.trim() || "" : '';
  let selectedUnit = yield select(selectors.selectedUnit);
  const lqQualificationDetails = yield select(selectors.lqQualificationDetails);
  if (!isNightTimeWindow() && !window.redirectionExecuted) {
    SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
    SiteCatalyst.trackProductsList(window.LQResponse);
    SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
    if (addressQualificationDetails?.Qualified == "true" || addressQualificationDetails?.QualifiedCBand === 'true') {
      SiteCatalyst.trackLQSuccess5G(window.LQRequestBody, { type: '5G Redirection', data: window.LQResponse });
    } else {
      SiteCatalyst.trackLQSuccess4G(window.LQRequestBody, { type: '4G/LTE Redirection', data: window.LQResponse });
    }

    if (window?.newrelic?.addPageAction) {
      window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
      if (addressQualificationDetails?.Qualified == "true" || addressQualificationDetails?.QualifiedCBand === 'true') {
        window.newrelic.addPageAction('LQSuccess5G', { data: window.LQRequestBody });
      } else {
        window.newrelic.addPageAction('LQSuccess4G', { data: window.LQRequestBody });
      }
    }
  }

  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  try {
    const requestBody = {
      "zipCode": selectedStreetAddress?.zip,
      "city": selectedStreetAddress?.muni || '',
      "state": selectedStreetAddress?.state || '',
      "unit": selectedUnit ? selectedUnit : '',
      streetAddress:
        selectedStreetAddress && selectedStreetAddress?.dispstr
          ? selectedStreetAddress.dispstr
          : ""
    }


    if (addressQualificationDetails?.Qualified == "true" || addressQualificationDetails?.QualifiedCBand === 'true') {
      if (!window.redirectionExecuted) {
        window.redirectionExecuted = true;
        SiteAnalytics.track5GEligibleRedirection();
        const event = { data: { log: "Redirecting to 5G", doLoopSessionId: addressQualificationDetails?.sessionId, eventType: 'log', eventName: "5G_PageLoad", sectionName: "Page", sync: true } }
        yield call(postEventLogging, event);
      }
      if(addressQualificationDetails?.LQPost?.S2SLBO == "Y"){
        yield put({ type: "REDIRECT_TO_LBO", message: 'S2SLBO' });
      }
      // if(addressQualificationDetails?.LQPost?.S2SLBO == "N"){
      if (addressQualificationDetails?.GUIEncryptSessionId) {
        if(addressQualificationDetails?.FiveGRedirectUrl) window.location.href= addressQualificationDetails?.FiveGRedirectUrl + `?redirectedFrom=BBA&lqsessionId=${addressQualificationDetails?.GUIEncryptSessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
        else window.location.href = REDIRECT_5G_URL + `?redirectedFrom=BBA&lqsessionId=${addressQualificationDetails?.GUIEncryptSessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
      } else {
        if(addressQualificationDetails?.FiveGRedirectUrl) window.location.href= addressQualificationDetails?.FiveGRedirectUrl + `?redirectedFrom=BBA`
        else window.location.href = REDIRECT_5G_URL + `?redirectedFrom=BBA`
      }
      // }
    } else {
      if (!window.redirectionExecuted) {
        window.redirectionExecuted = true;
        SiteAnalytics.track4GEligibleRedirection();
        const event = { data: { log: "Redirecting to 4G", doLoopSessionId: addressQualificationDetails?.sessionId, eventType: 'log', eventName: "4G_PageLoad", sectionName: "Page", sync: true } }
        yield call(postEventLogging, event);
      }
      if (addressQualificationDetails?.GUIEncryptSessionId || lqQualificationDetails?.GUISessionId) {
        if(addressQualificationDetails?.LTERedirectUrl) window.location.href = addressQualificationDetails?.LTERedirectUrl + `?redirectedFrom=BBA&lqsessionId=${addressQualificationDetails?.GUIEncryptSessionId || lqQualificationDetails?.GUISessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
        else window.location.href = REDIRECT_4G_URL + `?redirectedFrom=BBA&lqsessionId=${addressQualificationDetails?.GUIEncryptSessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
      } else {
        if(addressQualificationDetails?.LTERedirectUrl) window.location.href = addressQualificationDetails?.LTERedirectUrl + `?redirectedFrom=BBA`
        else window.location.href = REDIRECT_4G_URL + `?redirectedFrom=BBA`
      }
    }
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
  catch (err) {
    console.log(err)
  }
}

export function* getQulaificationDetails({data}) {
  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    const cmpCodeForWireless = yield select(state=>state.AddressValidationPage.cmpCodeQueryParamWirelesss)
    //  const params = new URLSearchParams(window.location.search);
    // const safeEncode = (v) => encodeURIComponent(v || "");
    // const cmp = safeEncode(params.get("cmp"));
    // let showVcgModal=CheckAEMBoolValue(i18next.t("fios.showVcgModal", { ns: "fios"}))
		// let vcgCmpList = i18next.t("fios.vcgCmpList", { ns: "fios",returnObjects:true });
		// let isVcgCmpExist = vcgCmpList && Array.isArray(vcgCmpList) && cmp ? vcgCmpList.some(cmpVal => decodeURIComponent(cmp) === cmpVal) : false;
    // if(showVcgModal && isVcgCmpExist){
    //   // below block is for vcg flow to store the query params in url
    //   const scartId = safeEncode(params.get("scartId"));
    //   const monNO = params.get("monNo") || "";
    //   const cid = safeEncode(params.get("cid"));
    //   const SMBBANNERID = safeEncode(params.get("SMBBANNERID"));
    //   const source = safeEncode(params.get("source"));
    //   yield put({ type: "SET_C_MP", data: cmp });
    //   yield put({ type: "SET_SOURCE", data: source });
    //   yield put({ type: "SET_SMB_BANNERID", data: SMBBANNERID });
    //   yield put({ type: "SET_CART_MON", data: monNO });
    //   yield put({ type: "SET_CART_ID", data: scartId });
    //   yield put({ type: "SET_C_ID", data: cid });
    // }
    
    const response = yield apiClient.get(GET_FIOS_LQ_DETAILS + `?cid=${data?.cid}`);
    yield put({ type: "SAVE_FIOS_LQ_IsNYDMA", data: response?.data?.IsNYDMA || "N"});
    if(response?.data?.Qualified_4g==='Y'&&response?.data?.DoLoopResponse!==null&&response?.data?.DoLoopResponse&&response?.data?.DoLoopResponse?.DataInfo!==null&&
      response?.data?.DoLoopResponse?.DataInfo&&(response?.data?.DoLoopResponse?.DataInfo?.Plans===null||
        response?.data?.DoLoopResponse?.DataInfo?.Plans===undefined||(typeof response?.data?.DoLoopResponse?.DataInfo?.Plans=='object'&&response?.data?.DoLoopResponse?.DataInfo?.Plans.length===0))){
    if (response?.data?.GUISessionId) {
        window.location.href = REDIRECT_4G_URL + `?redirectedFrom=BBA&lqsessionId=${response?.data?.GUISessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
      } 
      else {
        window.location.href = REDIRECT_4G_URL + `?redirectedFrom=BBA`
      }
    }
    if (response?.data?.FiOSDataStatus !== "Y" && response?.data?.HSIStatus !== "Y" &&
      response?.data?.IDEQualified !== "Y") {
      if (response?.data?.GUISessionId) {
        window.location.href = REDIRECT_4G_URL + `?redirectedFrom=BBA&lqsessionId=${response?.data?.GUISessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
      } 
      else {
        window.location.href = REDIRECT_4G_URL + `?redirectedFrom=BBA`
      }
    }
    if (!(response?.data?.FiOSDataStatus !== "Y" && response?.data?.HSIStatus !== "Y" &&
      response?.data?.IDEQualified !== "Y")) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    }
    const getPostLqDataResponse = JSON.parse(JSON.stringify(response?.data?.DoLoopResponse?.LQPost))
    if (!response?.data?.Retry) {
      if (data?.source!==null&&data?.source&&data?.source !== 'FIOSAPI') {
        yield put({ type: "GET_RETRIEVE_ORDER", params: data });
      } else {
        yield put({ type: "IS_FIOS_JOINT_OFFER", data: response?.data?.DoLoopResponse?.LQPost?.EnableJointOffer });      
        yield put({ type: "SAVE_ADDRESS_QUALIFICATION_DETAILS", data: response?.data?.DoLoopResponse });
        yield put({ type: "GET_POST_LQ_DATA_RESPONSE", data: getPostLqDataResponse });
        // yield put({ type: "IS_FIOS_WIRELESS", data: isfiosWireless  });
       


       let jointOffer  =  response?.data?.jointoffer;
       if(jointOffer && jointOffer?.JointofferStatus == 'Y'){
        yield put({
          type: "JOINT_OFFER_AVAILABILITY_RESPONSE", data: {
            JointOfferPrice: jointOffer?.JointOfferPrice,
            JointofferStatus: jointOffer?.JointofferStatus,
            OneGigSpeedPrice: jointOffer?.OneGigSpeedPrice
          }
        });
       }
       else{
        yield put({
          type: "JOINT_OFFER_AVAILABILITY_RESPONSE", data: {          
            JointofferStatus: 'N',
           
          }
        });
       }
        

        yield put({ type: "DO_LOOP_TRIGGERED", data: false })
        window.LQResponse = response?.data?.DoLoopResponse;
        if (response?.data?.DoLoopResponse?.LQPost?.HSIStatus === "Y") {
          SiteCatalyst.trackLQAttempts(window.LQRequestBody, {
            type: "lq-address-validation",
            data: window.LQResponse,
          });
        }
        dispatchEvent('recievedDoLoopResponse', true);
        yield put({ type: "CUST_API_TRIGGERED", data: false });
        if (response?.data?.DoLoopResponse?.LQPost?.FiOSDataStatus === 'Y') {
          yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA });
        } else {
          yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.HSI });
        }

        if (response?.data?.DoLoopResponse?.LQPost?.EPSessionID && window?.newrelic?.setCustomAttribute) {
          window.newrelic.setCustomAttribute("EPSessionId", response.data.DoLoopResponse.LQPost.EPSessionID);
          window.newrelic.setCustomAttribute("GUISessionID", response.data.DoLoopResponse.LQPost.GUISessionID);
        }
        
        yield put({ type: "SET_INTERNET_TYPE", data: response?.data?.DoLoopResponse?.DataInfo?.Plans[0]?.ServiceType });
        yield put({ type: "SET_ROUTER_LIST", data: response?.data?.DoLoopResponse?.DataInfo?.Routers });
        if (!(window.isRedirected )) {
          yield call(getFloatingCartDetails);
          const getCustApiTriggered = yield select(selectors.customizeProductsResponse);
          if (!getCustApiTriggered) {
            yield put({ type: "FETCH_CUSTOMIZE_PRODUCTS", params: {} });
          }
          // if (response?.data?.HasPendingOrder !== 'Y') {
          //   data.params.history.push('/customize-order');
          // }
          window.isRedirected = null;
        }
      }
    } else {
      console.log("====> Retry working")
      window.qualificationRetry++;
      if (window.qualificationRetry <= 5) {
        yield put({ type: "GET_QUALIFICATION_DETAILS", data: data });
      } else {
        if (data?.source!==null&&data?.source&&data?.source !== 'FIOSAPI') {
          yield put({ type: "GET_RETRIEVE_ORDER", params: data });
        } else {
          yield put({ type: "FETCH_CUSTOMIZE_PRODUCTS", params: {} });
        }
      }
    }
    yield put({ type: "SET_LQ_QUALIFICATION_RESPONSE", data: response?.data });

  }
  catch (err) {
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
  }
}


export function* processBannerProductCall(response) {
  const bannerInfo = yield select(selectors.bannerInfo);
  const applicableSrvc = getapplicableBundle(bannerInfo);
  const lqPostData = yield select(selectors.lqPostData);
  yield put({ type: "UPDATE_PAGELOAD_TYPE", data: 'C' });
  if (bannerInfo && (applicableSrvc?.bundleFlowType === BUNDLE.DATA || applicableSrvc?.bundleFlowType === BUNDLE.HSI)) {
    if (response?.data?.DataInfo) {
      let params = { type: 'data' }
      yield put({ type: "SET_INTERNET_TYPE", data: response?.data?.DataInfo?.Plans[0]?.ServiceType });
      yield put({ type: "SET_ROUTER_LIST", data: response?.data?.DataInfo?.Routers });
      let bannerInternetObj = bannerInfo ? getBannerInternetSelectedPlan(response?.data?.DataInfo, bannerInfo) : '';
      let internetPlanData = bannerInfo && bannerInternetObj ? bannerInternetObj : response?.data?.DataInfo?.Plans[0];
      const infoParams = {
        bundleID: internetPlanData?.PackageId, tvID: 0, nLines: 1, contract: internetPlanData?.Contract,
        hcid: internetPlanData?.ProductId ? internetPlanData?.ProductId : '', ptype: internetPlanData?.ServiceType ? internetPlanData?.ServiceType : '', bRc: internetPlanData?.Price,
        upselSelected: false
      };
      const newFlowInternetType = infoParams.ptype;
      if (lqPostData?.FiOSDataStatus == "Y" || lqPostData?.HSIStatus == "Y") {
        yield* getSelectedBundleInfo({ infoParams, params }, true);
      }
      yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: newFlowInternetType });
    }
  } else if (bannerInfo && applicableSrvc?.bundleFlowType === BUNDLE.BDV) {
    let valueList = getBDVValues(response?.data);
    const bRc = valueList.businessVoice.Price;
    const bundleID = valueList.businessVoice.ProductId;
    const SABdvFormData = `bundleID=${bundleID}&bRc=${bRc}&Nlines=1&contract=TwoYears`
    yield* getSABDV({ params: SABdvFormData });
  } else if (bannerInfo && applicableSrvc?.bundleFlowType === BUNDLE.VIDEO) {
    let bannerTVObj = bannerInfo ? getBannerTVSelectedPlan(response?.data?.FiosTVInfo, bannerInfo) : '';
    let tvPlanData = bannerInfo && bannerTVObj ? bannerTVObj : response?.data?.FiosTVInfo?.Plans?.MainPlan?.PrivatePlan[0];
    const infoParams = {
      bundleID: tvPlanData?.PackageId ? tvPlanData.PackageId : '23851082',
      tvID: tvPlanData?.ProductId,
      nLines: 1,
      // contract: selectedContract === "2 year agreement" ? 'TwoYears' : 'MonthToMonth', //input.Contract,
      contract: 'TwoYears',
      hcid: tvPlanData?.ProductId,
      ptype: 'TV',
      bRc: tvPlanData?.Price,
      upselSelected: false
    };
    let params = { type: 'standalone_tv' };
    yield* getSelectedBundleInfo({ infoParams, params });
  } else if (bannerInfo && applicableSrvc?.bundleFlowType === BUNDLE.DATA_BDV) {
    if (response.data?.BDVFIOSDP) {
      let bannerInternetBDVObj = getBannerInternetSelectedPlan(response?.data?.BDVFIOSDP, bannerInfo);
      console.log('Banner bannerInternetBDVObj', bannerInternetBDVObj)
      let bundleInfo = bannerInternetBDVObj ? bannerInternetBDVObj : response?.data?.BDVFIOSDP?.Plans[0];

      yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.DATA_BDV });
      yield put({ type: "SET_ROUTER_LIST", data: response?.data?.BDVFIOSDP?.Routers });

      const FiosBdvFormData = {
        bundleID: bundleInfo?.BundleId,
        dpackgeId: bundleInfo?.PackageId,
        dHcid: bundleInfo?.ProductId,
        contract: bundleInfo?.Contract,
        bdvID: bundleInfo?.BDVId,
        ptype: bundleInfo?.Flowtype,
        bRc: bundleInfo?.Price,
        Nlines: 1,
        upselSelected: false,
        TVPackageId: 0,
        TVHCID: 0,
      };
      let isSelectedBundlePlan = response.data?.BDVFIOSDP?.Plans.find((item) => {
        return item?.IsSelected === true;
      });

      yield put({ type: "UPDATE_INTERNET_PLAN_ID", internetPlanID: isSelectedBundlePlan?.ProductId });
      yield* getCustomizeBDVFiosBundleInfo({ params: { FiosBdvFormData: FiosBdvFormData } });
      yield put({
        type: "UPDATE_SELECTED_INTERNET_PLAN", params: {
          bundleID: bundleInfo?.ProductId?.toString(),
          hcid: bundleInfo?.PackageId?.toString(), ProductName: bundleInfo?.ProductName
        }
      });
      yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: 'FIOS' });
    }
  } else if (bannerInfo && applicableSrvc?.bundleFlowType === BUNDLE.FLEX) {

    const filteredPrds = response?.data?.FlexInfo?.Plans?.length && response?.data?.FlexInfo?.Plans?.filter(eachInfo => {
      return (eachInfo.IPType === "Dynamic" && eachInfo.Contract === "TwoYears");
    });

    let bannerInternetTVObj = getBannerInternetSelectedPlan({ Plans: filteredPrds }, bannerInfo);
    console.log('Banner bannerInternetTVObj', bannerInternetTVObj)
    let flexBundleInfo = bannerInternetTVObj ? bannerInternetTVObj : filteredPrds[0];
    const flexFormData = {
      BID: flexBundleInfo.BundleId,
      dPAKGID: flexBundleInfo.DataPackageId,
      dHCID: flexBundleInfo.DataProductId,
      contract: flexBundleInfo.Contract,
      RC: flexBundleInfo.Price,
      TVPackageID: flexBundleInfo.TVPackageId,
      TVHCID: flexBundleInfo.TVProductId,
    };

    yield* getFlexSelection({ data: { flexFormData: flexFormData } });
  } else if (bannerInfo && applicableSrvc?.bundleFlowType === BUNDLE.BDV_DATA_VIDEO) {
    if (response.data?.BDVFIOSTP) {
      let bannerInternetBDVObj = getBannerInternetSelectedPlan(response?.data?.BDVFIOSTP, bannerInfo);
      console.log('Banner bannerInternetBDVObj', bannerInternetBDVObj)
      let bundleInfo = bannerInternetBDVObj ? bannerInternetBDVObj : response?.data?.BDVFIOSTP?.Plans[0];

      yield put({ type: "UPDATE_SERVICES_IN_CART", params: BUNDLE.BDV_DATA_VIDEO });
      yield put({ type: "SET_ROUTER_LIST", data: response?.data?.BDVFIOSTP?.Routers });

      const FiosBdvFormData = {
        bundleID: bundleInfo?.BundleId,
        dpackgeId: bundleInfo?.DataPackageId,
        dHcid: bundleInfo?.DataProductId,
        contract: bundleInfo?.Contract,
        bdvID: bundleInfo?.BDVId,
        ptype: bundleInfo?.Flowtype,
        bRc: bundleInfo?.Price,
        Nlines: 1,
        upselSelected: false,
        TVPackageID: bundleInfo.TVPackageId,
        TVHCID: bundleInfo.TVProductId,
      };
      const flowType = FLOW.TRIPLE;
      yield put({ type: "UPDATE_INTERNET_PLAN_ID", internetPlanID: bundleInfo?.ProductId });
      yield* getCustomizeBDVFiosBundleInfo({ params: { FiosBdvFormData: FiosBdvFormData, flowType: flowType } });
      yield put({
        type: "UPDATE_SELECTED_INTERNET_PLAN", params: {
          bundleID: bundleInfo?.ProductId?.toString(),
          hcid: bundleInfo?.PackageId?.toString(), ProductName: bundleInfo?.ProductName
        }
      });
      yield put({ type: "SET_NEWFLOW_INTERNET_TYPE", data: 'FIOS' });
    }

  }
}

export function* GetBDVTNs(params) {
  try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    const response = yield apiClient.get(GET_BDV_TNS_URL + params?.data);
    if (response?.data) {
      let TNObject = response.data?.TNObject;
      yield put({ type: "SET_GET_BDV_TN_RESP", data: TNObject });
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      if(params?.callback && typeof params?.callback == 'function' && !!response.data && response.data.TNObject && response.data.TNObject.length){
        let bdvSubsLines = []
        let responses=TNObject.length>params.data?TNObject.slice(0,params.data):TNObject;
        yield put({ type: "SET_BDVW_PHONE_LINES_RESPONSE", data: responses });
        responses.map((data,i)=>{
                bdvSubsLines.push({
                    LineNO:i+1,
                    OldTN:(data['TN']).replace(/-/g, ""),
                    OldPlanID:data['ProductID'],
                    OldIsWB:"",
                    NewTN:(data['TN']).replace(/-/g, ""),
                    NewPlanID:data['ProductID'],
                    NewIsWB:"",
                    selected:(data?.SubscriberInfo?.SubscriberType) == "" ? "desktop" : (data?.SubscriberInfo?.SubscriberType).toLowerCase(),
                    SubscriberInfo:{"TN":(data['TN']).replace(/-/g, ""),"SubscriberType":(data?.SubscriberInfo?.SubscriberType) == "" ? "desktop" : (data?.SubscriberInfo?.SubscriberType).toLowerCase(),"Email":"","IsBDVWAdmin":i+1 == 1 ? "Y" : "N"}
                })
            })
          yield put({ type: "SET_BDVW_PHONE_LINES", data: bdvSubsLines });
        const requestBody ={
          "type":"BDV",
          "data":{
              "BdvPhoneLines":bdvSubsLines
          }
      }  
        params.callback(requestBody)
      }
    }
  }
  catch (err) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
  }
}
function* autoPaySavePaymentMethods(ParamObject) {

  try {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
  const response = yield apiClient.post(AUTOPAY_PAYMENT_SAVE_URL, ParamObject.data);
  if (response&&response?.data) {
    yield put({ type: "AUTOPAY_PAYMENT_METHOD_RESPONSE", data: response.data });
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });

  }
  } catch (err) {
  yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });

   }
  }

  function* postOtp(param) {
    try {     
      yield put({ type: "UPDATE_POST_VALIDATE_OTP_RESPONSE", data: {} });  
      const requestBody =
      {
        "smsNumber": param.data
      }
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    const response = yield apiClient.post(POST_OTP, requestBody);
    console.log("otp response",response);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    yield put({ type: "UPDATE_POST_OTP_RESPONSE", data: response });
    } catch (err) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    
        }
    }
    function* postValidateOtp(param) {
      try {
        const enableNewLowerFunnelFlag = CheckAEMBoolValue(i18next.t("enableVDS3LF",{ns:"customize-order"}));
          if(!enableNewLowerFunnelFlag){
            yield put({ type: "UPDATE_POST_OTP_RESPONSE", data: {} });
          }
        const requestBody =
        {
          "OTPPin": param.data
        }
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
      const response = yield apiClient.post(POST_VALIDATE_OTP, requestBody);
      console.log("otp code response",response);
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      yield put({ type: "UPDATE_POST_VALIDATE_OTP_RESPONSE", data: response });
      } catch (err) {
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      
          }
      }

  function* enrollPFB(ParamObject) {

    try {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
    const response = yield apiClient.post(ENROLL_PFB_URL, ParamObject.data);
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    } catch (err) {
    yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
    
        }
    }

    function* getFCCTemplate(){
      try{
        // const response = yield apiClient.get(FWA_WIDGET_TEMPLATE_URL);
        // if(!response || !response.data || String(response.data).toLowerCase().includes('exception')){
            const resp1 = yield apiClient.get(FCC_TEMPLATE_URL);
            if(resp1.data!==null&&resp1.data) yield put({type:'SET_FCC_TEMPLATE',data:JSON.stringify(resp1.data)})
            else yield put({type:'SET_FCC_TEMPLATE',data:JSON.stringify(Template)})
        // } else if(JSON.parse(response.data)['head']) yield put({type:'SET_FCC_TEMPLATE',data:response.data})
        // else throw new Error('FCC Template Error')
      }catch(e){
        yield put({type:'SET_FCC_TEMPLATE',data:JSON.stringify(Template)})
        console.log(e)
      }finally{
        yield put({type:'SET_FCC_TEMPLATE_API_TRIGGERED',data:true}) 
      }
    }
    function* storeFCCTemplate(params){
      try{
        const response = yield apiClient.post(STORE_FCC_URL,params.data);
      }catch(e){
        console.log(e)
      }
    }
    function* fetchLocusInfo(params){
      try{
        const token = yield select(selectors.apigeeAccessToken);
    
        const config = {
          headers: {
            apikey:process.env.REACT_APP_ATOM_SEARCH_BY_LOCATION_URL_APIKEY
          }
        }
        const response = yield apiClient.post(FETCH_LOCUS_INFO,params.data,config);
        if(response?.data){
          let responseData = {}
          if(typeof response.data == 'string') responseData = JSON.parse(response.data)
          else if(typeof response.data == 'object') responseData = response.data
        if(responseData && typeof responseData == 'object' && responseData?.addressInfo && responseData?.addressInfo.length && typeof responseData?.addressInfo == "object"){
          const  { standardizedAddress } = responseData?.addressInfo[0]
          yield put({type:'SET_ADDRESS_SEARCH_BY_LOCATION',data:standardizedAddress})
          const selectedStreetAddress = {
            "zip": standardizedAddress['postalCodeBase'],
            "locusID": standardizedAddress['locationId'],
            "ntasAddrID": standardizedAddress?.['ntasAddrId'] ? standardizedAddress?.['ntasAddrId'] : "",
            // "baseAddID": standardizedAddress['']"B",
            "disprawstr": standardizedAddress['formattedAddress'],
            "dispstr": standardizedAddress['addressLine1'],
            "muni": standardizedAddress['city'],
            "houseNumber": standardizedAddress['addressComponents']['premiseNumber'],
            "state": standardizedAddress['stateProvince'],
            "locusLocation": `${standardizedAddress['latLong']['latitude'],standardizedAddress['latLong']['longitude']}`,
            "propertyType": standardizedAddress['addressRecordType'],
            "streetName": standardizedAddress['addressComponents']['streetName'],
            // "dpv": "Y",
            // "addressClassification": "MDU"
          }
          yield put({type:'SAVE_SELECTED_STREET_ADDRESS',data:selectedStreetAddress})
          yield call(fetchUnits,{doLoopCall:undefined})
    
        }else{
          yield put({type:'FETCH_CURRENT_LOCATION_ERROR',data:true})
        }
      }else{
          yield put({type:'FETCH_CURRENT_LOCATION_ERROR',data:true})
        }
    
      }catch(e){
        yield put({type:'FETCH_CURRENT_LOCATION_ERROR',data:true})
      }
    }
  
    function* getUnitsLocus(action){
      try{
        const streetAddress = yield select(selectors.selectedStreetAddress);
        const selectedUnit = action.data ? { unit: action.data } : yield select(selectors.selectedUnit);
        const unit = selectedUnit.unit ? selectedUnit.unit.toUpperCase() : "";
        const config = {
          headers: {
            'apikey': ATOMAPI_KEY
          }
        }
        const useLocusSmb = CheckAEMBoolValue(i18next.t("fios.useLocusSmb",{ns:"fios"}));
        let response = {} 
        if(useLocusSmb){
         response = yield apiClient.post(FETCH_LOCUS_ADDRESS_AND_UNIT_URL, { locusId: streetAddress.locusID, unitTerm: unit, QueryType: "typeahead-units" })
        }else{
         response = yield apiClient.get(FETCH_LOCUS_UNIT + streetAddress.locusID + "&unitterm=" + unit + `&size=10`, config)
        }
        if(response && response?.data){
          yield put({ type: "SET_UNITS_RESPONDED", data: true });
          if(response?.data?.data && response?.data?.data.length){
          let responseData = {total:response?.data?.totalHits,unitDetails:[]}
          const unitDetailsMain = [...response.data.data]
          unitDetailsMain.map(unitData=>{
            responseData.unitDetails.push({
              "baseAddressId": unitData["ntasBaseAddrId"] ?? "" ,
              "addressId": unitData["ntasAddrId"] ?? "",
              "IsUnitNtasIdPresent": unitData["ntasAddrId"] ? 'Y' : 'N',
              "unit": unitData["ntasSublocation"] ?? unitData["sublocation"] ?? "",
              "ntasAddrId":unitData["ntasAddrId"] ?? "",
              unitQuery:{
                unitType :unitData["subLocation1"] ?? "",
                unitValue:unitData["subLocationValue1"] ?? "",
                elevationType:unitData["subLocation2"] ?? "",
                elevationValue :unitData["subLocationValue2"] ?? "",
                structureType :unitData["subLocation3"] ?? "",
                structureValue:unitData["subLocationValue3"] ?? ""
              }
          })
          })
          if(response.data.totalHits > 0){
          yield put({ type: "SAVE_UNIT_LIST", data: responseData.unitDetails })
          if(!action.fromFetchUnits) yield put({ type: "SAVE_TOTAL_UNITS", data: response.data.totalHits });
          }else if(!action.fromFetchUnits && (action.doLoopCall === undefined||action.doLoopCall === null)){
            yield put({ type: "ENABLE_CHECK_AVAILABILITY" });
      
            const previousAddressID = yield select(selectors.previousAddressID);
            if (previousAddressID !== streetAddress.ntasAddrID ||
              (!previousAddressID && !streetAddress.ntasAddrID)) {
              if (ENABLE_OMNI_CART === "true") {
                yield all([
                  call(triggerAddressQualification),
                  // call(triggerOptixAddressQualification)
                ])
              } else {
                yield* triggerAddressQualification()
              }
            }
            //  yield *triggerAddressQualification()
            // yield*triggerOptixAddressQualification()
          }
          }
          else if(!action.fromFetchUnits && (action.doLoopCall === undefined||action.doLoopCall === null)){
            yield put({ type: "ENABLE_CHECK_AVAILABILITY" });
      
            const previousAddressID = yield select(selectors.previousAddressID);
            if (previousAddressID !== streetAddress.ntasAddrID ||
              (!previousAddressID && !streetAddress.ntasAddrID)) {
              if (ENABLE_OMNI_CART === "true") {
                yield all([
                  call(triggerAddressQualification),
                  // call(triggerOptixAddressQualification)
                ])
              } else {
                yield* triggerAddressQualification()
              }
            }
            //  yield *triggerAddressQualification()
            // yield*triggerOptixAddressQualification()
          }
        }
      }catch(err){
        yield put({ type: 'POST_EVENT_LOGGING', data: { type: 'Error', message: err } });
        yield put({ type: "REFRESH_APIGEE_TOKEN" });
      }
    }
    function* validateEmail(params){
      try{
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
         const response = params?.data?.fromsaveCartValidation ? 
      yield apiClient.get(String(VALIDATE_EMAIL_URL_NEW).replace("{sess}",params?.data?.payload?.sessionId).replace("{email}",params?.data?.payload?.email))
    : yield apiClient.post(VALIDATE_EMAIL_URL,params.data);

      if(params?.data?.fromsaveCartValidation){
        if(String(response?.data).toLowerCase().includes('false')){
        localStorage.removeItem("SAVE_CART_EMAIL_VALIDATED")
        yield put({type:'SET_EMAIL_VALIDATION_SAVE_CART',data:false})
      }
      else{
        localStorage.setItem('SAVE_CART_EMAIL_VALIDATED','true')
      yield put({type:'SET_EMAIL_VALIDATION_SAVE_CART',data:true})
      }

      }else{
        if(!!response?.data && response?.data?.Message && String(response?.data?.Message).toUpperCase() === "SUCCESS"){
        yield put({type:'SET_EMAIL_VALIDATION',data:true})
        yield put({type:'SET_ENABLE_EQUIPMENT_SECTION_BDVW',data:true})
        yield put({type:"SET_EMAIL_VALIDATION_FAILURE_COUNT",actionType:"reset"})
        }else{
          yield put({type:'SET_EMAIL_VALIDATION',data:false})
          yield put({type:"SET_EMAIL_VALIDATION_FAILURE_COUNT",actionType:"increment"})
        }
      }
      }catch(e){
        yield put({type:'SET_EMAIL_VALIDATION',data:false})
        yield put({type:"SET_EMAIL_VALIDATION_FAILURE_COUNT",actionType:"increment"})
        console.log(e)
      }finally{
      yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
    }    

  function* saveMatrixFtrs(params){
      try{
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: true });
        yield apiClient.post(SAVE_FTR_MATRIX_URL,params.data);
      }catch(e){
        console.log(e)
      }finally{
        yield put({ type: "TOGGLE_LOADING_SPINNER", data: false });
      }
  }

function* actionWatcher() {
  yield takeLatest('ENROLL_PFB',enrollPFB);
  yield takeLatest('SAVE_AUTOPAY_PAYMENT_METHOD',autoPaySavePaymentMethods);
  yield takeLatest('INITIATE_GLOBAL_SESSION', initiateGlobalSession);
  yield takeLatest('GET_ZIPCODES', fetchZipcodes);
  yield takeLatest('SAVE_SELECTED_ZIPCODE_AND_CHECK_IF_FIOS_QUALIFIED', saveSelectedZipcode);
  yield takeLatest('GET_STREET_ADDRESS', fetchStreetAddress);
  yield takeLatest('GET_UNITS', fetchUnits);
  yield takeLatest('GET_UNITS_BILLING_ADDRESS', fetchUnitsinBillingAddress);
  yield takeLatest('GET_OMNI_DUEDATE_INFO', getOmniDueDateInfo);
  yield takeLatest('GET_UNITS_BY_UNIT_TERM', fetchUnitsByUnitterm);
  yield takeLatest('TRIGGER_ADDRESS_QUALIFICATION', triggerAddressQualification);
  yield takeLatest('TRIGGER_OPTIX_ADDRESS_QUALIFICATION', triggerOptixAddressQualification);
  yield takeLatest('GET_MULTI_ADDR', getMultipleAddressSelection);
  yield takeLatest('POST_MULTIPLEADDR_SEL_WITH_ID', getMultipleAddressSelectionWithId);
  yield takeLatest("REFRESH_APIGEE_TOKEN", refreshApigeeToken);
  /* Customize order api's */
  yield takeLatest('USE_YOUR_OWN_NO', fetchOwnNumber);
  yield takeLatest('GET_YELLOW_PAGE_HEADING', fetchYellowPageHeadings);
  yield takeLatest('GET_INTERNET_DATA', fetchInternetData);
  yield takeLatest('SAVE_CART_INFO', fetchSaveCartInfo);
  yield takeLatest('GET_SA_BDV', getSABDV);
  yield takeLatest('GET_PREFERRED_VOICE', getPreferredvoiceData);
  yield takeLatest('GET_RETRIEVE_ORDER', getRetrieveOrder);
  yield takeLatest('GET_RETRIEVE_CART_INFO', getRetrieveCartInfo)

  /* Review order api's */
  yield takeLatest('GET_CART_INFO', getCartInfo)

  /* Confiramtion page api's */
  yield takeLatest('GET_CONFIRAMTION_ORDER_INFO', getConfirmationOrderInfo)

  /* Optix checkout page api's */
  yield takeLatest('DO_BUSINESS_VALIDATION_OPTIX', omniBusinessValidation)
  yield takeLatest("CREDIT_CHECK_OPTIX", omniCreditCheck);
  yield takeLatest("GET_OMNI_CART_INFO", getOmniCartInfo);
  yield takeLatest("GET_OMNI_OLO_DETAILS", getOmniOloDetails);
  //yield takeLatest('DO_LOA_CONFIRMATION_OPTIX', doOptixLOAConfirmation);

  /* Check out page api's */
  yield takeLatest('SUBMIT_ORDER', submitOrder);
  yield takeLatest('SUBMIT_ORDER_OPTIX', omnisubmitOrder);
  yield takeLatest('AUTOPAY_LOG', autoPayLog);
  yield takeLatest('CHECKOUT', checkout);
  yield takeLatest('DO_BUSINESS_VALIDATION', doBusinessValidation);
  yield takeLatest('CREDIT_CHECK', creditCheck);
  yield takeLatest('DO_INSTALLMENT_VALIDATION', doInstallmentValidation);
  yield takeLatest('UPDATE_COVID_INFO', setCOVID19);
  yield takeLatest('SELECTED_DUE_DATE', selectedDueDate);
  yield takeLatest('UPDATE_SI_INFO', generateSI);
  yield takeLatest('RESERVER_DUE_DATE', reserveDueDate);
  yield takeLatest('RESERVER_DUE_DATE_OPTIX', reserveOmniDueDate);
  yield takeLatest('GET_FAQ_CONTENT', getFaqContent);
  yield takeLatest('REDIRECT_TO_LBO', redirectToLBO);
  yield takeLatest('UPDATE_FAILURE_LBO', updateFailureToLBO);
  yield takeLatest('CHECKOUT_CART_LOAD', checkoutCartLoad);
  yield takeLatest('GET_CHAT_INFO', getChatInfo);
  yield takeLatest('CHECK_AVAIL_API', checkAvailAPICall);
  yield takeLatest('CHECK_AVAIL_API_VCG', checkAvailAPICallVcg);
  yield takeLatest('GET_DUE_DATES', getDueDateInfo);
  yield takeLatest('GET_YAHOO_CATEGORIES', getYahooRelatedCategoriesAndBusinessAddress);
  yield takeLatest('YAHOO_ELIGIBILITY_CHECK', checkYahooEligibility);
  yield takeLatest('CLEAR_YAHOO_FORM', clearEligibilityForm);
  yield takeLatest('CLEAR_YAHOO_ELIGIBILITY_RESPONSE', clearYahooEligibilityResponse);
  yield takeLatest('DO_LOA_CONFIRMATION', doLOAConfirmation);
  yield takeLatest('REDIRECTION_HANDLER', redirectionHandler);

  // UI Event Logging 
  yield takeLatest('POST_EVENT_LOGGING', postEventLogging);
  yield takeLatest('TOGGLE_LOADING_SPINNER', postEventLogging);


  yield takeLatest('FETCH_JOINT_OFFER_INFO', fetchJointOfferInfo);
  yield takeLatest('GET_LQ_PAGE_ADS', getLqPageAds);
  yield takeLatest('ADD_TECHTEAM_USERS', addTechTeamUsers);
  yield takeLatest('SAVE_CONVERSATION_INFO', saveConversationInfo);
  yield takeLatest('SUBMIT_IDE_FORM', SubmitIdeForm);
  yield takeLatest('GET_QUALIFICATION_DETAILS', getQulaificationDetails);
  yield takeLatest('FETCH_CUSTOMIZE_PRODUCTS', fetchCustomizeProducts);
  yield takeLatest('GET_BDV_TNS', GetBDVTNs);
  yield takeLatest('POST_OTP',postOtp);
  yield takeLatest('POST_VALIDATE_OTP',postValidateOtp);
  yield takeLatest('GET_FCC_TEMPLATE',getFCCTemplate);
  yield takeLatest('STORE_FCC_TEMPLATE',storeFCCTemplate);
  yield takeLatest('FETCH_LOCUS_INFO',fetchLocusInfo);
  yield takeLatest("VALIDATE_EMAIL",validateEmail);
  yield takeLatest("SAVE_FTR_MATRIX",saveMatrixFtrs)
}

export default function* rootSaga() {
  yield all([
    actionWatcher(),
    bundleCoversionActionWatcher(),
    switchContractActionWatcher(),
    floatingCartActionWatcher(),
    dynamicCartActionWatcher(),
    lowerFunnelSaga()
  ]);
}
